(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-intl")["default"], require("@ux/util")["default"], require("react-trfq")["default"], require("@ux/icon")["default"], require("react"), require("prop-types"), require("react-dom"), require("@ux/button")["default"], require("@ux/modal")["default"], require("@ux/spinner")["default"], require("@ux/namespace-component")["default"], require("@ux/growl")["default"], require("@ux/component")["default"]);
	else if(typeof define === 'function' && define.amd)
		define("ApplicationHeader", ["react-intl", "@ux/util", "react-trfq", "@ux/icon", "react", "prop-types", "react-dom", "@ux/button", "@ux/modal", "@ux/spinner", "@ux/namespace-component", "@ux/growl", "@ux/component"], factory);
	else if(typeof exports === 'object')
		exports["ApplicationHeader"] = factory(require("react-intl")["default"], require("@ux/util")["default"], require("react-trfq")["default"], require("@ux/icon")["default"], require("react"), require("prop-types"), require("react-dom"), require("@ux/button")["default"], require("@ux/modal")["default"], require("@ux/spinner")["default"], require("@ux/namespace-component")["default"], require("@ux/growl")["default"], require("@ux/component")["default"]);
	else
		root["ApplicationHeader"] = factory(root["ux"]["intl"], root["ux"]["utils"], root["ux"]["trfq"], root["ux"]["Icon"], root["React"], root["PropTypes"], root["ReactDOM"], root["ux"]["Button"], root["ux"]["Modal"], root["ux"]["Spinner"], root["ux"]["NamespaceComponent"], root["ux"]["Growl"], root["ux"]["Component"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_react_intl__, __WEBPACK_EXTERNAL_MODULE__ux_util__, __WEBPACK_EXTERNAL_MODULE_react_trfq__, __WEBPACK_EXTERNAL_MODULE__ux_icon__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE__ux_button__, __WEBPACK_EXTERNAL_MODULE__ux_modal__, __WEBPACK_EXTERNAL_MODULE__ux_spinner__, __WEBPACK_EXTERNAL_MODULE__ux_namespace_component__, __WEBPACK_EXTERNAL_MODULE__ux_growl__, __WEBPACK_EXTERNAL_MODULE__ux_component__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@godaddy/fetch/browser.js":
/*!************************************************!*\
  !*** ./node_modules/@godaddy/fetch/browser.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

var fetch = window.fetch;
/**
 * Latest evergreen browsers define these API's globally.
 * Add the constructors to `fetch` for a consistent cross-platform experience.
 * Technically client-side only code could directly use these API's. Code that
 * is used both client and server-side will benefit from consistency.
 */

fetch.Headers = window.Headers;
fetch.Request = window.Request;
fetch.Response = window.Response;
fetch.AbortController = window.AbortController;
module.exports = fetch;

/***/ }),

/***/ "./node_modules/@ux/order-confirmation/src/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@ux/order-confirmation/src/index.js ***!
  \**********************************************************/
/*! exports provided: default */
/*! ModuleConcatenation bailout: Module uses injected variables (global) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return OrderConfirmation; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utilities */ "./node_modules/@ux/order-confirmation/src/utilities.js");
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./message */ "./node_modules/@ux/order-confirmation/src/message.js");
/* harmony import */ var _ux_growl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ux/growl */ "@ux/growl");
/* harmony import */ var _ux_growl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ux_growl__WEBPACK_IMPORTED_MODULE_4__);






var OrderConfirmation =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inheritsLoose(OrderConfirmation, _Component);

  function OrderConfirmation() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = OrderConfirmation.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var orderId = _utilities__WEBPACK_IMPORTED_MODULE_2__["getOrderIdFromCookie"]() || _utilities__WEBPACK_IMPORTED_MODULE_2__["getOrderIdFromQuerystring"](global) || this.props.orderId;

    if (orderId) {
      var messageData = _utilities__WEBPACK_IMPORTED_MODULE_2__["getMessageDataFromCookie"](orderId);

      if (messageData) {
        _utilities__WEBPACK_IMPORTED_MODULE_2__["deleteOrderIdCookie"](global);
        _utilities__WEBPACK_IMPORTED_MODULE_2__["deleteMessageDataCookie"](global, orderId);

        if (messageData.orderData) {
          _utilities__WEBPACK_IMPORTED_MODULE_2__["captureEcomEvent"](global, messageData.orderData);
        }

        if (messageData.message) {
          _ux_growl__WEBPACK_IMPORTED_MODULE_4___default.a.addGrowlMessage({
            title: messageData.message.title,
            content: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_message__WEBPACK_IMPORTED_MODULE_3__["default"], messageData.message),
            icon: 'success',
            fade: false
          });
        }
      }
    }
  };

  _proto.render = function render() {
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ux_growl__WEBPACK_IMPORTED_MODULE_4___default.a, null);
  };

  return OrderConfirmation;
}(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);


OrderConfirmation.propTypes = {
  orderId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/@ux/order-confirmation/src/message.js":
/*!************************************************************************!*\
  !*** ./node_modules/@ux/order-confirmation/src/message.js + 1 modules ***!
  \************************************************************************/
/*! exports provided: default */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"} (<- Module is not an ECMAScript module) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
var external_root_React_commonjs_react_commonjs2_react_amd_react_ = __webpack_require__("react");
var external_root_React_commonjs_react_commonjs2_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs_react_commonjs2_react_amd_react_);

// EXTERNAL MODULE: external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"}
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_ = __webpack_require__("prop-types");
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_);

// EXTERNAL MODULE: external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"}
var namespace_component_ = __webpack_require__("@ux/namespace-component");

// CONCATENATED MODULE: ./node_modules/@ux/order-confirmation/src/order-display.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var order_display_OrderDisplay =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(OrderDisplay, _NamespaceConsumer);

  function OrderDisplay() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = OrderDisplay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        items = _this$props.items,
        itemsTitle = _this$props.itemsTitle,
        subTotal = _this$props.subTotal,
        subTotalPrefix = _this$props.subTotalPrefix,
        taxesTotal = _this$props.taxesTotal,
        taxesTotalPrefix = _this$props.taxesTotalPrefix;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('font-base', 'order-display')
    }, itemsTitle && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, itemsTitle), items && items.length > 0 && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", null, items.map(function (item) {
      return item.name && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: item.name
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, item.name, " ", external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("br", null), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("small", null, item.term)));
    })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, subTotalPrefix && subTotal && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("small", null, subTotalPrefix, " ", external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, subTotal)), taxesTotalPrefix && taxesTotal && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("small", null, taxesTotalPrefix, " ", external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, taxesTotal))));
  };

  return OrderDisplay;
}(namespace_component_["NamespaceConsumer"]);

order_display_OrderDisplay.propTypes = _objectSpread({}, namespace_component_["NamespaceShape"], {
  items: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  itemsTitle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  subTotal: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  subTotalPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  taxesTotal: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  taxesTotalPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/* harmony default export */ var order_display = (Object(namespace_component_["withNamespace"])(order_display_OrderDisplay));
// CONCATENATED MODULE: ./node_modules/@ux/order-confirmation/src/message.js
function message_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function message_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { message_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { message_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var message_Message =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Message, _NamespaceConsumer);

  function Message() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = Message.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        email = _this$props.email,
        contactOptOut = _this$props.contactOptOut,
        contactPreferences = _this$props.contactPreferences,
        order = _this$props.order,
        orderTotal = _this$props.orderTotal,
        orderTotalPrefix = _this$props.orderTotalPrefix,
        receiptUrl = _this$props.receiptUrl,
        preferenceUrl = _this$props.preferenceUrl,
        printReceipt = _this$props.printReceipt;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, email && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", {
      className: this.namespace('font-base')
    }, email), preferenceUrl && contactPreferences && contactOptOut && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, contactOptOut), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: preferenceUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('link-style', 'contact-preferences')
    }, contactPreferences))), order && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(order_display, order), orderTotal && orderTotalPrefix && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('font-base')
    }, orderTotalPrefix, " ", external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, orderTotal))), receiptUrl && printReceipt && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: "uxicon uxicon-page"
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: receiptUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('link-style', 'receipt')
    }, printReceipt))));
  };

  return Message;
}(namespace_component_["NamespaceConsumer"]);

message_Message.propTypes = message_objectSpread({}, namespace_component_["NamespaceShape"], {
  email: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  contactOptOut: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  contactPreferences: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  order: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  orderTotal: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  orderTotalPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  preferenceUrl: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  printReceipt: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  receiptUrl: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/* harmony default export */ var message = __webpack_exports__["default"] = (Object(namespace_component_["withNamespace"])(message_Message));

/***/ }),

/***/ "./node_modules/@ux/order-confirmation/src/utilities.js":
/*!**************************************************************!*\
  !*** ./node_modules/@ux/order-confirmation/src/utilities.js ***!
  \**************************************************************/
/*! exports provided: getHostDomain, getOrderIdFromQuerystring, getOrderIdFromCookie, getMessageDataFromCookie, deleteMessageDataCookie, deleteOrderIdCookie, captureEcomEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHostDomain", function() { return getHostDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderIdFromQuerystring", function() { return getOrderIdFromQuerystring; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderIdFromCookie", function() { return getOrderIdFromCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMessageDataFromCookie", function() { return getMessageDataFromCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMessageDataCookie", function() { return deleteMessageDataCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOrderIdCookie", function() { return deleteOrderIdCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "captureEcomEvent", function() { return captureEcomEvent; });
/* harmony import */ var _ux_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @ux/util */ "@ux/util");
/* harmony import */ var _ux_util__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ux_util__WEBPACK_IMPORTED_MODULE_0__);

var getHostDomain = function getHostDomain(windowObject) {
  if (windowObject) {
    var hostDomain = windowObject.location.hostname;
    var hostnameParts = hostDomain.split('.');
    var len = hostnameParts.length;

    if (len > 2) {
      return hostnameParts[len - 2] + '.' + hostnameParts[len - 1];
    }

    return hostDomain;
  }

  return null;
};
var getOrderIdFromQuerystring = function getOrderIdFromQuerystring(windowObject) {
  var searchObject = windowObject && windowObject.location && windowObject.location.search ? windowObject.location.search : null; // eslint-disable-line max-len

  var results = new RegExp('[\\?&]orderId=([^&#]*)', 'i').exec(searchObject);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var getOrderIdFromCookie = function getOrderIdFromCookie() {
  // Current utag cookie name orderId
  return _ux_util__WEBPACK_IMPORTED_MODULE_0__["cookie"].getItem('orderId');
};
var getMessageDataFromCookie = function getMessageDataFromCookie(orderNumber) {
  // Current utag cookie name pd + orderNumber
  if (orderNumber && orderNumber.length > 0) {
    try {
      return JSON.parse(_ux_util__WEBPACK_IMPORTED_MODULE_0__["cookie"].getItem("pd".concat(orderNumber)));
    } catch (e) {
      return {};
    }
  }

  return null;
};
var deleteMessageDataCookie = function deleteMessageDataCookie(windowObject, orderNumber) {
  // Current utag cookie name pd + orderNumber
  if (orderNumber && orderNumber.length > 0) {
    // Return null if undefined
    return _ux_util__WEBPACK_IMPORTED_MODULE_0__["cookie"].remove("pd".concat(orderNumber), {
      path: '/',
      domain: getHostDomain(windowObject)
    }) || null; // eslint-disable-line max-len
  }
};
var deleteOrderIdCookie = function deleteOrderIdCookie(windowObject) {
  // Current utag cookie name orderId
  // Return null if undefined
  return _ux_util__WEBPACK_IMPORTED_MODULE_0__["cookie"].remove('orderId', {
    path: '/',
    domain: getHostDomain(windowObject)
  }) || null; // eslint-disable-line max-len
};
var captureEcomEvent = function captureEcomEvent(windowObject, orderData) {
  if (orderData && babelHelpers["typeof"](windowObject._expDataLayer) === 'object') {
    windowObject._expDataLayer.push(orderData);

    return true;
  }

  return false;
};

/***/ }),

/***/ "./node_modules/@ux/webpack-config/node_modules/diagnostics/browser/production.js":
/*!****************************************************************************************!*\
  !*** ./node_modules/@ux/webpack-config/node_modules/diagnostics/browser/production.js ***!
  \****************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var create = __webpack_require__(/*! ../diagnostics */ "./node_modules/@ux/webpack-config/node_modules/diagnostics/diagnostics.js");
/**
 * Create a new diagnostics logger.
 *
 * @param {String} namespace The namespace it should enable.
 * @param {Object} options Additional options.
 * @returns {Function} The logger.
 * @public
 */


var diagnostics = create(function prod(namespace, options) {
  options = options || {};
  options.namespace = namespace;
  options.prod = true;
  options.dev = false;
  if (!(options.force || prod.force)) return prod.nope(options);
  return prod.yep(options);
}); //
// Expose the diagnostics logger.
//

module.exports = diagnostics;

/***/ }),

/***/ "./node_modules/@ux/webpack-config/node_modules/diagnostics/diagnostics.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@ux/webpack-config/node_modules/diagnostics/diagnostics.js ***!
  \*********************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/**
 * Contains all configured adapters for the given environment.
 *
 * @type {Array}
 * @public
 */
var adapters = [];
/**
 * Contains all modifier functions.
 *
 * @typs {Array}
 * @public
 */

var modifiers = [];
/**
 * Our default logger.
 *
 * @public
 */

var logger = function devnull() {};
/**
 * Register a new adapter that will used to find environments.
 *
 * @param {Function} adapter A function that will return the possible env.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */


function use(adapter) {
  if (~adapters.indexOf(adapter)) return false;
  adapters.push(adapter);
  return true;
}
/**
 * Assign a new log method.
 *
 * @param {Function} custom The log method.
 * @public
 */


function set(custom) {
  logger = custom;
}
/**
 * Check if the namespace is allowed by any of our adapters.
 *
 * @param {String} namespace The namespace that needs to be enabled
 * @returns {Boolean|Promise} Indication if the namespace is enabled by our adapters.
 * @public
 */


function enabled(namespace) {
  var async = [];

  for (var i = 0; i < adapters.length; i++) {
    if (adapters[i].async) {
      async.push(adapters[i]);
      continue;
    }

    if (adapters[i](namespace)) return true;
  }

  if (!async.length) return false; //
  // Now that we know that we Async functions, we know we run in an ES6
  // environment and can use all the API's that they offer, in this case
  // we want to return a Promise so that we can `await` in React-Native
  // for an async adapter.
  //

  return new Promise(function pinky(resolve) {
    Promise.all(async.map(function prebind(fn) {
      return fn(namespace);
    })).then(function resolved(values) {
      resolve(values.some(Boolean));
    });
  });
}
/**
 * Add a new message modifier to the debugger.
 *
 * @param {Function} fn Modification function.
 * @returns {Boolean} Indication of a successful add.
 * @public
 */


function modify(fn) {
  if (~modifiers.indexOf(fn)) return false;
  modifiers.push(fn);
  return true;
}
/**
 * Write data to the supplied logger.
 *
 * @param {Object} meta Meta information about the log.
 * @param {Array} args Arguments for console.log.
 * @public
 */


function write() {
  logger.apply(logger, arguments);
}
/**
 * Process the message with the modifiers.
 *
 * @param {Mixed} message The message to be transformed by modifers.
 * @returns {String} Transformed message.
 * @public
 */


function process(message) {
  for (var i = 0; i < modifiers.length; i++) {
    message = modifiers[i].apply(modifiers[i], arguments);
  }

  return message;
}
/**
 * Introduce options to the logger function.
 *
 * @param {Function} fn Calback function.
 * @param {Object} options Properties to introduce on fn.
 * @returns {Function} The passed function
 * @public
 */


function introduce(fn, options) {
  var has = Object.prototype.hasOwnProperty;

  for (var key in options) {
    if (has.call(options, key)) {
      fn[key] = options[key];
    }
  }

  return fn;
}
/**
 * Nope, we're not allowed to write messages.
 *
 * @returns {Boolean} false
 * @public
 */


function nope(options) {
  options.enabled = false;
  options.modify = modify;
  options.set = set;
  options.use = use;
  return introduce(function diagnopes() {
    return false;
  }, options);
}
/**
 * Yep, we're allowed to write debug messages.
 *
 * @param {Object} options The options for the process.
 * @returns {Function} The function that does the logging.
 * @public
 */


function yep(options) {
  /**
   * The function that receives the actual debug information.
   *
   * @returns {Boolean} indication that we're logging.
   * @public
   */
  function diagnostics() {
    var args = Array.prototype.slice.call(arguments, 0);
    write.call(write, options, process(args, options));
    return true;
  }

  options.enabled = true;
  options.modify = modify;
  options.set = set;
  options.use = use;
  return introduce(diagnostics, options);
}
/**
 * Simple helper function to introduce various of helper methods to our given
 * diagnostics function.
 *
 * @param {Function} diagnostics The diagnostics function.
 * @returns {Function} diagnostics
 * @public
 */


module.exports = function create(diagnostics) {
  diagnostics.introduce = introduce;
  diagnostics.enabled = enabled;
  diagnostics.process = process;
  diagnostics.modify = modify;
  diagnostics.write = write;
  diagnostics.nope = nope;
  diagnostics.yep = yep;
  diagnostics.set = set;
  diagnostics.use = use;
  return diagnostics;
};

/***/ }),

/***/ "./node_modules/bowser/src/bowser.js":
/*!*******************************************!*\
  !*** ./node_modules/bowser/src/bowser.js ***!
  \*******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */
!function (root, name, definition) {
  if ( true && module.exports) module.exports = definition();else if (true) __webpack_require__(/*! !webpack amd define */ "./node_modules/webpack/buildin/amd-define.js")(name, definition);else {}
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */
  var t = true;

  function detect(ua) {
    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return match && match.length > 1 && match[1] || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return match && match.length > 1 && match[2] || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
        likeAndroid = /like android/i.test(ua),
        android = !likeAndroid && /android/i.test(ua),
        nexusMobile = /nexus\s*[0-6]\s*/i.test(ua),
        nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua),
        chromeos = /CrOS/.test(ua),
        silk = /silk/i.test(ua),
        sailfish = /sailfish/i.test(ua),
        tizen = /tizen/i.test(ua),
        webos = /(web|hpw)(o|0)s/i.test(ua),
        windowsphone = /windows phone/i.test(ua),
        samsungBrowser = /SamsungBrowser/i.test(ua),
        windows = !windowsphone && /windows/i.test(ua),
        mac = !iosdevice && !silk && /macintosh/i.test(ua),
        linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua),
        edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
        versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
        tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua),
        mobile = !tablet && /[^-]mobi/i.test(ua),
        xbox = /xbox/i.test(ua),
        result;

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera',
        opera: t,
        version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera',
        opera: t,
        version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      };
    } else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android',
        samsungBrowser: t,
        version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser',
        whale: t,
        version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser',
        mzbrowser: t,
        version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast',
        coast: t,
        version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus',
        focus: t,
        version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser',
        yandexbrowser: t,
        version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      };
    } else if (/ucbrowser/i.test(ua)) {
      result = {
        name: 'UC Browser',
        ucbrowser: t,
        version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon',
        maxthon: t,
        version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany',
        epiphany: t,
        version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin',
        puffin: t,
        version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      };
    } else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir',
        sleipnir: t,
        version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon',
        kMeleon: t,
        version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      };
    } else if (windowsphone) {
      result = {
        name: 'Windows Phone',
        osname: 'Windows Phone',
        windowsphone: t
      };

      if (edgeVersion) {
        result.msedge = t;
        result.version = edgeVersion;
      } else {
        result.msie = t;
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
      }
    } else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer',
        msie: t,
        version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      };
    } else if (chromeos) {
      result = {
        name: 'Chrome',
        osname: 'Chrome OS',
        chromeos: t,
        chromeBook: t,
        chrome: t,
        version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      };
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge',
        msedge: t,
        version: edgeVersion
      };
    } else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi',
        vivaldi: t,
        version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    } else if (sailfish) {
      result = {
        name: 'Sailfish',
        osname: 'Sailfish OS',
        sailfish: t,
        version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      };
    } else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey',
        seamonkey: t,
        version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      };
    } else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox',
        firefox: t,
        version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      };

      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t;
        result.osname = 'Firefox OS';
      }
    } else if (silk) {
      result = {
        name: 'Amazon Silk',
        silk: t,
        version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      };
    } else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS',
        phantom: t,
        version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      };
    } else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS',
        slimer: t,
        version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      };
    } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry',
        osname: 'BlackBerry OS',
        blackberry: t,
        version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      };
    } else if (webos) {
      result = {
        name: 'WebOS',
        osname: 'WebOS',
        webos: t,
        version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t);
    } else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada',
        osname: 'Bada',
        bada: t,
        version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    } else if (tizen) {
      result = {
        name: 'Tizen',
        osname: 'Tizen',
        tizen: t,
        version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    } else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla',
        qupzilla: t,
        version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      };
    } else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium',
        chromium: t,
        version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      };
    } else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome',
        chrome: t,
        version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      };
    } else if (android) {
      result = {
        name: 'Android',
        version: versionIdentifier
      };
    } else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari',
        safari: t
      };

      if (versionIdentifier) {
        result.version = versionIdentifier;
      }
    } else if (iosdevice) {
      result = {
        name: iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }; // WTF: version is not part of user agent in web apps

      if (versionIdentifier) {
        result.version = versionIdentifier;
      }
    } else if (/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot',
        googlebot: t,
        version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      };
    } else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
      };
    } // set webkit or gecko flag for browsers based on these engines


    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink";
        result.blink = t;
      } else {
        result.name = result.name || "Webkit";
        result.webkit = t;
      }

      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier;
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko";
      result.gecko = t;
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
    } // set OS flags for platforms that have multiple browsers


    if (!result.windowsphone && (android || result.silk)) {
      result.android = t;
      result.osname = 'Android';
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t;
      result.ios = t;
      result.osname = 'iOS';
    } else if (mac) {
      result.mac = t;
      result.osname = 'macOS';
    } else if (xbox) {
      result.xbox = t;
      result.osname = 'Xbox';
    } else if (windows) {
      result.windows = t;
      result.osname = 'Windows';
    } else if (linux) {
      result.linux = t;
      result.osname = 'Linux';
    }

    function getWindowsVersion(s) {
      switch (s) {
        case 'NT':
          return 'NT';

        case 'XP':
          return 'XP';

        case 'NT 5.0':
          return '2000';

        case 'NT 5.1':
          return 'XP';

        case 'NT 5.2':
          return '2003';

        case 'NT 6.0':
          return 'Vista';

        case 'NT 6.1':
          return '7';

        case 'NT 6.2':
          return '8';

        case 'NT 6.3':
          return '8.1';

        case 'NT 10.0':
          return '10';

        default:
          return undefined;
      }
    } // OS version extraction


    var osVersion = '';

    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }

    if (osVersion) {
      result.osversion = osVersion;
    } // device type extraction


    var osMajorVersion = !result.windows && osVersion.split('.')[0];

    if (tablet || nexusTablet || iosdevice == 'ipad' || android && (osMajorVersion == 3 || osMajorVersion >= 4 && !mobile) || result.silk) {
      result.tablet = t;
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || nexusMobile || result.blackberry || result.webos || result.bada) {
      result.mobile = t;
    } // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs


    if (result.msedge || result.msie && result.version >= 10 || result.yandexbrowser && result.version >= 15 || result.vivaldi && result.version >= 1.0 || result.chrome && result.version >= 20 || result.samsungBrowser && result.version >= 4 || result.whale && compareVersions([result.version, '1.0']) === 1 || result.mzbrowser && compareVersions([result.version, '6.0']) === 1 || result.focus && compareVersions([result.version, '1.0']) === 1 || result.firefox && result.version >= 20.0 || result.safari && result.version >= 6 || result.opera && result.version >= 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] >= 6 || result.blackberry && result.version >= 10.1 || result.chromium && result.version >= 20) {
      result.a = t;
    } else if (result.msie && result.version < 10 || result.chrome && result.version < 20 || result.firefox && result.version < 20.0 || result.safari && result.version < 6 || result.opera && result.version < 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] < 6 || result.chromium && result.version < 20) {
      result.c = t;
    } else result.x = t;

    return result;
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];

      if (typeof browserItem === 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }

    return false;
  };
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */


  function getVersionPrecision(version) {
    return version.split(".").length;
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */


  function map(arr, iterator) {
    var result = [],
        i;

    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }

    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }

    return result;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */


  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version); // 2) "9" -> "9.0" (for precision = 2)

      version = version + new Array(delta + 1).join(".0"); // 3) "9.0" -> ["000000000"", "000000009"]

      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    }); // iterate in reverse order by reversed chunks array

    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      } else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      } else {
        return -1;
      }
    }
  }
  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */


  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser; // make strictMode param optional with ua param usage

    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void 0;
    }

    if (strictMode === void 0) {
      strictMode = false;
    }

    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;

    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          } // browser version and min supported version.


          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }
  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */


  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;
  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */

  bowser._detect = detect;
  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */

  bowser.detect = detect;
  return bowser;
});

/***/ }),

/***/ "./node_modules/eventemitter3/index.js":
/*!*********************************************!*\
  !*** ./node_modules/eventemitter3/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty; //
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//

var prefix = typeof Object.create !== 'function' ? '~' : false;
/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */

function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}
/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */


function EventEmitter() {}
/* Nothing to set */

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */


EventEmitter.prototype._events = undefined;
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */

EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events,
      names = [],
      name;
  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};
/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */


EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event,
      available = this._events && this._events[evt];
  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};
/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */


EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;
  if (!this._events || !this._events[evt]) return false;
  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;

      case 2:
        return listeners.fn.call(listeners.context, a1), true;

      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;

      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;

      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);
          break;

        case 2:
          listeners[i].fn.call(listeners[i].context, a1);
          break;

        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);
          break;

        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }
          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};
/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */


EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this),
      evt = prefix ? prefix + event : event;
  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;else {
    if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
  }
  return this;
};
/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */


EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true),
      evt = prefix ? prefix + event : event;
  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;else {
    if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
  }
  return this;
};
/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */


EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;
  if (!this._events || !this._events[evt]) return this;
  var listeners = this._events[evt],
      events = [];

  if (fn) {
    if (listeners.fn) {
      if (listeners.fn !== fn || once && !listeners.once || context && listeners.context !== context) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }
    }
  } //
  // Reset the array, or remove it completely if we have no more listeners.
  //


  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};
/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */


EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;
  if (event) delete this._events[prefix ? prefix + event : event];else this._events = prefix ? {} : Object.create(null);
  return this;
}; //
// Alias methods names because people roll like that.
//


EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
// This function doesn't apply anymore.
//

EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
}; //
// Expose the prefix.
//


EventEmitter.prefixed = prefix; //
// Expose the module.
//

if (true) {
  module.exports = EventEmitter;
}

/***/ }),

/***/ "./node_modules/golf-to-eid/index.js":
/*!*******************************************!*\
  !*** ./node_modules/golf-to-eid/index.js ***!
  \*******************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringcase = __webpack_require__(/*! stringcase */ "./node_modules/stringcase/lib/index.js"),
    deacro = __webpack_require__(/*! pascal-deacronym */ "./node_modules/pascal-deacronym/index.js"),
    diagnostics = __webpack_require__(/*! diagnostics */ "./node_modules/@ux/webpack-config/node_modules/diagnostics/browser/production.js");

var debug = diagnostics('golf-to-eid');
var isValidKey = /^[A-Za-z0-9\_\:-]+$/;
/**
 * Transforms the specified set of keys from one of four
 * formats:
 *
 *    camelCaseWithNoDelimiters
 *    PascalCaseWithNoDelimiters
 *    camelCase:delimitedBy:Colon
 *    Pascal:Delimited:By:Colon
 *
 * and transforms it into:
 *
 *    snake_case_no_delimiter
 *
 * @param {string|Array} keys Key (or set of keys) to transform
 * @param {Object} opts *Optional* Additional options for returned keys
 * @returns {string|Array} Transformed key (or set ofkeys).
 *
 */

module.exports = function (keys, opts) {
  var isArray = Array.isArray(keys);
  opts = opts || {};
  keys = !isArray ? [keys] : keys;
  var mapped = keys.filter(function (key) {
    return isValidKey.test(key);
  }).map(function (key) {
    //
    // Transformation is three steps:
    // 1. Obtain substring of key after the last ":"
    // 2. "deacryonym" it using
    //   pascal-deacronym. For example:
    //   - SSL becomes Ssl
    //   - GDEmail becomes GdEmail
    //   - VAT becomes Vat
    //   - ECommerce stays ECommerce
    //   - etc. etc. etc.
    // 3. Convert that part from proper PascalCase
    //    to snake_case
    //
    var rekey = key.substring(key.lastIndexOf(':') + 1);
    rekey = deacro(rekey);
    rekey = stringcase.snakecase(rekey);
    rekey = rekey.replace('-', '_'); //
    // Add our prefix and postfix components of
    // the eid.
    //

    if (opts.prefix) {
      rekey = opts.prefix + '.' + rekey;
    }

    if (opts.postfix) {
      rekey = rekey + '.' + opts.postfix;
    }

    debug('%s', key);
    debug('%s', rekey);
    return rekey;
  });
  return isArray ? mapped : mapped[0];
};

/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/***/ }),

/***/ "./node_modules/pascal-deacronym/index.js":
/*!************************************************!*\
  !*** ./node_modules/pascal-deacronym/index.js ***!
  \************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = function deacronym(anyKey) {
  return anyKey.replace(/([A-Z]+)[A-Z]/g, function (match, cap, i, str) {
    var sub;

    if (i + match.length === str.length) {
      sub = match.slice(1);
    } else {
      sub = !i ? cap.slice(1) : match.slice(1, -1);
    }

    return match.replace(sub, sub.toLowerCase());
  });
};

/***/ }),

/***/ "./node_modules/querystringify/index.js":
/*!**********************************************!*\
  !*** ./node_modules/querystringify/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */

function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */


function encode(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */


function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g,
      result = {},
      part;

  while (part = parser.exec(query)) {
    var key = decode(part[1]),
        value = decode(part[2]); //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //

    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */


function querystringify(obj, prefix) {
  prefix = prefix || '';
  var pairs = [],
      value,
      key; //
  // Optionally prefix with a '?' if needed
  //

  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key]; //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //

      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encodeURIComponent(key);
      value = encodeURIComponent(value); //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //

      if (key === null || value === null) continue;
      pairs.push(key + '=' + value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
} //
// Expose the module.
//


exports.stringify = querystringify;
exports.parse = querystring;

/***/ }),

/***/ "./node_modules/rip-out/index.js":
/*!***************************************!*\
  !*** ./node_modules/rip-out/index.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Clone a given object and rip out the keys that we don't want.
 *
 * @param {Object} obj Object that needs to be cloned and cleaned.
 * @param {Arguments} ...args Keys that need to be ignored in cloning.
 * @returns {Object} Fresh object.
 * @public
 */

module.exports = function ripout(obj) {
  var args = Array.prototype.slice.call(arguments, 1);
  var result = {};

  for (var key in obj) {
    if (~args.indexOf(key)) continue;
    result[key] = obj[key];
  }

  return result;
};

/***/ }),

/***/ "./node_modules/stringcase/lib/camelcase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/camelcase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into camel case.
 * @memberof module:stringcase/lib
 * @function camelcase
 * @param {string} str - String to convert.
 * @returns {string} Camel case string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");

var replacing = {
  from: /[\-_\.\s]([a-zA-Z])/g,
  to: function to(a, b) {
    return uppercase(b);
  }
};
/** @lends camelcase */

function camelcase(str) {
  if (camelcase.isCamelcase(str)) {
    return str;
  }

  str = String(str).replace(/^[\-_\.]/, '');

  if (!str) {
    return str;
  }

  if (uppercase.isUppercase(str)) {
    str = lowercase(str);
  }

  return lowercase(str[0]) + str.replace(replacing.from, replacing.to).slice(1);
}
/**
 * Checks whether the string are camelcase.
 * @memberof module:stringcase/lib
 * @function camelcase.isCamelcase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are camelcase.
 */


camelcase.isCamelcase = function (str) {
  return str && /^[a-zA-Z]+$/.test(str) && lowercase(str[0]) === str[0];
};

module.exports = camelcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/capitalcase.js":
/*!****************************************************!*\
  !*** ./node_modules/stringcase/lib/capitalcase.js ***!
  \****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into capital case.
 * First letters will be uppercase.
 * @memberof module:stringcase/lib
 * @function capitalcase
 * @param {string} str - String to convert.
 * @returns {string} Capital case string.
 */


var uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");
/** @lends capitalcase */


function capitalcase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return uppercase(str[0]) + str.slice(1);
}

module.exports = capitalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/constcase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/constcase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into upper snake case.
 * Join punctuation with underscore and convert letters into uppercase.
 * @memberof module:stringcase/lib
 * @function constcase
 * @param {string} str - String to convert.
 * @returns {string} Const cased string.
 */


var uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js"),
    snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends constcase */


function constcase(str) {
  if (constcase.isConstcase(str)) {
    return str;
  }

  return uppercase(snakecase(str));
}
/**
 * Checks whether the string are constcase.
 * @memberof module:stringcase/lib
 * @function constcase.isConstcase
 * @param {string} str - String to check.
 * @returns {boolean} - True if the string are constcase.
 */


constcase.isConstcase = function (str) {
  return str && /^[A-Z_]+$/.test(str);
};

module.exports = constcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/decapitalcase.js":
/*!******************************************************!*\
  !*** ./node_modules/stringcase/lib/decapitalcase.js ***!
  \******************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into de-capitalized case.
 * First letters will be lowercase.
 * @memberof module:stringcase/lib
 * @function decapitalcase
 * @param {string} str - String to convert.
 * @returns {string} Capital case string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js");
/** @lends capitalcase */


function capitalcase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return lowercase(str[0]) + str.slice(1);
}

module.exports = capitalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/index.js":
/*!**********************************************!*\
  !*** ./node_modules/stringcase/lib/index.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string cases between camel case, pascal case, snake case etc...
 * @module stringcase
 */


module.exports = {
  get camelcase() {
    return __webpack_require__(/*! ./camelcase */ "./node_modules/stringcase/lib/camelcase.js");
  },

  get capitalcase() {
    return __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");
  },

  get constcase() {
    return __webpack_require__(/*! ./constcase */ "./node_modules/stringcase/lib/constcase.js");
  },

  get decapitalcase() {
    return __webpack_require__(/*! ./decapitalcase */ "./node_modules/stringcase/lib/decapitalcase.js");
  },

  get lowercase() {
    return __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js");
  },

  get pascalcase() {
    return __webpack_require__(/*! ./pascalcase */ "./node_modules/stringcase/lib/pascalcase.js");
  },

  get pathcase() {
    return __webpack_require__(/*! ./pathcase */ "./node_modules/stringcase/lib/pathcase.js");
  },

  get sentencecase() {
    return __webpack_require__(/*! ./sentencecase */ "./node_modules/stringcase/lib/sentencecase.js");
  },

  get snakecase() {
    return __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
  },

  get spacecase() {
    return __webpack_require__(/*! ./spacecase */ "./node_modules/stringcase/lib/spacecase.js");
  },

  get spinalcase() {
    return __webpack_require__(/*! ./spinalcase */ "./node_modules/stringcase/lib/spinalcase.js");
  },

  get titlecase() {
    return __webpack_require__(/*! ./titlecase */ "./node_modules/stringcase/lib/titlecase.js");
  },

  get trimcase() {
    return __webpack_require__(/*! ./trimcase */ "./node_modules/stringcase/lib/trimcase.js");
  },

  get uppercase() {
    return __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");
  }

};

/***/ }),

/***/ "./node_modules/stringcase/lib/lowercase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/lowercase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into lower case.
 * @memberof module:stringcase/lib
 * @function lowercase
 * @param {string} str - String to convert.
 * @returns {string} Lowercase case string.
 */

/** @lends lowercase */

function lowercase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return str.toLowerCase();
}
/**
 * Checks whether the string are lowercase.
 * @memberof module:stringcase/lib
 * @function lowercase.isLowercase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are lowercase.
 */


lowercase.isLowercase = function (str) {
  return str && !/[A-Z]+/.test(str);
};

module.exports = lowercase;

/***/ }),

/***/ "./node_modules/stringcase/lib/pascalcase.js":
/*!***************************************************!*\
  !*** ./node_modules/stringcase/lib/pascalcase.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into pascal case.
 * @memberof module:stringcase/lib
 * @function pascalcase
 * @param {string} str - String to convert.
 * @returns {string} Pascal case string.
 */


var camelcase = __webpack_require__(/*! ./camelcase */ "./node_modules/stringcase/lib/camelcase.js"),
    capitalcase = __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");
/** @lends pascalcase */


function pascalcase(str) {
  return capitalcase(camelcase(str));
}

module.exports = pascalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/pathcase.js":
/*!*************************************************!*\
  !*** ./node_modules/stringcase/lib/pathcase.js ***!
  \*************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into path case.
 * Join punctuation with slash.
 * @memberof module:stringcase/lib
 * @function pathcase
 * @param {string} str - String to convert.
 * @returns {string} Path cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends pathcase */


function pathcase(str) {
  return snakecase(str).replace(/_/g, '/');
}

module.exports = pathcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/sentencecase.js":
/*!*****************************************************!*\
  !*** ./node_modules/stringcase/lib/sentencecase.js ***!
  \*****************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into sentence case.
 * First letter capped and each punctuations are joined with space.
 * @memberof module:stringcase/lib
 * @function sentencecase
 * @param {string} str - String to convert.
 * @returns {string} Sentence cased string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    trimcase = __webpack_require__(/*! ./trimcase */ "./node_modules/stringcase/lib/trimcase.js"),
    snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js"),
    capitalcase = __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");

var JOINER = ' ';
/** @lends sentencecase*/

function sentencecase(str) {
  str = String(str).replace(/^[\-_\.\s]/g, JOINER);

  if (!str) {
    return str;
  }

  return capitalcase(snakecase(trimcase(str)).replace(/_/g, JOINER));
}

module.exports = sentencecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/snakecase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/snakecase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into snake case.
 * Join punctuation with underscore.
 * @memberof module:stringcase/lib
 * @function snakecase
 * @param {string} str - String to convert.
 * @returns {string} Snake cased string.
 */


var lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    uppercase = __webpack_require__(/*! ./uppercase */ "./node_modules/stringcase/lib/uppercase.js");

var JOINER = '_';
var replacing = {
  from: /([A-Z])/g,
  to: function to($1) {
    return JOINER + lowercase($1);
  }
};
/** @lends snakecase */

function snakecase(str) {
  if (snakecase.isSnakecase(str)) {
    return str;
  }

  str = String(str).replace(/[\-\.\s]/g, JOINER);

  if (!str) {
    return str;
  }

  if (uppercase.isUppercase(str)) {
    str = lowercase(str);
  }

  return lowercase(str[0]) + str.slice(1).replace(replacing.from, replacing.to).replace(/_+/g, '_');
}
/**
 * Checks whether the string are snakecase.
 * @memberof module:stringcase/lib
 * @function snakecase.isSnakecase
 * @param {string} str - String to check.
 * @returns {boolean} - True if the string are snakecase.
 */


snakecase.isSnakecase = function (str) {
  return str && /^[a-z_]+$/.test(str);
};

module.exports = snakecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/spacecase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/spacecase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into path case.
 * Join punctuation with space.
 * @memberof module:stringcase/lib
 * @function spacecase
 * @param {string} str - String to convert.
 * @returns {string} Path cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends spacecase */


function spacecase(str) {
  return snakecase(str).replace(/_/g, ' ');
}

module.exports = spacecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/spinalcase.js":
/*!***************************************************!*\
  !*** ./node_modules/stringcase/lib/spinalcase.js ***!
  \***************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into spinal case.
 * Join punctuation with hyphen.
 * @memberof module:stringcase/lib
 * @function spinalcase
 * @param {string} str - String to convert.
 * @returns {string} Spinal cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js");
/** @lends spinalcase */


function spinalcase(str) {
  return snakecase(str).replace(/_/g, '-');
}

module.exports = spinalcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/titlecase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/titlecase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into sentence case.
 * First letter capped and each punctuations is capitalcase and joined with space.
 * @memberof module:stringcase/lib
 * @function titlecase
 * @param {string} str - String to convert.
 * @returns {string} Title cased string.
 */


var snakecase = __webpack_require__(/*! ./snakecase */ "./node_modules/stringcase/lib/snakecase.js"),
    lowercase = __webpack_require__(/*! ./lowercase */ "./node_modules/stringcase/lib/lowercase.js"),
    trimcase = __webpack_require__(/*! ./trimcase */ "./node_modules/stringcase/lib/trimcase.js"),
    capitalcase = __webpack_require__(/*! ./capitalcase */ "./node_modules/stringcase/lib/capitalcase.js");

var LOWERCASE_WORDS = 'a,the,and,or,not,but,for,of'.split(',');
/** @lends titlecase*/

function titlecase(str) {
  return snakecase(str).split(/_/g).map(trimcase).map(function (word) {
    var lower = !!~LOWERCASE_WORDS.indexOf(word);

    if (lower) {
      return lowercase(word);
    } else {
      return capitalcase(word);
    }
  }).join(' ');
}

module.exports = titlecase;

/***/ }),

/***/ "./node_modules/stringcase/lib/trimcase.js":
/*!*************************************************!*\
  !*** ./node_modules/stringcase/lib/trimcase.js ***!
  \*************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into trimmed string.
 * @memberof module:stringcase/lib
 * @function trimcase
 * @param {string} str - String to convert.
 * @returns {string} Trimmed case string.
 */

/** @lends trimcase */

function trimcase(str) {
  return String(str).trim();
}

module.exports = trimcase;

/***/ }),

/***/ "./node_modules/stringcase/lib/uppercase.js":
/*!**************************************************!*\
  !*** ./node_modules/stringcase/lib/uppercase.js ***!
  \**************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Convert string into upper case.
 * @memberof module:stringcase/lib
 * @function uppercase
 * @param {string} str - String to convert.
 * @returns {string} Upper case string.
 */

/** @lends uppercase */

function uppercase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return str.toUpperCase();
}
/**
 * Checks whether the string are uppercase.
 * @memberof module:stringcase/lib
 * @function uppercase.isUppercase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are uppercase.
 */


uppercase.isUppercase = function (str) {
  return str && !/[a-z]+/.test(str);
};

module.exports = uppercase;

/***/ }),

/***/ "./node_modules/webpack/buildin/amd-define.js":
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

var g; // This works in non-strict mode

g = function () {
  return this;
}();

try {
  // This works if eval is allowed (see CSP)
  g = g || new Function("return this")();
} catch (e) {
  // This works if the window reference is available
  if ((typeof window === "undefined" ? "undefined" : babelHelpers["typeof"](window)) === "object") g = window;
} // g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}


module.exports = g;

/***/ }),

/***/ "./src/index.js":
/*!***********************************!*\
  !*** ./src/index.js + 60 modules ***!
  \***********************************/
/*! exports provided: Header, Footer */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@godaddy/fetch/browser.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/@ux/order-confirmation/src/index.js (<- Module uses injected variables (global)) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/bowser/src/bowser.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/eventemitter3/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/golf-to-eid/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/object-assign/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/querystringify/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/rip-out/index.js (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Button"],"commonjs":["@ux/button","default"],"commonjs2":["@ux/button","default"],"amd":"@ux/button"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Component"],"commonjs":["@ux/component","default"],"commonjs2":["@ux/component","default"],"amd":"@ux/component"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Icon"],"commonjs":["@ux/icon","default"],"commonjs2":["@ux/icon","default"],"amd":"@ux/icon"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Modal"],"commonjs":["@ux/modal","default"],"commonjs2":["@ux/modal","default"],"amd":"@ux/modal"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","Spinner"],"commonjs":["@ux/spinner","default"],"commonjs2":["@ux/spinner","default"],"amd":"@ux/spinner"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"} (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"} (<- Module is not an ECMAScript module) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var url_namespaceObject = {};
__webpack_require__.r(url_namespaceObject);
__webpack_require__.d(url_namespaceObject, "updateQuery", function() { return updateQuery; });
__webpack_require__.d(url_namespaceObject, "updateCurrentHref", function() { return updateCurrentHref; });

// EXTERNAL MODULE: external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"}
var namespace_component_ = __webpack_require__("@ux/namespace-component");

// EXTERNAL MODULE: external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"}
var external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_ = __webpack_require__("react-intl");

// EXTERNAL MODULE: ./node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("./node_modules/eventemitter3/index.js");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: ./node_modules/@ux/header-util/events.js
 //
// Singleton EventEmitter instance to track manifest events.
//

var events = new eventemitter3_default.a();
/* harmony default export */ var header_util_events = (events);
// CONCATENATED MODULE: ./node_modules/@ux/header-util/instance.js
 //
// Keep track of mounted manifest instances.
//

var instances = {};
/**
 * Setup listener for mount of React manifest instance.
 *
 * @param {String} type Expected mount of instance.
 * @returns {Function} Completion callback.
 * @api public
 */

function getInstance() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'header';
  var event = "mount:".concat(type); //
  // Listen early to intercept the event before the helper is called and store the
  // instance for later calls to the helper.
  //

  header_util_events.once(event, function (instance) {
    instances[type] = instance;
  });
  return function getMountedInstance(done) {
    if (type in instances) {
      return done(null, instances[type]);
    }

    header_util_events.once(event, function (instance) {
      return done(null, instance);
    });
  };
}
// EXTERNAL MODULE: external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"}
var util_ = __webpack_require__("@ux/util");

// CONCATENATED MODULE: ./node_modules/@ux/header-util/data.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var qs = util_["URL"].qs;
/**
 * Expose 'smart' data object.
 *
 * @class Data
 * @api public
 */

var Data =
/*#__PURE__*/
function () {
  function Data() {
    this.set.apply(this, arguments);
  }
  /**
   * Set property and value on the object. Unpack property if passed as object.
   *
   * @param {String} property Identifier.
   * @param {Mixed} value property values.
   * @returns {Data} Fluent interface
   * @api public
   */


  var _proto = Data.prototype;

  _proto.set = function set(property, value) {
    var _this = this;

    if (!property) {
      return this;
    }

    if (property === 'urlArgs') {
      return this.setUrlArgs(value);
    }

    if (babelHelpers["typeof"](property) === 'object') {
      return Object.keys(property).forEach(function (prop) {
        _this.set(prop, property[prop]);
      });
    }

    this[property] = value;
    return this;
  }
  /**
   * Performs a simple shallow merge of the value into property setting any default value.
   *
   * @param {String} property Identifier.
   * @param {Object} value property values.
   * @returns {Data} Fluent interface
   * @api public
   */
  ;

  _proto.merge = function merge(property, value) {
    if (!property || !value || babelHelpers["typeof"](value) !== 'object') {
      return this;
    }

    this[property] = _objectSpread({}, this[property] || {}, {}, value);
    return this;
  }
  /**
   * Safely sets `urlArgs` as an Object, converting any partial or complete
   * querystrings into objects as necessary.
   *
   * @param {Object|String} value Attempted value for urlArgs.
   * @returns {Data} Fluent interface
   * @api private
   */
  ;

  _proto.setUrlArgs = function setUrlArgs(value) {
    var type = babelHelpers["typeof"](value);

    if (type === 'string') {
      this.urlArgs = qs.parse(value);
      return this;
    }

    if (!value || type !== 'object') {
      this.urlArgs = {};
      return this;
    }

    this.urlArgs = value;
    return this;
  }
  /**
   * Returns sealed props object with keys and values, prevents React warnings.
   *
   * @returns {Object} Values.
   * @api public
   */
  ;

  babelHelpers.createClass(Data, [{
    key: "props",
    get: function get() {
      var _this2 = this;

      return Object.seal(Object.getOwnPropertyNames(this).reduce(function (clone, key) {
        clone[key] = _this2[key];
        return clone;
      }, {}));
    }
  }]);
  return Data;
}();


// EXTERNAL MODULE: ./node_modules/@godaddy/fetch/browser.js
var fetch_browser = __webpack_require__("./node_modules/@godaddy/fetch/browser.js");
var browser_default = /*#__PURE__*/__webpack_require__.n(fetch_browser);

// EXTERNAL MODULE: ./node_modules/querystringify/index.js
var querystringify = __webpack_require__("./node_modules/querystringify/index.js");
var querystringify_default = /*#__PURE__*/__webpack_require__.n(querystringify);

// CONCATENATED MODULE: ./node_modules/@ux/header-util/shopper-data.js



/**
 * Loader for shopper data from the GUI API
 *
 * Data load is triggered by the header, but this class allows for other components to subscribe to the response
 * @class ShopperDataLoader
 * @public
 */

var shopper_data_ShopperDataLoader =
/*#__PURE__*/
function () {
  function ShopperDataLoader() {
    this._requestTriggered = false;
    this._data = null;
  }
  /**
   * Request the shopper data from GUI and notify subscribers.
   *
   * @memberof ShopperDataLoader
   * @private
   */


  var _proto = ShopperDataLoader.prototype;

  _proto._requestShopperData = function _requestShopperData() {
    var _this = this;

    if (this._requestTriggered) return;
    this._requestTriggered = true;
    var queryParams = {
      plId: this._privateLabelId,
      shopperId: this._shopperId,
      sid: this._shopperId
    };
    var url = this._url + querystringify_default.a.stringify(queryParams, true);
    browser_default()(url, {
      method: 'GET',
      credentials: 'include'
    }).then(function (response) {
      if (response.status >= 400) {
        var error = new Error(response.statusText);
        error.status = response.status;
        return Promise.reject(error);
      }

      return response.json();
    }).then(function (data) {
      _this._data = data;
      header_util_events.emit('shopperData', null, data);
    })["catch"](function (error) {
      header_util_events.emit('shopperData', error);
    });
  }
  /**
   * Configure this loader
   *
   * @param {Object} opts Options for the call
   *    @param {String} opts.url URL to the GUI service
   *    @param {Number|String} [opts.privateLabelId=1] Private Label id (e.g. 1 for GoDaddy, 2 for BlueRazor, etc.)
   *    @param {Number|String} opts.shopperId Shopper id number
   * @returns {Boolean} true if configuration succeeded, false if there was missing data
   *
   * @memberof ShopperDataLoader
   * @private
   */
  ;

  _proto._configure = function _configure(opts) {
    if (!opts.url) {
      return false;
    }

    this._url = opts.url;
    this._shopperId = opts.shopperId;
    this._privateLabelId = opts.privateLabelId || 1;
    return true;
  }
  /**
   * Callback for shopper data subscriptions
   * @callback ShopperDataCallback
   * @param {Object|String} err Error, if any
   * @param {Object} data Shopper data object
   */

  /**
   * Subscribe for shopper data when it becomes available.
   *
   * Guaranteed to be async -- if data is immediately available, callback is run on next tick.
   * @param {Object} [opts] Optional options for the call -- typically only passed in from UX Platform headers
   * @param {String}        opts.url URL to the GUI service
   * @param {Number|String} opts.privateLabelId Private Label id (e.g. 1 for GoDaddy, 2 for BlueRazor, etc.)
   * @param {Number|String} opts.shopperId Shopper id number
   * @param {ShopperDataCallback} cb Callback
   *
   * @memberof ShopperDataLoader
   * @public
   */
  ;

  _proto.shopperData = function shopperData(opts, cb) {
    if (typeof opts === 'function') {
      cb = opts;
      opts = null;
    }

    if (this._data) {
      setTimeout(cb.bind(undefined, null, this._data), 0); // eslint-disable-line no-undefined

      return;
    }

    header_util_events.once('shopperData', cb);

    if (opts) {
      if (!this._configure(opts)) {
        setTimeout(cb.bind(undefined, {
          // eslint-disable-line no-undefined
          error: 'opts object is incomplete'
        }), 0);
        return;
      }

      this._requestShopperData();
    } else if (this._url && this._shopperId && this._privateLabelId) {
      // Loader is already configured, so kick off the request now
      this._requestShopperData();
    }
  }
  /**
   * Configure this loader only, but do not request data unless something else on the page needs it
   * This is only used by the UXP headers when the header itself doesn't need GUI data.
   * If the header does need data, it should call {@link shopperData}(opts, cb) instead.
   *
   * @param {Object} opts Options for the call
   *    @param {String} opts.url URL to the GUI service
   *    @param {Number|String} [opts.privateLabelId=1] Private Label id (e.g. 1 for GoDaddy, 2 for BlueRazor, etc.)
   *    @param {Number|String} opts.shopperId Shopper id number
   * @returns {Boolean} true if configuration succeeded, false if there was missing data
   *
   * @memberof ShopperDataLoader
   * @public
   */
  ;

  _proto.configureOnly = function configureOnly(opts) {
    if (!this._configure(opts)) {
      return false;
    } // If there are queued requests, kick off the GUI call


    if (header_util_events.listeners('shopperData', true)) {
      this._requestShopperData();
    }

    return true;
  };

  return ShopperDataLoader;
}(); // Export a singleton ShopperDataLoader object


var shopperDataLoader = new shopper_data_ShopperDataLoader();

// CONCATENATED MODULE: ./node_modules/@ux/header-util/state.js




var state_target = typeof document !== 'undefined' ? window : {};
var state_data = new Data();
var eldorado = {};
state_target.ux = state_target.ux || {};
state_target.ux.eldorado = state_target.ux.eldorado || eldorado; //
// Allow external JS to listen to events emitted from the manifests and prepare
// data object.
//

state_target.ux.eldorado.events = eldorado.events || header_util_events;
state_target.ux.eldorado.data = eldorado.data || state_data; //
// Setup listeners to expose mounted instances.
//

state_target.ux.eldorado.header = getInstance('header');
state_target.ux.eldorado.footer = getInstance('footer'); // To keep backwards compatibility with Eldorado

if (typeof state_target.jQuery === 'function') {
  state_target.ux.jQuery = state_target.ux.eldorado.jQuery = state_target.jQuery;
}
/**
 * If jQuery is present on the page, run the specified callback when jQuery is ready.
 * Otherwise, run the callback synchronously
 *
 * @param {Function} cb The callback to run
 * @api private
 */


state_target.ux._runOnJQueryReady = function runOnJQueryReady(cb) {
  if (state_target.ux.jQuery) {
    state_target.ux.jQuery(document).ready(cb);
  } else {
    cb(); // eslint-disable-line callback-return
  }
}; // When the header mounts, make all subsequent calls to ux.eldorado.ready synchronous


state_target.ux.eldorado.events.once('mount:header', function uxEldoradoReadyOnMountHeader() {
  state_target.ux.eldorado.ready = function uxEldoradoReadyImmediate(cb) {
    state_target.ux._runOnJQueryReady(cb);
  };
});
/**
 * Register the specified callback to run when UXCore1 is loaded.
 *
 * Note: If UXCore1 is never loaded (e.g. if the page is using UXCore2), the callback will never run.
 *
 * @param {Function} cb The callback to run
 * @api public
 */

state_target.ux.ready = function uxReady(cb) {
  state_target.ux.fns = state_target.ux.fns || [];
  state_target.ux.fns.push(cb);
};
/**
 * Register the specified callback to run when the header is mounted.
 *
 * @param {Function} cb The callback to run
 * @api public
 */


state_target.ux.eldorado.ready = function uxEldoradoReady(cb) {
  state_target.ux.eldorado.events.once('mount:header', function () {
    state_target.ux._runOnJQueryReady(cb);
  });
}; // Transfer over all the callbacks that queued up before this script loaded


if (Array.isArray(state_target.ux.eldorado.readyFns)) {
  state_target.ux.eldorado.readyFns.forEach(function (fn) {
    state_target.ux.eldorado.ready(fn);
  });
  state_target.ux.eldorado.readyFns = null;
} // Set up shopperData API and handle pre-queued callbacks


if (!state_target.ux.eldorado._shopperDataLoader) {
  // Create a new ShopperDataLoader
  state_target.ux.eldorado._shopperDataLoader = shopperDataLoader; // Attach it to the existing `shopperData` function

  state_target.ux.eldorado.shopperData = shopperDataLoader.shopperData.bind(shopperDataLoader); // Run all pre-queued callbacks in order

  if (state_target.ux.eldorado._shopperDataFns) {
    state_target.ux.eldorado._shopperDataFns.forEach(function (fn) {
      state_target.ux.eldorado.shopperData(fn);
    });
  }
}


// CONCATENATED MODULE: ./node_modules/@ux/header-util/helpers.js
/**
 * Scope method to data.
 *
 * @param {Object} data Dataset.
 * @returns {Function} Getter.
 * @api public
 */
function helpers_get() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /**
   * Get property from data, fallback to lowercased or uppercased.
   *
   * @param {String} property Name.
   * @param {Boolean} fallback Return property name if no value was found.
   * @returns {Mixed} property value.
   * @api private
   */
  return function propGet(property, fallback) {
    var result = data[property] || data[property.toLowerCase()] || data[property.toUpperCase()];
    return !fallback ? result : result || property;
  };
}
// CONCATENATED MODULE: ./node_modules/@ux/header-util/cookies.js


var cookies_browser = typeof document !== 'undefined';
/**
 * Collection of cookies, read out cookie info_idp on construction.
 *
 * @Constructor Cookies.
 * @param {Object} options Optional configuration.
 * @api public
 */

var cookies_Cookies =
/*#__PURE__*/
function () {
  function Cookies() {
    this.idp = {};
    this.getIdpProperty = helpers_get(this.idp);
    this.updateRealm('idp');
    this.jomax = {};
    this.getJomaxProperty = helpers_get(this.jomax);
    this.updateRealm('jomax');
  }
  /**
   * Get the customers shopper id from the cookie.
   *
   * @returns {String} Shopper id.
   * @api public
   */


  var _proto = Cookies.prototype;

  /**
   * Update the cached cookies values.
   * (For backwards compatibility since this was previously marked as public)
   *
   * @returns {Cookies} fluent interface.
   * @api public
   */
  _proto.updateIdp = function updateIdp() {
    return this.updateRealm('idp');
  }
  /**
   * Update the cached cookies values.
   *
   * @param {String} [realm='idp'] The authentication realm to update
   * @returns {Cookies} fluent interface.
   * @api private
   */
  ;

  _proto.updateRealm = function updateRealm() {
    var realm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'idp';

    if (!cookies_browser) {
      return this;
    }

    var titleCaseRealm = realm[0].toUpperCase() + realm.substr(1);
    this[realm] = util_["json"].parse(util_["cookie"].get("info_".concat(realm))) || {};
    this["get".concat(titleCaseRealm, "Property")] = helpers_get(this[realm]);
    return this;
  }
  /**
   * Get the requested properties from the cookie for the specified realm.
   *
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @api public
   */
  ;

  _proto.getIdpProperties = function getIdpProperties(properties, replace) {
    return Cookies.getRealmPropertiesFromObject(this.idp, properties, replace);
  }
  /**
   * Get the requested properties from the specified object
   *
   * @param {Object} obj The object to extract properties from
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @package
   */
  ;

  Cookies.getRealmPropertiesFromObject = function getRealmPropertiesFromObject(obj, properties) {
    var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var getProp = helpers_get(replace);

    if (!Array.isArray(properties)) {
      properties = [properties];
    }

    return properties.reduce(function (result, property) {
      if (Array.isArray(property)) {
        result[getProp(property[property.length - 1], true)] = property.reduce(function (o, i) {
          return o && o[i];
        }, obj);
        var desiredProp = property[property.length - 1];

        if (obj[desiredProp] && !result[desiredProp]) {
          result[desiredProp] = obj[desiredProp];
        }

        return result;
      }

      result[getProp(property, true)] = obj[property];
      return result;
    }, {});
  }
  /**
   * Get the requested properties from the jomax cookie.
   *
   * @param {Array} properties properties to extract.
   * @param {Object} replace Optional object with strings to replace.
   * @returns {Object} Collection of extracted properties.
   * @api public
   */
  ;

  _proto.getJomaxProperties = function getJomaxProperties(properties, replace) {
    return Cookies.getRealmPropertiesFromObject(this.jomax, properties, replace);
  };

  babelHelpers.createClass(Cookies, [{
    key: "shopperId",
    get: function get() {
      return this.getIdpProperty('info_shopperId');
    }
  }]);
  return Cookies;
}();


// CONCATENATED MODULE: ./node_modules/@ux/header-util/user.js
function user_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function user_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { user_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { user_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var user_status = ['partial', 'full', 'manager'];
var inverseNameOrderMarkets = ['ja-JP', 'ko-KR', 'vi-VN', 'zh-SG', 'zh-TW', 'zh-HK'];
/**
 * User details.
 *
 * @Constructor User.
 * @param {Object} options Optional configuration.
 * @api public
 */

var user_User =
/*#__PURE__*/
function () {
  function User() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = options;
    this.market = options.market || 'en-US';
    this.cookies = new cookies_Cookies();
    this.set(options.data);
  }
  /**
   * Update user data and getter.
   *
   * @param {Object} data Dataset.
   * @api private
   */


  var _proto = User.prototype;

  _proto.set = function set(data) {
    this.data = data || {};
    this.get = helpers_get(data);
  }
  /**
   * Gets all store data as an object
   *
   * @returns {Object} User data
   * @api private
   */
  ;

  _proto.getAll = function getAll() {
    return this.data;
  }
  /**
   * Makes a request against a url which expects shopper information.
   *
   * @param {String} url Request target.
   * @param {Function} done Continuation to respond to when complete
   * @api private
   */
  ;

  _proto.shopperRequest = function shopperRequest(url, done) {
    shopperDataLoader.shopperData({
      url: url,
      privateLabelId: this.options.privateLabelId,
      shopperId: this.shopperId
    }, done);
  }
  /**
   * Fetch all user details, unpack and store locally.
   * TODO: JSONP should not be enforced for details but CORS headers are missing.
   *
   * @param {Object} url Request targets.
   * @param {Function} done Completion callback
   * @api public
   */
  ;

  _proto.fetch = function fetch(url, done) {
    this.fetchInternal(url, done);
  }
  /**
   * Fetch all user details, unpack and store locally.
   * TODO: JSONP should not be enforced for details but CORS headers are missing.
   *
   * @param {Object} url Request targets.
   * @param {Function} done Completion callback
   * @param {Function} [parseAdditionalData] Optional function that parses out additional data
   * @api private
   */
  ;

  _proto.fetchInternal = function fetchInternal(url, done) {
    var _this = this;

    var parseAdditionalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var additionalData = {};
    this.shopperRequest(url.gui, function (error, details) {
      if (error) {
        return done(error);
      }

      if (parseAdditionalData) {
        additionalData = parseAdditionalData(details);
      }

      details = user_objectSpread({}, additionalData, {}, details);

      _this.set(details);

      done(null, details);
    });
  }
  /**
   * Return name to be displayed as customer or employee name.
   *
   * @param {Boolean} short Prefer short name.
   * @returns {String} Display name.
   * @api public
   */
  // eslint-disable-next-line complexity
  ;

  _proto.displayName = function displayName(_short) {
    // Content has already been generated, and we don't need to do so again.
    var name = this.get('displayName') || this.get('disp');

    if (name) {
      return name;
    }

    var firstName = this.get('firstName');
    var lastName = this.get('lastName');
    var fallback = this.get('name') || this.get('userName') || this.get('loginName') || this.shopperId || '';

    if (_short) {
      var value = ~inverseNameOrderMarkets.indexOf(this.market) ? lastName : firstName;
      return value || fallback;
    }

    if (firstName) {
      // Some Asian countries are inverse the name order.
      return ~inverseNameOrderMarkets.indexOf(this.market) ? [lastName, firstName].filter(Boolean).join(' ').trim() : [firstName, lastName].filter(Boolean).join(' ').trim();
    } // Fallback to name, username or loginName


    return fallback;
  }
  /**
   * Returns purposefully short name to be used in Account Delegation.
   *
   * @returns {String} Name to use for Account Delegation (see @ux/account-delegation).
   * @api public
   */
  ;

  _proto.delegateName = function delegateName() {
    return this.get('displayName') || this.get('firstName');
  }
  /**
   * Return Shopper ID of customer.
   *
   * @returns {String} Shopper ID
   * @api public
   */
  ;

  babelHelpers.createClass(User, [{
    key: "shopperId",
    get: function get() {
      return this.get('shopperId') || this.cookies.shopperId;
    }
    /**
     * Return logged in status of user.
     *
     * @returns {Boolean} Logged in or not
     * @api public
     */

  }, {
    key: "loggedIn",
    get: function get() {
      return !!~user_status.indexOf(this.get('status')) || !!this.get('loginName');
    }
    /**
     * Return VIP details if available.
     *
     * @returns {Object} VIP data.
     * @api public
     */

  }, {
    key: "vip",
    get: function get() {
      return this.get('vip');
    }
    /**
     * Return number of items in cart.
     *
     * @returns {Number} Number of items in cart.
     * @api public
     */

  }, {
    key: "cart",
    get: function get() {
      return this.get('cartTotal');
    }
  }]);
  return User;
}();


// CONCATENATED MODULE: ./node_modules/@ux/header-util/customer.js


var customer_status = ['partial', 'full', 'manager'];
/**
 * Customer details
 *
 * @Constructor Customer
 * @param {Object} options Optional configuration.
 * @api public
 */

var customer_Customer =
/*#__PURE__*/
function (_User) {
  babelHelpers.inheritsLoose(Customer, _User);

  function Customer() {
    return _User.apply(this, arguments) || this;
  }

  var _proto = Customer.prototype;

  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  _proto.updateFromCookie = function updateFromCookie() {
    this.cookies.updateIdp();
    var auth = this.cookies.getIdpProperty('auth');
    this.set(this.getIdpProperties(this.cookies.getIdpProperties.bind(this.cookies), auth));
  }
  /**
   * Get properties from idp information
   *
   * @param {Function} getIdpPropertiesFn Function to call to get properties from idp
   * @param {String} auth Type of authentication (e.g. e2s, s2s, e2s2s, none of the above)
   * @returns {Object} Extracted properties
   * @package
   */
  ;

  _proto.getIdpProperties = function getIdpProperties(getIdpPropertiesFn, auth) {
    return getIdpPropertiesFn(['disp', 'firstname', 'lastname', 'info_shopperId', 'plid'].map(function (property) {
      return [auth, property];
    }).concat('jti'), {
      info_shopperId: 'shopperId',
      disp: 'displayName'
    });
  }
  /**
   * Fetch all user details, unpack and store locally.
   * TODO: JSONP should not be enforced for details but CORS headers are missing.
   *
   * @param {Object} url Request targets.
   * @param {Function} done Completion callback
   * @api public
   */
  ;

  _proto.fetch = function fetch(url, done) {
    var _this = this;

    this.cookies.updateIdp();
    this.fetchInternal(url, done, function (data) {
      var idp;

      try {
        idp = JSON.parse(data.info);
      } catch (e) {
        return {};
      }

      return _this.getIdpProperties(cookies_Cookies.getRealmPropertiesFromObject.bind(_this, idp), idp.auth);
    });
  }
  /**
   * Return loggedIn status of Customer.
   *
   * @returns {Boolean} LoggedIn.
   * @api public
   */
  ;

  babelHelpers.createClass(Customer, [{
    key: "loggedIn",
    get: function get() {
      var privateLabelId = this.options.privateLabelId;

      if (privateLabelId && this.data.plid && privateLabelId.toString() !== this.data.plid.toString()) {
        return false;
      }

      return !!~customer_status.indexOf(this.get('status')) || !!this.get('loginName');
    }
  }]);
  return Customer;
}(user_User);


// CONCATENATED MODULE: ./node_modules/@ux/header-util/delegate.js



/**
 * Delegate details
 *
 * @Constructor Delegate
 * @param {Object} options Optional configuration.
 * @api public
 */

var delegate_Delegate =
/*#__PURE__*/
function (_User) {
  babelHelpers.inheritsLoose(Delegate, _User);

  function Delegate() {
    return _User.apply(this, arguments) || this;
  }

  var _proto = Delegate.prototype;

  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  _proto.updateFromCookie = function updateFromCookie() {
    this.cookies.updateIdp();
    var del = this.cookies.getIdpProperty('del');
    var delType = del && del.auth;

    if (delType && delType !== 'basic') {
      // In more complex impersonation scenarios such as e2s2s, we need to dig another layer deeper to get information
      // about the middle customer in a two-layer impersonation/delegation stack. So we store that Customer here and
      // then load their info directly from the parsed `del` section of the cookie.
      this.impersonatedCustomer = new customer_Customer();
      var customerInfo = this.impersonatedCustomer.getIdpProperties(function (properties, replace) {
        return cookies_Cookies.getRealmPropertiesFromObject(del, properties, replace);
      }, delType);
      this.impersonatedCustomer.set(customerInfo);
    }

    this.set(this.cookies.getIdpProperties(['firstname', 'lastname', 'info_accountname', 'jti'].map(function (property) {
      return ['del', delType === 'basic' ? null : 'del', property].filter(Boolean);
    }), {
      info_accountname: 'accountName'
    }));
  };

  return Delegate;
}(user_User);


// CONCATENATED MODULE: ./node_modules/@ux/header-util/employee.js

/**
 * Employee details
 *
 * @Constructor Employee
 * @param {Object} options Optional configuration.
 * @api public
 */

var Employee =
/*#__PURE__*/
function (_User) {
  babelHelpers.inheritsLoose(Employee, _User);

  function Employee() {
    return _User.apply(this, arguments) || this;
  }

  var _proto = Employee.prototype;

  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  _proto.updateFromCookie = function updateFromCookie() {
    this.cookies.updateRealm('jomax');
    this.set(this.getJomaxProperties(this.cookies.getJomaxProperties.bind(this.cookies)));
  }
  /**
   * Get properties from jomax information
   *
   * @param {Function} getJomaxPropertiesFn Function to call to get properties from jomax
   * @returns {Object} Extracted properties
   * @api private
   */
  ;

  _proto.getJomaxProperties = function getJomaxProperties(getJomaxPropertiesFn) {
    return getJomaxPropertiesFn(['firstname', 'lastname', 'info_accountName', 'loggedIn'].map(function (property) {
      return [property];
    }).concat('jti'), {
      info_accountName: 'loginName'
    });
  }
  /**
   * Update user details from cookie
   *
   * @param {Object} url Request targets (not used for this subclass)
   * @param {Function} done Completion callback
   * @api public
   */
  ;

  _proto.fetch = function fetch(url, done) {
    this.updateFromCookie();
    done(null, this.getAll());
  }
  /**
   * Always return a null shopper ID for Employees
   *
   * @returns {Undefined} null
   * @api public
   */
  ;

  babelHelpers.createClass(Employee, [{
    key: "shopperId",
    get: function get() {
      return null;
    }
  }]);
  return Employee;
}(user_User);


// EXTERNAL MODULE: external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"}
var external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_ = __webpack_require__("react-trfq");
var external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default = /*#__PURE__*/__webpack_require__.n(external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_);

// CONCATENATED MODULE: ./node_modules/@ux/header-util/traffic2.js
/* eslint no-undef: 0 */


/* harmony default export */ var traffic2 = ({
  /**
   * Initialize traffic2.
   *
   * @param {Object} opts options object
   * @param {String} [opts.type=onload] type of initialization. values `disable`, `inline`, `onload`
   * @param {Boolean} [opts.beacon=true] whether to call beacon
   *
   * @private
   */
  init: function init(opts) {
    if (opts.type === 'disable') {
      return;
    }

    if (opts.type !== 'inline') {
      this.inject();
    }

    if (opts.beacon !== false) {
      this.beacon();
    }
  },

  /**
   * If there is a "ux" global (i.e. in the browser), then configure GTM immediately
   * with some values from ux.eldorado.data.props.
   *
   * @private
   */
  inject: function inject() {
    if (typeof ux !== 'undefined' && typeof window !== 'undefined') {
      var data = ux.eldorado && ux.eldorado.data || {};

      var _ref = data.props || {},
          shopperId = _ref.shopperId,
          privateLabelId = _ref.privateLabelId;

      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_["gtm"].configure({
        data: [shopperId && {
          shopperId: shopperId
        }, privateLabelId && {
          privateLabelId: privateLabelId
        }, {
          'tcc.status': 'on'
        }, {
          'tcc.gastatus': 'off'
        }].filter(Boolean)
      });
    }
  },

  /**
   * Logs a Traffic2 "beacon" event for the UX Platform team. This allows us to
   * get a gestalt for the total usage of all headers by all teams to better plan
   * new features and make prioritization features based on usage data.
   *
   * @private
   */
  beacon: function beacon() {
    if (typeof ux !== 'undefined' && typeof window !== 'undefined') {
      var url = new util_["URL"](window.location.href, true);
      var data = ux.eldorado && ux.eldorado.data || {};

      var _ref2 = data.props || {},
          app = _ref2.app,
          split = _ref2.split,
          manifest = _ref2.manifest,
          market = _ref2.market,
          countryName = _ref2.countryName,
          languageName = _ref2.languageName,
          currency = _ref2.currency; // UXCore 1 pages do not load ux.versions onto the page,
      // so we use ux.version's existence as a proxy for
      // "Is this page uxcore 1"?


      var uxcore = ux.versions ? 2 : 1;

      if (manifest && app) {
        external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent("uxp.hyd.int.".concat(manifest.toLowerCase(), ".").concat(app.replace('.', '_'), ".impression").replace(/-/g, '_'), 'impression', {
          market: market,
          split: split,
          uxcore: uxcore,
          currency: currency,
          hostname: url.hostname,
          path: url.path,
          query: url.query,
          country: countryName,
          lang: languageName
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/@ux/header-util/url.js
function url_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function url_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { url_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { url_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/**
 * Add query parameters from props to the url.
 *
 * @param {String} url Logout or login link.
 * @param {Object} props Properties to merge with the query parameters object.
 * @returns {String} Configured url.
 * @api private
 */

function updateQuery(url, props) {
  url = new util_["URL"](url, true);
  return url.set('query', url_objectSpread({}, url.query, {}, props)).href;
}
/**
 * This function takes in a currentHref
 * and will return that with no query parameters OR if a
 * currentPage query parameter is present, it will utilize
 * that value and pass it back.
 *
 * @param {String} currentHref The currentHref usually passed thru props
 * @param {Bool} isBrowser A boolean indicating whether context is a browser
 * @param {String} location A string that represents document.location or window.location
 * @returns {String} A currentHref string without query params -OR- the value of the currentPage query parameter
 */


function updateCurrentHref(currentHref, isBrowser, location) {
  //
  // Logic originally from
  // https://github.secureserver.net/UX/product-nav/blob/119ebd4ffc55e41a4bfebe1c973f55de0c3e35bc/lib/product-nav.js#L37
  //
  if (isBrowser) {
    currentHref = location;
  }

  if (currentHref) {
    var currentUrl = new util_["URL"](currentHref, true);
    var qsCurrentHref = currentUrl.query.currentPage;

    if (qsCurrentHref) {
      currentHref = qsCurrentHref;
    } else {
      // Remove query string for comparisons
      currentUrl.set('query', {});
      currentHref = currentUrl.href;
    }
  }

  return currentHref;
}


// CONCATENATED MODULE: ./node_modules/@ux/header-util/index.js








 //
// Add useful methods.
//


// EXTERNAL MODULE: external {"root":["ux","Icon"],"commonjs":["@ux/icon","default"],"commonjs2":["@ux/icon","default"],"amd":"@ux/icon"}
var icon_ = __webpack_require__("@ux/icon");
var icon_default = /*#__PURE__*/__webpack_require__.n(icon_);

// EXTERNAL MODULE: external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
var external_root_React_commonjs_react_commonjs2_react_amd_react_ = __webpack_require__("react");
var external_root_React_commonjs_react_commonjs2_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs_react_commonjs2_react_amd_react_);

// EXTERNAL MODULE: external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"}
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_ = __webpack_require__("prop-types");
var external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_);

// EXTERNAL MODULE: external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"}
var external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_ = __webpack_require__("react-dom");
var external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/modal.js
/* eslint react/no-render-return-value: 0 */



/**
 * Render a modal in the page through a temporary placeholder.
 *
 * @param {ReactElement} modal UXCore2 Modal.
 * @param {String} market Locale.
 * @param {Object} messages Internationalization data.
 * @param {Function} done Optional completion callback.
 * @returns {ReactDOM} Instance of internationalized modal.
 * @api public
 */

function modal_render(modal, market, messages) {
  var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var placeholder = document.createElement('div');
  document.body.appendChild(placeholder);
  return external_root_ReactDOM_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_default.a.render(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
    locale: market,
    messages: messages
  }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.cloneElement(modal, {
    messages: messages
  })), placeholder, done);
}
// EXTERNAL MODULE: external {"root":["ux","Button"],"commonjs":["@ux/button","default"],"commonjs2":["@ux/button","default"],"amd":"@ux/button"}
var button_ = __webpack_require__("@ux/button");
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external {"root":["ux","Modal"],"commonjs":["@ux/modal","default"],"commonjs2":["@ux/modal","default"],"amd":"@ux/modal"}
var modal_ = __webpack_require__("@ux/modal");
var modal_default = /*#__PURE__*/__webpack_require__.n(modal_);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/clickguard.js







/**
 * ClickGuard modal.
 *
 * @class Title
 * @api private
 */

var clickguard_ClickGuard =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inheritsLoose(ClickGuard, _Component);

  function ClickGuard() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ClickGuard.prototype;

  /**
   * Event handler for cancel or continue button. This will always close the modal,
   * but the original guarded action could still be performed.
   *
   * @param {Boolean} allow Should callback be called
   * @returns {Function} event handler
   * @api private
   */
  _proto.close = function close(allow) {
    var _this = this;

    var props = this.props;
    return function () {
      _this.ref.close(); //
      // Continue button was clicked, call the supplied callback.
      //


      if (allow) {
        props.callback(props.event);
      }
    };
  }
  /**
   * Modal title, fallback to default.
   *
   * @returns {ReactElement} title
   * @api private
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(modal_default.a, {
      ref: function ref(c) {
        _this2.ref = c;
      },
      title: this.title,
      footer: this.footer
    }, this.props.message || external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:deny-all-msg"
    }));
  };

  babelHelpers.createClass(ClickGuard, [{
    key: "title",
    get: function get() {
      return this.props.title || external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:AccountDelegation:deny-all-title"
      });
    }
    /**
     * Modal footer buttons.
     *
     * @returns {ReactElement} both cancel and continue button
     * @api private
     */

  }, {
    key: "footer",
    get: function get() {
      return [external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
        key: "cancel",
        onClick: this.close()
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:AccountDelegation:cancel"
      })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
        key: "continue",
        design: "default",
        onClick: this.close(true)
      }, this.props.caption || external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:AccountDelegation:continue"
      }))];
    }
  }]);
  return ClickGuard;
}(external_root_React_commonjs_react_commonjs2_react_amd_react_["Component"]);
/**
 * Custom clickguard modal properties.
 *
 * @enum {Object}
 * @api public
 */


clickguard_ClickGuard.propTypes = {
  message: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  caption: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  title: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  callback: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  event: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.any
};
/**
 * Setup event listener to intercept events when account delegation is active.
 *
 * @param {String} market Locale.
 * @param {Object} messages Internationalized strings.
 * @param {Object} props Additional properties required for customized modal
 * @param {Function} done Completion callback
 * @returns {Function} Event listener
 * @api private
 */

function clickguard(market, messages) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var done = arguments.length > 3 ? arguments[3] : undefined;

  if (typeof props === 'function') {
    done = props;
    props = {};
  }

  return function handle(event) {
    if (!src.active) {
      return done(event);
    }

    modal_render(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(clickguard_ClickGuard, babelHelpers["extends"]({}, props, {
      market: market,
      event: event,
      callback: done
    })), market, messages);
  };
}
// EXTERNAL MODULE: external {"root":["ux","Spinner"],"commonjs":["@ux/spinner","default"],"commonjs2":["@ux/spinner","default"],"amd":"@ux/spinner"}
var spinner_ = __webpack_require__("@ux/spinner");
var spinner_default = /*#__PURE__*/__webpack_require__.n(spinner_);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/verify.js
function verify_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function verify_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { verify_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { verify_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Check if the stored credentials still match that of the cookie.
 *
 * @param {Object} customer details.
 * @returns {Boolean} validity.
 * @api private
 */

function validCredentials(customer) {
  return src.idp.getIdpProperty('jti') === customer.get('jti');
}
/**
 * Verify the consistency of the current authentication credentials
 * against the cookie. This should prevent actions against wrong accounts if
 * impersonating multiple accounts.
 *
 * @param {Object} config Required configuration.
 * @returns {Boolean} true if credentials are valid, false if they are not
 * @api private
 */


function verify(config) {
  var customer = config.customer; //
  // If delegation is inactive or credentials are valid don't render modal warning.
  //

  if (!src.active || validCredentials(customer)) {
    return true;
  }

  return false;
}
/**
 * Issue a request to refresh the authentication cookie.
 *
 * @param {Object} config Required configuration.
 * @param {Function} done Completion callback.
 */


function refreshCookie(config, done) {
  var customer = config.customer; //
  // Try to refresh the cookie to check the known jti. Ignore errors from the
  // request so the modal will also be shown in that case.
  //

  util_["request"].get("".concat(config.restoreCookie, "?jti=").concat(customer.get('jti')), {
    jsonp: config.jsonp === false ? config.jsonp : true
  }, function (error) {
    //
    // Credentials are still valid, notify the delegate that delegation is active.
    //
    if (!error && validCredentials(customer)) {
      return done(true);
    }

    done(false);
  });
}
/**
 * Render UXCore2 Modal if validation failed.
 *
 * @class Verify
 * @api public
 */


var verify_VerificationModal =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(VerificationModal, _NamespaceConsumer);

  function VerificationModal() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = VerificationModal.prototype;

  _proto.render = function render() {
    var props = this.props;
    var footer = !props.refreshFailed && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      design: "primary",
      disabled: props.pending,
      onClick: !props.pending && props.onOk
    }, props.pending ? external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(spinner_default.a, {
      size: "sm",
      inline: true,
      shade: "dark"
    }) : external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:Common:OK"
    }));
    var message;

    if (!props.refreshFailed) {
      message = 'Shared:AccountDelegation:pageAuthRefreshMessage';
    } else {
      message = 'Shared:AccountDelegation:validateAuthMessage';
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(modal_default.a, {
      footer: footer,
      title: external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:AccountDelegation:validateAuthTitle"
      }),
      onClose: props.onDismiss
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('verification-modal')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:AccountDelegation:validateAuthShopper",
      values: props
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: message
    })));
  };

  return VerificationModal;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Required properties for Modal message.
 *
 * @enum {Object}
 * @api public
 */


verify_VerificationModal.propTypes = verify_objectSpread({}, namespace_component_["NamespaceShape"], {
  displayName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  pending: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  refreshFailed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  onDismiss: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  onOk: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func
});
var modalWithNamespace = Object(namespace_component_["withNamespace"])(verify_VerificationModal);

// CONCATENATED MODULE: ./node_modules/@ux/account-delegation/src/index.js
function src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








 //
// Delegation types.
//
// Impersonate: c3 representatives
// Delegate: shopper delegation
//

var src_impersonate = 'impersonate';
var src_delegate = 'delegate';
/**
 * Render exit links on the right side of each delegation bar.
 *
 * @class ExitLink
 * @api private
 */

var src_ActualExitLink =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(ActualExitLink, _NamespaceConsumer);

  function ActualExitLink() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = ActualExitLink.prototype;

  /**
   * Render form to ensure a POST request to action.
   *
   * @returns {ReactElement} form element.
   * @api private
   */
  _proto.delegate = function delegate() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("form", {
      method: "post",
      action: props.action
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("input", {
      type: "hidden",
      name: "secret",
      value: props.secret
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      type: "submit",
      className: this.namespace('delegate-link')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_default.a, {
      name: "x"
    }), ' '
    /* deliberate space between icon and message */
    , external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "PC:AppHeader:Header:AcctDelegationExitLabel"
    })));
  }
  /**
   * Render a simple logout link.
   *
   * @returns {ReactElement} anchor element.
   * @api private
   */
  ;

  _proto.impersonate = function impersonate() {
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: this.props.action,
      className: this.namespace('delegate-link')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_default.a, {
      name: "x"
    }), ' '
    /* deliberate space between icon and message */
    , external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "PC:AppHeader:Header:AcctImpersonationExitLabel"
    }));
  };

  _proto.render = function render() {
    return this[this.props.type]();
  };

  return ActualExitLink;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Default type and action for exit link.
 *
 * @enum {Object}
 * @api public
 */


src_ActualExitLink.defaultProps = {
  type: src_delegate
};
/**
 * Required ExitLink properties.
 *
 * @enum {Object}
 * @api public
 */

src_ActualExitLink.propTypes = src_objectSpread({}, namespace_component_["NamespaceShape"], {
  secret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  type: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  action: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
var ExitLink = Object(namespace_component_["withNamespace"])(src_ActualExitLink);
/**
 * Render delegation bar.
 *
 * @class Bar
 * @api private
 */

var src_ActualBar =
/*#__PURE__*/
function (_NamespaceConsumer2) {
  babelHelpers.inheritsLoose(ActualBar, _NamespaceConsumer2);

  function ActualBar() {
    return _NamespaceConsumer2.apply(this, arguments) || this;
  }

  var _proto2 = ActualBar.prototype;

  _proto2.render = function render() {
    var props = this.props;
    var type = props.type;
    var wrapper = this.namespace(this.classNames('delegate', {
      rep: type === src_impersonate
    }));
    var animated = this.namespace(this.classNames('container', {
      refreshed: props.refreshed
    }));

    if (!props.active) {
      return null;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapper
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: animated
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('pull-left')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], props.label)), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('pull-right')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(ExitLink, {
      type: type,
      action: props.action,
      secret: props.secret
    }))));
  };

  return ActualBar;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Require Bar properties.
 *
 * @enum {Object}
 * @api public
 */


src_ActualBar.propTypes = src_objectSpread({}, namespace_component_["NamespaceShape"], {
  refreshed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  active: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  label: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  type: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  secret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  action: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
var Bar = Object(namespace_component_["withNamespace"])(src_ActualBar);
var AccountDelegation;
/**
 * Render internationalized delegation bars.
 *
 * @class AccountDelegation
 * @api public
 */

var src_ActualAccountDelegation =
/*#__PURE__*/
function (_NamespaceConsumer3) {
  babelHelpers.inheritsLoose(ActualAccountDelegation, _NamespaceConsumer3);

  function ActualAccountDelegation() {
    var _this;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _this = _NamespaceConsumer3.apply(this, arguments) || this; //
    // Setup delegate instance
    //

    _this.delegate = new delegate_Delegate({
      data: props.delegate || {}
    }); //
    // Keep track of the delegation type.
    //

    _this._type = AccountDelegation.type || src_impersonate;
    _this.state = {
      refreshed: false,
      credentialRefreshPending: false,
      showVerificationModal: false,
      impersonatedCustomerId: null
    }; //
    // Expose the clickguard method on the constructor. This is safe since there
    // should only be one AccountDelegation Component on the page. Required
    // to get the localization data in the modal. Also ClickGuard cannot
    // be used without account delegation being active.
    //

    AccountDelegation.clickguard = clickguard.bind(clickguard, props.market, props.messages);
    return _this;
  }
  /**
   * Determine type of delegating from cookie. This method is made static for
   * external consumption.
   *
   * @returns {String|Array} Account delegation type.
   * @api public
   */


  var _proto3 = ActualAccountDelegation.prototype;

  /**
   * Label properties of delegation bar.
   *
   * @param {Boolean} [forImpersonationBar] Whether this label is for the impersonation bar
   * @returns {Object} data used by formatted message.
   * @api private
   */
  _proto3.label = function label() {
    var forImpersonationBar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var customer, impersonator;

    if (forImpersonationBar) {
      customer = this.delegate.impersonatedCustomer || this.props.customer;
      impersonator = this.delegate;
    } else {
      // delegation bar
      customer = this.props.customer;
      impersonator = this.delegate.impersonatedCustomer || this.delegate;
    } // If we have a displayName set, use that.
    // If we have the customer's first and last name, pass those in so the i18n string handles localizing name order.
    // Otherwise, use the displayName method to handle fallbacks to fullName, username, or shopperId.


    var customerFirstName = customer.get('displayName');
    var customerLastName = '';

    if (!customerFirstName) {
      customerFirstName = customer.get('firstName');
      customerLastName = customer.get('lastName');

      if (!(customerFirstName && customerLastName)) {
        customerFirstName = customer.displayName(true);
        customerLastName = '';
      }
    }

    return {
      id: 'PC:AppHeader:Header:AcctDelegationLabel',
      values: {
        delegate: impersonator.delegateName(),
        firstName: customerFirstName,
        lastName: customerLastName
      }
    };
  }
  /**
   * Update the window title to reflect the current shopperId of the customer.
   *
   * @api private
   */
  ;

  _proto3.updateTitle = function updateTitle() {
    var customer = this.props.customer;

    if (!customer || !customer.shopperId) {
      return;
    }

    var title = window.document.title;
    var i = title.indexOf(']');
    title = ~i ? title.substr(i + 2) : title;
    window.document.title = "[".concat(customer.shopperId, "] ").concat(title);
  }
  /**
  * Verify consistency of credentials when a browser tab is focused.
  *
  * @api private
  */
  ;

  _proto3.onTabFocus = function onTabFocus() {
    var self = this;
    var props = self.props; // Don't reset state if the dialog is already showing

    if (this.state.showVerificationModal) return;
    var credentialsValid = verify({
      customer: props.customer
    });
    this.setState({
      showVerificationModal: !credentialsValid,
      credentialRefreshPending: false,
      credentialRefreshFailed: false
    });
  }
  /**
   * Handle click on OK button in verification modal
   *
   * @api private
   */
  ;

  _proto3.onVerificationModalOkClicked = function onVerificationModalOkClicked() {
    var _this2 = this;

    var props = this.props;
    this.setState({
      credentialRefreshPending: true
    });
    refreshCookie({
      customer: props.customer,
      restoreCookie: props.restoreCookie
    }, function (refreshed) {
      _this2.setState({
        showVerificationModal: !refreshed,
        credentialRefreshPending: false,
        credentialRefreshFailed: !refreshed
      });
    });
  }
  /**
   * Get data, listen to window focus and update the title if required.
   *
   * @api private
   */
  ;

  _proto3.componentDidMount = function componentDidMount() {
    this.delegate.updateFromCookie(); // If there is an intermediate customer in the delegation chain, we need to set state so we re-render the
    // impersonation bar label

    this.delegate.impersonatedCustomer && this.setState({
      impersonatedCustomerId: this.delegate.impersonatedCustomer.shopperId
    });
    this.on('focus', this.onTabFocus);

    if (this.isImpersonation) {
      this.updateTitle();
    }
  }
  /**
   * Update title if required
   *
   * @api private
   */
  ;

  _proto3.componentDidUpdate = function componentDidUpdate() {
    if (this.isImpersonation) {
      this.updateTitle();
    }
  }
  /**
   * Remove window focus listener.
   *
   * @api private
   */
  ;

  _proto3.componentWillUnmount = function componentWillUnmount() {
    this.off('focus', this.onTabFocus);
  }
  /**
   * Render the delegation bar.
   *
   * @returns {ReactElement} Translated delegation bar.
   * @api private
   */
  ;

  _proto3.render = function render() {
    var _this3 = this;

    var state = this.state;
    var props = this.props;
    var wrapper = this.namespace(this.classNames('delegation', {
      db: this.isImpersonation && this.isDelegate
    })); //
    // Do not render the bar if there is no active delegation.
    //

    if (!AccountDelegation.active) {
      return null;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapper
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(Bar, babelHelpers["extends"]({}, props, {
      type: src_impersonate,
      refreshed: state.refreshed,
      label: this.label(true),
      active: this.isImpersonation
    })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(Bar, babelHelpers["extends"]({}, props, {
      type: src_delegate,
      refreshed: state.refreshed,
      label: this.label(false),
      active: this.isDelegate
    })), this.state.showVerificationModal && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(modalWithNamespace, {
      displayName: props.customer.displayName(),
      shopperId: props.customer.shopperId,
      pending: this.state.credentialRefreshPending,
      refreshFailed: this.state.credentialRefreshFailed,
      onDismiss: function onDismiss() {
        _this3.setState({
          showVerificationModal: false
        });
      },
      onOk: this.onVerificationModalOkClicked.bind(this)
    })));
  };

  babelHelpers.createClass(ActualAccountDelegation, [{
    key: "isDelegate",

    /**
     * Is the delegation of type shopper delegate.
     *
     * @returns {Boolean} shopper delegation
     * @api private
     */
    get: function get() {
      return !!~this._type.indexOf(src_delegate);
    }
    /**
     * Is the delegation of type c3 impersonation.
     *
     * @returns {Boolean} impersonation
     * @api private
     */

  }, {
    key: "isImpersonation",
    get: function get() {
      return !!~this._type.indexOf(src_impersonate);
    }
  }], [{
    key: "type",
    get: function get() {
      var auth = AccountDelegation.idp.getIdpProperty('auth');

      switch (auth) {
        case 'e2s2s':
          return [src_delegate, src_impersonate];

        case 'e2s':
          return src_impersonate;

        case 's2s':
          return src_delegate;

        case 'e2s2snpr':
          return [src_delegate, src_impersonate];

        case 'e2snpr':
          return src_impersonate;

        case 's2snpr':
          return src_delegate;

        default:
          return 'none';
      }
    }
    /**
     * Return idp cookie reference. Also attempts to fetch latest data from cookie.
     *
     * @returns {Cookie} Header utils cookies instance.
     * @api public
     */

  }, {
    key: "idp",
    get: function get() {
      if (!AccountDelegation._idp) {
        AccountDelegation._idp = new cookies_Cookies();
      }

      return AccountDelegation._idp.updateIdp();
    }
    /**
     * Is delegation active?
     *
     * @returns {Boolean} Active
     * @api public
     */

  }, {
    key: "active",
    get: function get() {
      return !~AccountDelegation.type.indexOf('none');
    }
  }]);
  return ActualAccountDelegation;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Default type and action for exit link.
 *
 * @enum {Object}
 * @api public
 */

src_ActualAccountDelegation.defaultProps = {
  action: 'https://sso.godaddy.com/cookie/switchback/',
  restoreCookie: 'https://sso.godaddy.com/cookie/restore/'
};
/**
 * Allowed delegation values.
 *
 * @enum {Object}
 * @api public
 */

src_ActualAccountDelegation.propTypes = src_objectSpread({}, namespace_component_["NamespaceShape"], {
  customer: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  delegate: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  secret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  restoreCookie: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  action: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
AccountDelegation = Object(namespace_component_["withNamespace"])(src_ActualAccountDelegation); // Need to manually copy this over since `hoist-non-react-statics` ignores this static property.

Object.defineProperty(AccountDelegation, 'type', Object.getOwnPropertyDescriptor(src_ActualAccountDelegation, 'type'));
/* harmony default export */ var src = (AccountDelegation);
// EXTERNAL MODULE: ./node_modules/golf-to-eid/index.js
var golf_to_eid = __webpack_require__("./node_modules/golf-to-eid/index.js");
var golf_to_eid_default = /*#__PURE__*/__webpack_require__.n(golf_to_eid);

// CONCATENATED MODULE: ./node_modules/@ux/mobile-nav/src/enums.js
 //
// Golf translation ids
//

var golf = {
  callUs: 'Shared:UtilityBar:SupportPhone:CallUs',
  help: 'Shared:Help',
  myAccount: 'Sales:Footer:MyAccount:ManageYourAccount'
}; //
// Generate Traffic2 eid's to be used to track clicks. Map the generated
// strings back to the same keys the Golf translations strings have.
// These links appear in both app and sales header thus, the prefix can be
// hard-coded as `uxp.hyd.mobile_nav`
//

var golfKeys = Object.keys(golf);
var eidStrings = golf_to_eid_default()(golfKeys.map(function (key) {
  return golf[key];
}), {
  prefix: 'uxp.hyd.mobile_nav',
  postfix: 'link.click'
});
var enums_eids = golfKeys.reduce(function (eid, key, index) {
  eid[key] = eidStrings[index];
  return eid;
}, {});

// CONCATENATED MODULE: ./node_modules/@ux/link/index.js





/**
 * Regex for checking for `data-*` attributes
 * @type {RegExp}
 */

var isDataAttr = /^data-/;
/**
 * Returns a generic link component that lazily merges any `props.urlArgs`
 * with `props.href`.
 */

var link_Link =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inheritsLoose(Link, _Component);

  function Link() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  /**
   * Redirects to the merge of `props.urlArgs` and `props.href`
   * @param   {React.SyntheticEvent} e onClick event data.
   * @param   {String} loc Target location href to redirect to.
   * @returns {Boolean} false to stop navigation to `props.href`.
   */
  _proto.redirect = function redirect(e, loc) {
    var props = this.props;
    e.preventDefault();
    e.stopPropagation();
    props.onClicked();
    var target = props.target;
    var eid = props['data-eid'];

    if (eid) {
      //
      // Remark (crobbins): it is ALMOST NEVER desireable to pull from global window
      // state in a React component since it breaks encapsulation. In this case, however,
      // we allow it because:
      //
      // 1. We are purposefully lazy about the existence of data.
      // 2. This will happen at most ONCE on a page since we are about to redirect away
      //    from the page itself.
      //
      var data = window.ux && window.ux.eldorado && window.ux.eldorado.data && window.ux.eldorado.data.props || {}; //
      // Remark (crobbins): it may be desireable use `cb` in `trfq.logEvent` if
      // the navigation to another page happens too quickly for the event to be logged.
      //

      var l = window.location;
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eid, 'click', {
        app: data.app,
        hostname: l.hostname,
        path: l.path,
        query: l.search,
        market: data.market,
        lang: data.languageName,
        country: data.countryName,
        currency: data.currency,
        split: data.split
      });
    }

    var destination = url_namespaceObject.updateQuery(loc, props.urlArgs);

    if (e.metaKey || e.ctrlKey) {
      window.open(destination, '_blank');
    } else if (target && target !== '_self') {
      window.open(destination, target);
    } else {
      window.location = destination;
    }

    return false;
  }
  /**
   * Renders the link with the appropriate click handling.
   * @returns {React.ReactElement} Denormalized `anchor` with appropriate properties
   */
  // eslint-disable-next-line complexity
  ;

  _proto.render = function render() {
    var _this = this;

    var props = this.props;
    var urlArgs = props.urlArgs;
    var children; //
    // !! IMPORTANT !! Traffic2 (specifically tcc.combined.**.min.js)
    // will intercept ANY click on ANY element with an `href` attribute. Since we wish
    // to set our own `window.location` we must set `data-tcc-ignore` so that
    // no click listener is added by Traffic2.
    //

    var redirectTo = props.redirect || props.href;
    var hasUrlArgs = urlArgs && Object.keys(urlArgs).length;
    var shouldRedirect = props.href.indexOf('tel:') !== 0 && (props.redirect || hasUrlArgs);
    var tccIgnore = props['data-tcc-ignore'] || !!shouldRedirect;
    var dataAttrs = Object.keys(props).reduce(function (acc, key) {
      if (isDataAttr.test(key)) {
        acc[key] = props[key];
      }

      return acc;
    }, {});

    if (props.children || props.caption) {
      children = props.children || external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedHTMLMessage"], {
        id: props.caption
      });
    }

    dataAttrs['data-tcc-ignore'] = tccIgnore || null;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
      "aria-label": props.ariaLabel,
      id: props.id,
      href: props.href,
      rel: props.rel,
      target: props.target,
      className: props.className,
      title: props.title,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onClick: props.onClick || shouldRedirect && function (e) {
        _this.redirect(e, redirectTo);
      } || props.onClicked
    }, dataAttrs), children);
  };

  return Link;
}(external_root_React_commonjs_react_commonjs2_react_amd_react_["Component"]);


link_Link.defaultProps = {
  onClicked: function onClicked() {}
};
/**
 * PropTypes for Link. Most map directly to HTML attributes on the `<a>`.
 * @type {Object}
 */

link_Link.propTypes = {
  'caption': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'children': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node,
  'className': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'data-eid': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'data-tcc-ignore': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'href': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  'id': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'redirect': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'rel': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'target': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'urlArgs': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'ariaLabel': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'onClick': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  'onMouseEnter': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  'onMouseLeave': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  'onClicked': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  'title': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
};
// EXTERNAL MODULE: ./node_modules/rip-out/index.js
var rip_out = __webpack_require__("./node_modules/rip-out/index.js");
var rip_out_default = /*#__PURE__*/__webpack_require__.n(rip_out);

// CONCATENATED MODULE: ./node_modules/@ux/mobile-nav/src/subnav-panel.js
function subnav_panel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function subnav_panel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { subnav_panel_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { subnav_panel_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var subnav_panel_SubNavPanel =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(SubNavPanel, _NamespaceConsumer);

  function SubNavPanel() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = SubNavPanel.prototype;

  /**
   * Determines whether to render text as formatteHTMLMsg or as literal string
   * @param  {String}  caption   The string to render
   * @param  {Boolean} isLiteral Whether or not to render as literal string
   * overrides `literalCaptions` prop
   * @returns {Boolean|String|React.Element} false if there is nothing to render, otherwise
   * returns what should be rendered for the caption
   */
  _proto.renderCaption = function renderCaption(caption) {
    var isLiteral = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!caption) {
      return false;
    } else if (isLiteral || this.props.literalCaptions) {
      return caption;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedHTMLMessage"], {
      id: caption
    });
  }
  /**
   * Render a uxcore2 icon
   * @param {string} icon The classname for a uxcore2 icon
   * @returns {React.Element} A span with an icon
   * @private
   */
  ;

  _proto.renderIcon = function renderIcon(icon) {
    if (icon) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: this.namespace(icon, 'uxicon', 'custom-icon')
      });
    }

    return null;
  }
  /**
   * handles clicking on navigation items with a custom onClick handler
   *
   * @param {Object} item The item that was just clicked on
   * @param {Object} event The click event
   * @private
   */
  ;

  _proto.onItemClick = function onItemClick(item, event) {
    if (typeof item.onClick === 'function') {
      item.onClick(event);
    }

    this.afterItemClicked(item);
  }
  /**
   * Performs actions after clicking on an item
   *
   * @param {Object} item The item that was just clicked on
   * @private
   */
  ;

  _proto.afterItemClicked = function afterItemClicked(item) {
    if (this.isBrowser) {
      window.sessionStorage.setItem('activeCaption', item.caption || item.id);
    }

    this.props.onClose();
  }
  /**
   * Generate links
   *
   * @private
   * @param {Array} items Array of objects to display as links
   * @returns {Array} a set of Links
   */
  ;

  _proto.renderMobileLinks = function renderMobileLinks(items) {
    var _this = this;

    var links = [];
    items.forEach(function (child, i) {
      if (!child.href || child.href.length === 0) {
        return;
      }

      var active = _this.props.currentHref === child.href;
      var eid = child.eid || golf_to_eid_default()(child.caption || child.id || '', {
        prefix: _this.props.eidPrefix,
        postfix: 'link.click'
      });

      if (child.caption || child.title) {
        links.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
          key: (child.caption || child.id) + i,
          className: _this.namespace(_this.classNames('subnav-item', 'list-unstyled', {
            active: active
          }))
        }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, babelHelpers["extends"]({
          href: child.href,
          target: child.target,
          "data-eid": eid,
          onClick: child.onClick && _this.onItemClick.bind(_this, child),
          onClicked: function onClicked() {
            return _this.afterItemClicked(child);
          },
          urlArgs: _this.props.urlArgs
        }, child.dataAttrs), _this.renderCaption(child.title, true) || _this.renderCaption(child.caption), _this.renderIcon(child.icon))));
      }
    });
    return links;
  }
  /**
   * Generate secondary headings for each section of links inside primary heading
   *
   * @private
   * @param {Object[]} items Array of objects for generating the subnav links
   * @param {String} parentHeading The caption for the parent of the subnav-panel
   * @returns {ReactElement[]} a set of list items
   */
  ;

  _proto.renderSubNavSections = function renderSubNavSections(items, parentHeading) {
    var _this2 = this;

    var listItems = [];
    items.forEach(function (child, i) {
      // if there are subsections, i.e. two levels of children
      if (child.children && child.children.length > 0) {
        var suppressTitle = items.length === 1 && child.title && child.title === parentHeading; // check if the children are valid links

        var links = _this2.renderMobileLinks(child.children);

        if (!Array.isArray(links) || links.length === 0) {
          return;
        } // push the heading first


        if (!suppressTitle && (child.caption || child.title)) {
          listItems.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
            key: (child.caption || child.id) + i,
            className: _this2.namespace('subnav-mobile-heading')
          }, _this2.renderCaption(child.title, true) || _this2.renderCaption(child.caption)));
        } // then push the links


        listItems.push(links); // then push divider

        listItems.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("hr", {
          key: 'hr' + i
        }));
      }
    });

    if (listItems.length === 0) {
      // no subsections
      listItems.push(this.renderMobileLinks(items));
    }

    return listItems;
  }
  /**
   * Generate subnav for a primary heading
   *
   * @private
   * @param {Object} navSection Object for generating the subnav
   * @param {String} navSection.caption Text for primary heading in subnav
   * @param {Object[]} navSection.children Array of objects for generating the subnav sections
   * @param {String} [navSection.href] href for heading to link to
   * @returns {ReactElement} a div containing the subnav for a primary heading
   */
  ;

  _proto.renderNavSection = function renderNavSection(navSection) {
    var _this3 = this;

    var colHeading;
    var caption = navSection.caption,
        title = navSection.title,
        id = navSection.id,
        href = navSection.href,
        dataAttrs = navSection.dataAttrs,
        target = navSection.target,
        onClick = navSection.onClick;

    if (href) {
      var eid = navSection.eid || golf_to_eid_default()(caption || id || '', {
        prefix: this.props.eidPrefix,
        postfix: 'link.click'
      });
      colHeading = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, babelHelpers["extends"]({
        href: href,
        "data-eid": eid,
        target: target,
        onClick: onClick && this.onItemClick.bind(this, navSection),
        onClicked: this.props.onClose
      }, dataAttrs), this.renderCaption(title, true) || this.renderCaption(caption));
    } else {
      colHeading = this.renderCaption(title, true) || this.renderCaption(caption);
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('subnav-scroller')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      ref: function ref(r) {
        _this3.element = r;
      },
      className: "".concat(this.namespace('subnav-mobile'), " list-unstyled")
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: this.namespace('column-heading', 'font-primary-bold')
    }, colHeading, this.renderIcon(navSection.icon)), this.renderSubNavSections(navSection.children, colHeading)));
  }
  /**
   * render gray header with close button
   * and conditionally a back button
   *
   * @param {Boolean} showBackBtn Whether or not to show the back button
   * @private
   * @returns {ReactElement} a div for the top header
   */
  ;

  _proto.renderTopContainer = function renderTopContainer(showBackBtn) {
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('mobile-top-container')
    }, showBackBtn && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      onClick: this.props.onBack,
      design: "tertiary",
      className: this.namespace('main-menu-btn')
    }, this.renderCaption(this.props.menuTitle)), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      onClick: this.props.onClose,
      className: this.namespace('uxicon-x', 'uxicon', 'pull-right')
    }));
  }
  /**
   * Render panel displaying subnav if navigation menu is open
   *
   * @private
   *
   * @returns {ReactElement} div for the subnav panel
   */
  ;

  _proto.render = function render() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('subnav-panel', {
        open: props.open
      }))
    }, this.renderTopContainer(true), this.renderNavSection(props.navigation));
  };

  return SubNavPanel;
}(namespace_component_["NamespaceConsumer"]);
/**
 * PropType validation for SubNavPanel
 *
 * @type {Object}
 * @api public
 */

subnav_panel_SubNavPanel.propTypes = subnav_panel_objectSpread({}, namespace_component_["NamespaceShape"], {
  currentHref: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  literalCaptions: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  menuTitle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  navigation: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  onBack: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  onClose: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

subnav_panel_SubNavPanel.defaultProps = {
  currentHref: '',
  eidPrefix: 'uxp.hyd.mobile_nav',
  literalCaptions: false,
  menuTitle: 'Shared:MobileNav:MainMenu',
  onBack: function onBack() {},
  onClose: function onClose() {},
  open: false
};
/* harmony default export */ var subnav_panel = (Object(namespace_component_["withNamespace"])(subnav_panel_SubNavPanel));
// CONCATENATED MODULE: ./node_modules/@ux/mobile-nav/src/index.js
function mobile_nav_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mobile_nav_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mobile_nav_src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mobile_nav_src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var src_MobileNav =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(MobileNav, _NamespaceConsumer);

  function MobileNav() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.state = mobile_nav_src_objectSpread({}, _this.state, {
      selectedItem: null,
      displaySubNavPanel: false,
      open: false,
      runway: false,
      hideOnScroll: false
    });
    _this.html = {};
    _this.close = _this.close.bind(babelHelpers.assertThisInitialized(_this));
    _this.goToMainMenu = _this.goToMainMenu.bind(babelHelpers.assertThisInitialized(_this));
    _this.toggleOpen = _this.toggleOpen.bind(babelHelpers.assertThisInitialized(_this));
    _this.killRunway = _this.killRunway.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  var _proto = MobileNav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var state = this.state;
    var subMenuHeight = '';

    if (this.subNavPanel && this.subNavPanel.element) {
      subMenuHeight = this.subNavPanel.element.clientHeight;
    }

    var fauxScreenHeight = screen.height - 60;

    if (subMenuHeight && subMenuHeight > fauxScreenHeight && !state.runway && state.displaySubNavPanel && !state.hideOnScroll) {
      this.setState({
        runway: true
      });
    } else if (!state.displaySubNavPanel && state.runway) {
      this.setState({
        runway: false
      });
    }
  }
  /**
   * close the menu by setting state.open to be false
   *
   * @private
   */
  ;

  _proto.close = function close() {
    this.props.onClick(false);
    this.setState({
      open: false,
      runway: false,
      displaySubNavPanel: false,
      selectedItem: null
    });
    var html = this.html;
    html.className = this.classNames(html.className, babelHelpers.defineProperty({}, this.namespace('mobile-menu-open'), false)) || '';
  }
  /**
   * get rid of the runway
   *
   * @private
   */
  ;

  _proto.killRunway = function killRunway() {
    if (!this.state.runway) {
      return;
    }

    this.setState({
      runway: false,
      hideOnScroll: true
    });
  }
  /**
   * click function to set open/close state of menu
   *
   * @private
   */
  ;

  _proto.toggleOpen = function toggleOpen() {
    var open = this.state.open;
    this.props.onClick(!open);
    this.setState({
      open: !open
    });
  }
  /**
   * click function to set which nav item is selected
   * as well as whether to display the main headings or the subnav
   *
   * @param {Object} item The item that was just clicked on
   * @param {Object} event The click event
   * @private
   */
  ;

  _proto.onHeadingClick = function onHeadingClick(item, event) {
    if (item.onClick) {
      item.onClick(event);
    }

    this.setState({
      selectedItem: item,
      displaySubNavPanel: true
    });
  }
  /**
   * handles clicking on navigation items with an onClick handler
   *
   * @param {Object} item The item that was just clicked on
   * @param {Object} event The click event
   * @private
   */
  ;

  _proto.onItemClick = function onItemClick(item, event) {
    item.onClick(event);
    this.close();
  }
  /**
   * click function to go back to the main menu
   *
   * @private
   */
  ;

  _proto.goToMainMenu = function goToMainMenu() {
    this.setState({
      displaySubNavPanel: false,
      hideOnScroll: false
    });
  }
  /**
   * Determines whether to render text as formatteHTMLMsg or as literal string
   * @param  {String}  caption   The string to render
   * @param  {Boolean} isLiteral Whether or not to render as literal string
   * overrides `literalCaptions` prop
   * @returns {Boolean|String|React.Element} false if there is nothing to render, otherwise
   * returns what should be rendered for the caption
   */
  ;

  _proto.renderCaption = function renderCaption(caption) {
    var isLiteral = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!caption) {
      return false;
    } else if (isLiteral || this.props.literalCaptions) {
      return caption;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedHTMLMessage"], {
      id: caption
    });
  }
  /**
   * Render a uxcore2 icon
   * @param {string} icon The classname for a uxcore2 icon
   * @returns {React.Element} A span with an icon
   * @private
   */
  ;

  _proto.renderIcon = function renderIcon(icon) {
    if (icon) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: this.namespace(icon, 'uxicon', 'custom-icon')
      });
    }

    return null;
  }
  /**
   * Render a heading that is a plain button with no children.
   * @param  {Object} item A navigation item that contains link data
   * @param {Number} idx The index at which the item appears in the nav array
   * @param  {String} eid Eid for click tracking
   * @param  {Boolean} active If the parent is active
   * @returns {ReactElement} Div containing a parent link
   */
  ;

  _proto.renderPlainButton = function renderPlainButton(item, idx, eid, active) {
    var _this$props = this.props,
        urlArgs = _this$props.urlArgs,
        useGradientHighlightBar = _this$props.useGradientHighlightBar;
    var caption = item.caption,
        title = item.title,
        icon = item.icon,
        id = item.id,
        href = item.href,
        dataAttrs = item.dataAttrs,
        target = item.target,
        onClick = item.onClick;
    var plainButton = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, babelHelpers["extends"]({
      key: (caption || id) + idx,
      className: this.namespace(this.classNames('column-heading', {
        active: active
      })),
      href: href,
      urlArgs: urlArgs,
      "data-eid": eid,
      target: target,
      onClick: onClick && this.onItemClick.bind(this, item),
      onClicked: this.close
    }, dataAttrs), this.renderCaption(title, true) || this.renderCaption(caption), this.renderIcon(icon));

    if (!useGradientHighlightBar) {
      return plainButton;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('column-container')
    }, active && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('column-highlight'),
      role: "presentation"
    }, "\xA0"), plainButton);
  }
  /**
   * Render a heading button that has children
   * @param  {Object} item A parent navigation item that has children
   * @param {Number} idx The index at which the item appears in the nav array
   * @param  {String} eid Eid used for click tracking
   * @param  {Boolean} active If the parent is active
   * @returns {ReactElement} Div containing a parent that has children
   */
  ;

  _proto.renderHeadingWithChildren = function renderHeadingWithChildren(item, idx, eid, active) {
    var caption = item.caption,
        title = item.title,
        id = item.id;
    var menuItem = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      key: (caption || id) + idx,
      className: this.namespace(this.classNames('column-heading', {
        active: active
      })),
      onClick: this.onHeadingClick.bind(this, item),
      "data-eid": eid
    }, this.renderCaption(title, true) || this.renderCaption(caption), this.renderIcon(item.icon), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('uxicon-chevron-right-lt', 'uxicon')
    }));

    if (!this.props.useGradientHighlightBar) {
      return menuItem;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('column-container')
    }, active && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('column-highlight'),
      role: "presentation"
    }, "\xA0"), menuItem);
  }
  /**
   * render top level headings for nav
   *
   * @private
   * @returns {ReactElement} a set of divs
   */
  ;

  _proto.renderMobileHeadings = function renderMobileHeadings() {
    var _this2 = this;

    var props = this.props; // eslint-disable-next-line complexity

    return props.nav.map(function (item, idx) {
      var caption = item.caption,
          title = item.title,
          id = item.id,
          children = item.children,
          href = item.href;

      if (caption || title) {
        var active = props.activeHeading && (props.activeHeading.caption && ~props.activeHeading.caption.indexOf(caption) || props.activeHeading.id && ~props.activeHeading.id.indexOf(id));
        var eid = item.eid || golf_to_eid_default()(caption || id || '', {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        }); // add a divider above partner programs

        if (props.growthnav2 && id === 'Sales:ProductNav:PartnerPrograms') {
          var content;

          if (children && children.length > 0) {
            content = _this2.renderHeadingWithChildren(item, idx, eid, active);
          } else if (href) {
            content = _this2.renderPlainButton(item, idx, eid, active);
          }

          return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, {
            key: id + idx
          }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("hr", null), content);
        }

        if (children && children.length > 0) {
          return _this2.renderHeadingWithChildren(item, idx, eid, active);
        } else if (href) {
          return _this2.renderPlainButton(item, idx, eid, active);
        }
      }
    });
  }
  /**
   * render gray header with close button
   * and conditionally a back button
   *
   * @param {Boolean} showBackBtn Whether or not to show the back button
   * @private
   * @returns {ReactElement} a div for the top header
   */
  ;

  _proto.renderTopContainer = function renderTopContainer(showBackBtn) {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('mobile-top-container')
    }, showBackBtn && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, {
      onClick: this.goToMainMenu,
      design: "tertiary",
      className: this.namespace('main-menu-btn')
    }, this.renderCaption(this.props.menuTitle)), !showBackBtn && props.showMenuTitleOnHome && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('mobile-top-container-label', 'font-primary-bold')
    }, this.renderCaption(this.props.menuTitle)), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      onClick: this.close,
      className: this.namespace('uxicon-x', 'uxicon', 'pull-right')
    }));
  }
  /**
   * Render array of all panels containing subnavs
   *
   * @private
   *
   * @returns {Array} div of SubNavPanels
   */
  ;

  _proto.renderSubNavPanels = function renderSubNavPanels() {
    var _this3 = this;

    var state = this.state,
        props = this.props;
    var panels = [];
    var selectedItem = state.selectedItem;

    var _ref = selectedItem || {},
        caption = _ref.caption,
        title = _ref.title;

    props.nav.forEach(function (navItem, i) {
      if (navItem.children) {
        var open = state.displaySubNavPanel && (caption && caption === navItem.caption || title && title === navItem.title);
        panels.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(subnav_panel, {
          onClose: _this3.close,
          onBack: _this3.goToMainMenu,
          open: open,
          navigation: navItem,
          menuTitle: props.menuTitle,
          eidPrefix: props.eidPrefix,
          literalCaptions: props.literalCaptions,
          currentHref: props.currentHref,
          urlArgs: props.urlArgs,
          key: 'subNavPanel' + i,
          ref: function ref(r) {
            if (open) {
              _this3.subNavPanel = r;
            }
          }
        }));
      }
    });
    return panels;
  }
  /**
   * Render panel displaying nav headings if navigation menu is open
   *
   * @private
   *
   * @returns {ReactElement} div for the nav headings
   */
  ;

  _proto.renderHeadingsPanel = function renderHeadingsPanel() {
    var state = this.state,
        props = this.props;

    if (this.isBrowser) {
      var userAgent = window.navigator.userAgent;
      var iOS = userAgent.match(/iPhone|iPad/i); // iPad and iPhone user agent for Safari

      var mobileRegExp = /(iPad|iPhone).*WebKit(?:(?!(CriOS|FxiOS|OPiOS)).)*$/;
      var mobileSafariClass = mobileRegExp.test(userAgent) ? this.namespace("mobile-safari-".concat(iOS[0].toLowerCase())) : '';
      var html = this.html = this.target || document.documentElement;
      html.className = this.classNames(html.className, mobileSafariClass, babelHelpers.defineProperty({}, this.namespace('mobile-menu-open'), state.open));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('headings-panel', {
        open: !state.displaySubNavPanel && state.open
      }))
    }, this.renderTopContainer(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('mobile-wrap')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('mobile-label', 'font-primary-bold')
    }, this.renderCaption(props.menuTitle)), this.renderMobileHeadings()));
  }
  /**
   * Render panel displaying mobile nav buttons if navigation menu is open
   *
   * @private
   *
   * @returns {ReactElement} list of buttons
   */
  ;

  _proto.renderButtons = function renderButtons() {
    var state = this.state;
    var props = this.props;
    props = rip_out_default()(props, 'ariaLabel');
    var leftIcon = this.namespace('uxicon-phone');
    var leftHref = props.urls.contactUs && props.urls.contactUs.href;
    var leftA11y = props.messages[golf.callUs];
    var leftEid = enums_eids.callUs;

    if (props.showHomeLink) {
      leftIcon = this.namespace('uxicon-home');

      if (props.privateLabelId === 1) {
        if (props.isInGoCohort) {
          leftHref = props.urls.accountHome && props.urls.accountHome.href;
          leftEid = 'uxp.hyd.mobile_nav.account_home.link.click';
        } else {
          leftHref = props.urls.products && props.urls.products.href;
          leftEid = 'uxp.hyd.mobile_nav.my_products.link.click';
        }
      } else {
        leftHref = props.urls.home && props.urls.home.href;
        leftEid = 'uxp.hyd.mobile_nav.home.link.click';
      }

      leftA11y = '';
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace(this.classNames('mobile-buttons', 'list-unstyled', {
        closed: !state.open || state.displaySubNavPanel
      }))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
      ariaLabel: leftA11y,
      href: leftHref || '#',
      "data-eid": leftEid
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.classNames(this.namespace('uxicon'), leftIcon),
      "aria-hidden": "true"
    }))), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
      ariaLabel: props.messages[golf.myAccount],
      href: props.urls.account && props.urls.account.href || '#',
      "data-eid": enums_eids.myAccount
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('uxicon', 'uxicon-user'),
      "aria-hidden": "true"
    }))), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
      ariaLabel: props.messages[golf.help],
      href: props.urls.help && props.urls.help.href || '#',
      "data-eid": enums_eids.help
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('uxicon', 'uxicon-help'),
      "aria-hidden": "true"
    }))));
  }
  /**
   * Render translucent background behind the navigation menu
   *
   * @private
   *
   * @returns {ReactElement} div for the background
   */
  ;

  _proto.renderBackground = function renderBackground() {
    if (!this.state.open) {
      return null;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      onClick: this.close,
      className: this.namespace('mobile-bkg')
    });
  };

  _proto.render = function render() {
    var _this4 = this;

    var props = this.props,
        state = this.state;
    var buttonTitle;

    if (props.useActiveHeadingAsMenuTitle && props.activeHeading) {
      if (props.activeHeading.caption) {
        buttonTitle = this.renderCaption(props.activeHeading.caption);
      } else if (props.activeHeading.title) {
        buttonTitle = this.renderCaption(props.activeHeading.title, true);
      }
    }

    if (!buttonTitle) {
      buttonTitle = this.renderCaption(props.menuTitle);
    }

    var trayName = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('mobile-tray-name')
    }, props.showTitle && buttonTitle);
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.classNames(props.className, this.namespace('mobile-top-menu-item'))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: props.menuTitle
    }, function (text) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
        onClick: _this4.toggleOpen,
        className: _this4.namespace('nav-container', 'btn'),
        "aria-label": text,
        "data-eid": props.menuButtonEid
      }, !props.growthnav2 && trayName);
    }), this.renderBackground(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('mobile-navigation', {
        open: state.open
      })),
      onScroll: this.killRunway
    }, this.renderHeadingsPanel(), props.showButtons && this.renderButtons(), this.renderSubNavPanels(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('runway-container', {
        show: state.runway
      }))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('uxicon', 'uxicon-chevron-down-lt')
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('uxicon', 'uxicon-chevron-down-lt')
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('uxicon', 'uxicon-chevron-down-lt')
    })))));
  };

  return MobileNav;
}(namespace_component_["NamespaceConsumer"]);
src_MobileNav.propTypes = mobile_nav_src_objectSpread({}, namespace_component_["NamespaceShape"], {
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  growthnav2: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  nav: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object).isRequired,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  currentHref: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  menuTitle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  activeHeading: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  useActiveHeadingAsMenuTitle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  onClick: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  showHomeLink: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  literalCaptions: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  useGradientHighlightBar: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  showButtons: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  showMenuTitleOnHome: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  showTitle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  menuButtonEid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

src_MobileNav.defaultProps = {
  eidPrefix: 'uxp.hyd.mobile_nav',
  growthnav2: false,
  menuTitle: 'Shared:MobileNav:MainMenu',
  market: 'en-US',
  currentHref: '',
  showHomeLink: false,
  literalCaptions: false,
  useActiveHeadingAsMenuTitle: false,
  useGradientHighlightBar: false,
  showButtons: true,
  showMenuTitleOnHome: false,
  showTitle: true,
  onClick: function onClick() {}
};
/* harmony default export */ var mobile_nav_src = (Object(namespace_component_["withNamespace"])(src_MobileNav));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray.js
function tray_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Tray component.
 *
 * This is the actual tray that the dropdown menu opens up. It is where the
 * content of the dropdown is rendered.
 *
 * @class Tray
 * @public
 */

var tray_Tray =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Tray, _NamespaceConsumer);

  function Tray() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = Tray.prototype;

  /**
   * Render the component.
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  _proto.render = function render() {
    var _this = this;

    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.classNames(props.className, this.namespace('tray-dropdown', this.isBrowser && 'loaded')),
      ref: function ref(r) {
        _this.wrapper = r;
      }
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('tray-content')
    }, props.children));
  };

  return Tray;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_Tray.propTypes = tray_objectSpread({}, namespace_component_["NamespaceShape"], {
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/* harmony default export */ var tray = (Object(namespace_component_["withNamespace"])(tray_Tray));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-button.js
function tray_button_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_button_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_button_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_button_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];
/**
 * Tray button component.
 *
 * Tray buttons are the anchor for the tray menu, or what element is used to
 * toggle the menu open or closed.
 *
 * @class TrayButton
 * @public
 */

var tray_button_TrayButton =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(TrayButton, _NamespaceConsumer);

  function TrayButton() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.state = {
      trayToggleWidth: 0,
      caretMarginLeft: 0
    };
    return _this;
  }
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} Button.
   * @api public
   */


  var _proto = TrayButton.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var props = this.props;
    var className = props.className,
        type = props.type,
        ariaLabel = props.ariaLabel,
        onClick = props.onClick,
        children = props.children,
        traySpanClass = props.traySpanClass,
        dataAttrs = props.dataAttrs;
    var caretNode = null;

    if (props.showOpenCaret) {
      caretNode = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: this.namespace('tray-toggle-caret'),
        style: {
          marginLeft: this.state.caretMarginLeft + 'px'
        }
      });
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('tray-toggle-wrapper'),
      ref: function ref(r) {
        _this2.trayToggleWrapper = r;
      }
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, babelHelpers["extends"]({
      ariaLabel: ariaLabel,
      onClick: onClick,
      design: type,
      className: this.classNames(className, this.namespace('tray-toggle'))
    }, dataAttrs, {
      "aria-expanded": props['aria-expanded'],
      "aria-haspopup": true
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: traySpanClass
    }, children)), caretNode);
  }
  /**
   * Calculate the margin for placing the caret
   *
   * @api private
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.breakpoint.apply(this, breakpoints);
    this.calcCaretMargin();
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.breakup();
  }
  /**
   * Calculate the margin for placing the caret
   *
   * @param {Object} previousProps the props before the component updated
   * @param {Object} previousState the state before the component updated
   * @api private
   */
  ;

  _proto.componentDidUpdate = function componentDidUpdate(previousProps, previousState) {
    if (previousState.breakpoint !== this.state.breakpoint || previousState.trayToggleWidth !== this.state.trayToggleWidth) {
      this.calcCaretMargin();
    }
  }
  /**
   * Determine left margin for the caret based on the width of the tray-button
   *
   * @api private
   */
  ;

  _proto.calcCaretMargin = function calcCaretMargin() {
    var trayToggleWidth = this.getWidth(this.trayToggleWrapper);
    var caretMarginLeft = trayToggleWidth / 2 - 10;
    this.setState({
      trayToggleWidth: trayToggleWidth,
      caretMarginLeft: caretMarginLeft
    });
  }
  /**
   * Get a width for a given node
   *
   * @param {Element} element the element to measure
   * @returns {Number} the width of {element}
   * @api private
   */
  ;

  _proto.getWidth = function getWidth(element) {
    if (!element) {
      return 0;
    }

    var style = window.getComputedStyle(element) || {
      width: void 0
    };
    return parseFloat(style.width) || 0;
  };

  return TrayButton;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_button_TrayButton.propTypes = tray_button_objectSpread({}, namespace_component_["NamespaceShape"], {
  'ariaLabel': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'onClick': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func.isRequired,
  'type': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'children': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node,
  'traySpanClass': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'showOpenCaret': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'dataAttrs': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'aria-expanded': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var tray_button = (Object(namespace_component_["withNamespace"])(tray_button_TrayButton));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-close.js
function tray_close_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_close_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_close_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_close_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Tray close component.
 *
 *
 * @class TrayClose
 * @public
 */

var tray_close_TrayClose =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(TrayClose, _NamespaceConsumer);

  function TrayClose() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = TrayClose.prototype;

  /**
   * Render the component.
   *
   * @returns {React.ReactElement} close button.
   * @api public
   */
  _proto.render = function render() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      className: this.namespace('close'),
      onClick: props.onClick
    });
  };

  return TrayClose;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_close_TrayClose.propTypes = tray_close_objectSpread({}, namespace_component_["NamespaceShape"], {
  onClick: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func.isRequired
});
/* harmony default export */ var tray_close = (Object(namespace_component_["withNamespace"])(tray_close_TrayClose));
// CONCATENATED MODULE: ./node_modules/toggler/index.js
/**
 * Provides a default implementation to toggle a property. Many UI actions revolve
 * around toggling state.
 *
 * @param {Object} scope Scope of the method to work on.
 * @param {String} property Property that keeps the dropdown state.
 * @param {Function} callback Optional callback to use for both toggle states.
 * @returns {Function} event handler that switched state.
 * @api private
 */
function toggle(scope) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dropdown';
  var callback = arguments.length > 2 ? arguments[2] : undefined;

  if (arguments.length === 2 && typeof property === 'function') {
    callback = property;
    property = 'dropdown';
  }

  return function (event, done) {
    var state = scope.state || {};
    done = done || callback;

    if (typeof done !== 'function') {
      done = null;
    }

    scope.setState(babelHelpers.defineProperty({}, property, !state[property]), done);
  };
}
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-menu.js
function tray_menu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_menu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_menu_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_menu_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var tray_menu_isDataAttr = /^data-[a-zA-Z0-9-]+$/;
/**
 * Tray menu component.
 *
 * This is the primary component for using the tray menu. It defines and renders
 * the button and establishes click handlers for toggling open the menu.
 *
 * @class TrayMenu
 * @public
 */

var tray_menu_TrayMenu =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(TrayMenu, _NamespaceConsumer);

  function TrayMenu() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    var _this$props = _this.props,
        open = _this$props.open,
        onToggle = _this$props.onToggle,
        trayAlignment = _this$props.trayAlignment;
    _this.state = tray_menu_objectSpread({}, _this.state, {
      open: open || false,
      alignment: trayAlignment
    });
    _this.close = _this.close.bind(babelHelpers.assertThisInitialized(_this));
    _this.toggle = toggle(babelHelpers.assertThisInitialized(_this), 'open', function () {
      if (typeof onToggle === 'function') {
        onToggle(_this.state.open);
      }
    });
    _this.handleKeyDown = _this.handleKeyDown.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }
  /**
   * Hide the dropdown if clicks are outside the Tray itself.
   *
   * @api private
   */


  var _proto = TrayMenu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.outside('click', this.close, this.wrapperDiv);
    this.on('keydown', this.handleKeyDown);
    this.outside('focusin', this.close, this.wrapperDiv);

    if (!this.props.fullwidth && !this.state.alignment) {
      var alignment = this.getAlignment();
      this.setState(tray_menu_objectSpread({}, this.state, {
        alignment: alignment
      }));
    }
  }
  /**
   * Remove the attached click event listener.
   *
   * @api private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.off('click', this.close);
    this.off('keydown', this.handleKeyDown);
    this.off('focusin', this.close);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var open = this.state.open;
    var trayAlignment = this.props.trayAlignment;

    if (trayAlignment && trayAlignment !== prevProps.trayAlignment) {
      this.setState(tray_menu_objectSpread({}, this.state, {
        alignment: trayAlignment
      }));
    } else if (open && open !== prevState.open) {
      var alignment = this.getAlignment();

      if (alignment !== prevState.alignment) {
        this.setState(tray_menu_objectSpread({}, this.state, {
          alignment: alignment
        }));
      }
    }
  }
  /**
   * Listen for the ESC key event.
   * @param {object} e the event object sent from the browser
   * @api private
   */
  ;

  _proto.handleKeyDown = function handleKeyDown(e) {
    if (e.key && (e.key === 'Escape' || e.key === 'Esc')) {
      e.preventDefault();
      this.close();
    }
  }
  /**
   * Open the tray.
   *
   * @api public
   */
  ;

  /**
   * Close the tray.
   *
   * @api public
   */
  _proto.close = function close() {
    if (this.state.open) {
      this.toggle();
    }
  }
  /**
    * Fetches all element bounds to necessary calculations of display
    * @private
    * @returns {object} element bounds
    */
  ;

  _proto.getElementBounds = function getElementBounds() {
    // Viewport Bounds
    var viewportBounds = {
      x: window.pageXOffset,
      y: window.pageYOffset,
      width: window.innerWidth,
      height: window.innerHeight
    }; // Wrapper Div for Tray Menu

    var wrapperDivBounds = this.wrapperDiv && this.wrapperDiv.getBoundingClientRect(); // Tray Menu Element

    var menuBounds = this.trayMenuElement && this.trayMenuElement.wrapper && this.trayMenuElement.wrapper.getBoundingClientRect();
    return {
      viewportBounds: viewportBounds,
      wrapperDivBounds: wrapperDivBounds,
      menuBounds: menuBounds
    };
  }
  /**
   * Compute horizontal spacing for menu and determine whether to show aligned left or right to the tray menu.
   *
   * @returns {String|Boolean} The direction of alignment. False if neither left nor right.
   * @private
   */
  ;

  _proto.getAlignment = function getAlignment() {
    var alignment = null;

    if (!this.props.fullwidth) {
      var _this$getElementBound = this.getElementBounds(),
          wrapperDivBounds = _this$getElementBound.wrapperDivBounds,
          menuBounds = _this$getElementBound.menuBounds,
          viewportBounds = _this$getElementBound.viewportBounds;

      if (wrapperDivBounds && menuBounds) {
        var right = wrapperDivBounds.left + viewportBounds.x - window.document.documentElement.clientLeft + menuBounds.width; // The element needs to be right aligned if it's too close or outside the bounds of the viewport
        // and it it small enough to fit inside a viewport, if it's too big we'll default to left

        if (viewportBounds.width - right < 10 && menuBounds.width < viewportBounds.width) {
          alignment = 'right';
        } else {
          // otherwise align left
          alignment = 'left';
        }
      }
    }

    return alignment;
  }
  /**
   * Collects `data-*` attributes from the given object and returns them in a new object
   *
   * @param  {Object} obj The object from which data attributes are collected
   * @returns {Object} Thec colleciton of data attributes
   * @api private
   */
  ;

  _proto.collectDataAttrs = function collectDataAttrs(obj) {
    return Object.keys(obj).reduce(function (accumulator, key) {
      if (tray_menu_isDataAttr.test(key)) {
        accumulator[key] = obj[key];
      }

      return accumulator;
    }, {});
  }
  /**
   * Render the tray menu
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var props = this.props;
    var dataAttrs = this.collectDataAttrs(props);
    var _this$state = this.state,
        open = _this$state.open,
        alignment = _this$state.alignment;
    var alignMenuClass;

    if (!props.fullwidth) {
      alignMenuClass = alignment === 'left' ? 'tray-align-left' : 'tray-align-right';
    } // Don't namespace the incoming `props.className` -- the parent component should do so


    var wrapperClassNames = this.classNames(this.namespace(this.classNames('tray-menu', {
      open: open
    })), props.className);
    var trayClassNames = this.classNames(this.namespace(this.classNames(alignMenuClass, {
      'tray-fullwidth': props.fullwidth
    })));
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: wrapperClassNames,
      ref: function ref(r) {
        _this2.wrapperDiv = r;
      }
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_button, {
      type: props.type,
      "aria-expanded": open,
      ariaLabel: props.ariaLabel,
      showOpenCaret: props.showOpenCaret,
      onClick: function onClick(evt) {
        _this2.toggle(evt);
      },
      dataAttrs: dataAttrs,
      traySpanClass: props.traySpanClass
    }, props.name), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray, {
      className: trayClassNames,
      ref: function ref(r) {
        _this2.trayMenuElement = r;
      }
    }, props.showClose && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_close, {
      onClick: function onClick(evt) {
        _this2.toggle(evt);
      }
    }), props.children));
  };

  babelHelpers.createClass(TrayMenu, [{
    key: "show",
    get: function get() {
      if (!this.state.open) {
        this.toggle();
      } // This is a getter because it has to override `this.show` in `@ux/component` which is also a getter for some
      // reason. We can have the debate later about whether we should ship a breaking change here to rename this and make
      // it a method as it should be. But for now, let's at least make this getter return `undefined` since getters have
      // to return _something_


      return void 0;
    }
  }]);
  return TrayMenu;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

tray_menu_TrayMenu.propTypes = tray_menu_objectSpread({}, namespace_component_["NamespaceShape"], {
  // Arbitrary data-* tags can be passed along, e.g. data-mix, data-eid, ...
  // 'data-*': PropTypes.string,
  ariaLabel: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  type: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node.isRequired,
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node.isRequired,
  showOpenCaret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  onToggle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  fullwidth: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  showClose: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  traySpanClass: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  trayAlignment: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['left', 'right'])
});
/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */

tray_menu_TrayMenu.defaultProps = {
  fullwidth: true,
  showClose: true,
  type: 'base',
  showOpenCaret: false
};
/* harmony default export */ var tray_menu = (Object(namespace_component_["withNamespace"])(tray_menu_TrayMenu));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/tray-title.js
function tray_title_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tray_title_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tray_title_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tray_title_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
 * Tray title component.
 *
 * Tray titles are for rendering a title inside of the open tray menu.
 *
 * @class TrayTitle
 * @public
 */

var tray_title_TrayTitle =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(TrayTitle, _NamespaceConsumer);

  function TrayTitle() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = TrayTitle.prototype;

  /**
   * Render the component.
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  _proto.render = function render() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-sm-12')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('font-primary-bold', 'h3')
    }, props.children)));
  };

  return TrayTitle;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


tray_title_TrayTitle.propTypes = tray_title_objectSpread({}, namespace_component_["NamespaceShape"], {
  children: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node
});
/* harmony default export */ var tray_title = (Object(namespace_component_["withNamespace"])(tray_title_TrayTitle));
// CONCATENATED MODULE: ./node_modules/@ux/tray-menu/src/index.js






/* harmony default export */ var tray_menu_src = (tray_menu);
// CONCATENATED MODULE: ./src/nav-set.js
function nav_set_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function nav_set_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { nav_set_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { nav_set_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var nav_set_NavigationSet =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NavigationSet, _NamespaceConsumer);

  function NavigationSet(props) {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.state = nav_set_objectSpread({}, _this.state, {
      emptyNav: props.navigation.every(function (navItem) {
        return !navItem.caption;
      }),
      emptyNavRight: !props.navigationRight || props.navigationRight.every(function (navItem) {
        return !navItem.caption;
      })
    });
    return _this;
  }
  /**
   * Add eventListeners for breakpoints.
   *
   * @private
   */


  var _proto = NavigationSet.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.breakpoint('mobile', 'phablet', 'tablet', 'desktop', 'large');
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.breakup();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps) {
      this.setState({
        emptyNav: nextProps.navigation.every(function (navItem) {
          return !navItem.caption;
        }),
        emptyNavRight: !nextProps.navigationRight || nextProps.navigationRight.every(function (navItem) {
          return !navItem.caption;
        })
      });
    }
  };

  _proto.render = function render() {
    var props = this.props;
    var state = this.state;
    var navigation = props.navigation,
        navigationRight = props.navigationRight,
        navigationPosition = props.navigationPosition,
        renderMobile = props.renderMobile;
    var isNotDesktop = ['mobile', 'phablet', 'tablet'].indexOf(this.state.breakpoint) !== -1; //
    // Remark: Do NOT render the navigation server side it will cause mobile clients
    // to briefly show/flash a large or desktop rendered navigation view.
    //

    if (typeof window === 'undefined' || state.emptyNav && state.emptyNavRight) {
      return null;
    } // if renderMobile is explicitly set to false, do not render mobile


    if (isNotDesktop && !state.emptyNav && renderMobile !== false) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace("".concat(navigationPosition, "-nav-set"))
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedNavigation, babelHelpers["extends"]({}, props, {
        items: navigation,
        renderMobile: true,
        renderEmptyTitle: navigationPosition !== 'bot'
      })));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace("".concat(navigationPosition, "-nav-set"))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedNavigation, {
      items: navigation
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedNavigation, {
      items: navigationRight,
      side: "right"
    }));
  };

  return NavigationSet;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Default properties for navigation bar.
 *
 * @type {Object}
 * @api public
 */


nav_set_NavigationSet.defaultProps = {
  navigation: [],
  navigationPosition: 'bot'
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

nav_set_NavigationSet.propTypes = nav_set_objectSpread({}, namespace_component_["NamespaceShape"], {
  navigation: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array.isRequired,
  navigationRight: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  renderMobile: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  navigationPosition: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['bot', 'top'])
});
/* harmony default export */ var nav_set = (Object(namespace_component_["withNamespace"])(nav_set_NavigationSet));
// CONCATENATED MODULE: ./src/nav-bottom.js
function nav_bottom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function nav_bottom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { nav_bottom_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { nav_bottom_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var nav_bottom_isDataAttr = /^data-[a-zA-Z0-9-]+$/;
var isRelativeURL = /^\/(?:[^/]|$)/;
var absoluteURLPrefix = /^https?:\/\/[^/]*/;

var nav_bottom_Navigation =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Navigation, _NamespaceConsumer);

  function Navigation(props) {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.currentHref = _this.getCurrentHref();
    _this.renderItems = _this.renderItems.bind(babelHelpers.assertThisInitialized(_this));
    _this.setDataAttrs = _this.setDataAttrs.bind(babelHelpers.assertThisInitialized(_this));
    _this.closeNavTrays = _this.closeNavTrays.bind(babelHelpers.assertThisInitialized(_this));
    _this.onItemClick = _this.onItemClick.bind(babelHelpers.assertThisInitialized(_this));
    _this.trayMenus = Object.create(null);
    props.items.map(_this.setDataAttrs);
    return _this;
  }
  /**
   * When component gets new props, mutate `items` property using Array.map
   * @param  {object} nextProps The set of updated properties
   */


  var _proto = Navigation.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.items) {
      this.setState({
        items: nextProps.items.map(this.setDataAttrs)
      });
    }
  }
  /**
   * Close all navigation menus
   *
   * @memberof Navigation
   * @private
   */
  ;

  _proto.closeNavTrays = function closeNavTrays() {
    for (var menu in this.trayMenus) {
      // eslint-disable-line guard-for-in
      this.trayMenus[menu].close();
    }
  }
  /**
   * Function to call when clicking an item.
   *
   * @param {Object} item The item containing a custom onClick function
   * @param {Event} event The click event
   * @memberof Navigation
   * @private
   */
  ;

  _proto.onItemClick = function onItemClick(item, event) {
    if (item.onClick) {
      item.onClick(event);
    }

    this.closeNavTrays();
  }
  /**
   * Sets a dataAttrs field containing all the `data-` attributes on a given item.
   * @param  {object} item A navigation item
   * @returns {Object} The updated navigation item with a `dataAttrs` field
   * @private
   */
  ;

  _proto.setDataAttrs = function setDataAttrs(item) {
    if (!item) return;
    item.dataAttrs = Object.keys(item).reduce(function (acc, k) {
      if (nav_bottom_isDataAttr.test(k)) {
        acc[k] = item[k];
      }

      return acc;
    }, {});

    if (item.children) {
      item.children.forEach(this.setDataAttrs);
    }

    return item;
  }
  /**
   * Get the current page href for comparison of active item
   *
   * @returns {String} current href
   * @private
   */
  ;

  _proto.getCurrentHref = function getCurrentHref() {
    //
    // Logic originally from
    // https://github.secureserver.net/UX/product-nav/blob/119ebd4ffc55e41a4bfebe1c973f55de0c3e35bc/lib/product-nav.js#L37
    //
    var currentHref = this.props.currentHref;

    if (this.isBrowser) {
      currentHref = document.location.href;
    }

    if (currentHref) {
      var currentUrl = new util_["URL"](currentHref, true);
      var qsCurrentHref = currentUrl.query.currentPage;

      if (qsCurrentHref) {
        currentHref = qsCurrentHref;
      } else {
        // Remove query string for comparisons
        currentUrl.set('query', {});
        currentHref = currentUrl.href;
      }
    }

    return currentHref;
  }
  /**
   * Determine if an item is active, or if any of it's children are active.
   *
   * @param {Object} item nav item
   * @param {Boolean} [recurse=true] flag to enable recursion of children
   * @returns {Boolean} whether item is active
   * @private
   */
  ;

  _proto.isActive = function isActive(item, recurse) {
    var _this2 = this;

    if (typeof item.active === 'boolean') return item.active;
    if (item.href && item.href === this.currentHref) return true; // Handle relative URLs

    if (this.currentHref && isRelativeURL.test(item.href) && item.href === this.currentHref.replace(absoluteURLPrefix, '')) {
      return true;
    }

    if (recurse !== false && item.children) {
      return item.children.some(function (child) {
        return _this2.isActive(child);
      });
    }

    return false;
  }
  /**
   * Renders mobile navigation
   * @param  {[Object]} items The navigation items to render
   * @returns {ReactElement} an instance of MobileNav
   */
  ;

  _proto.renderMobile = function renderMobile(items) {
    var props = this.props;
    var activeHeading;

    for (var i = 0; i < items.length; i++) {
      if (this.isActive(items[i])) {
        activeHeading = items[i];
        break;
      }
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(mobile_nav_src, babelHelpers["extends"]({}, props, {
      nav: items,
      menuTitle: props.appName,
      currentHref: this.currentHref,
      activeHeading: activeHeading,
      showHomeLink: true,
      literalCaptions: true,
      useActiveHeadingAsMenuTitle: true,
      showTitle: !props.renderEmptyTitle
    }));
  }
  /**
   * Render a uxicon.
   *
   * @param {String} classname The classname corresponding to the uxicon
   * @returns {Element} Span containing a uxicon
   * @private
   */
  ;

  _proto.renderNavIcon = function renderNavIcon(classname) {
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace(classname, 'icon', 'uxicon')
    });
  }
  /**
   * Render a column of nav items. Used inside of a multi-column tray.
   * @param  {Object} item Navigation item whose children to render in a column
   * @param  {String} key The key for the heading list elements
   * @returns {Element[]} Array of list elements containing a heading and links
   */
  ;

  _proto.renderColumn = function renderColumn(item, key) {
    var _this3 = this;

    var renderMobile = this.props.renderMobile; // discard if it's mobile and mobileOnly

    if (item.mobileOnly && !renderMobile) {
      return null;
    }

    var columnItems = []; // push the heading for the column if there is one

    if (item.caption) {
      columnItems.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", babelHelpers["extends"]({
        key: key,
        className: this.namespace('heading', 'title', 'small')
      }, item.dataAttrs), item.caption, item.icon && this.renderNavIcon(item.icon)));
    } // then push the links


    var _loop = function _loop() {
      var childItem = item.children[i];

      if (childItem.mobileOnly && !renderMobile) {
        return "continue";
      }

      var classNames = _this3.classNames(item.className, _this3.namespace(_this3.classNames({
        active: _this3.isActive(childItem, false)
      })));

      var props = nav_bottom_objectSpread({
        'className': classNames,
        'target': childItem.target,
        'id': childItem.id,
        'href': childItem.href || '#',
        'data-eid': childItem.eid,
        'onClick': function onClick(e) {
          _this3.onItemClick(childItem, e);
        },
        'onClicked': _this3.closeNavTrays
      }, childItem.dataAttrs);

      columnItems.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: (childItem.caption || childItem.id) + i,
        className: childItem.className
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, props, childItem.caption, childItem.icon && _this3.renderNavIcon(childItem.icon))));
    };

    for (var i = 0; i < item.children.length; i++) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }

    return columnItems;
  }
  /**
   * Render a single nav item. Used inside of a single column tray.
   * @param  {Object} item Navigation item to render
   * @param  {String} key The key for each list element
   * @returns {Element} List element containing a @ux/link
   */
  ;

  _proto.renderSingleItem = function renderSingleItem(item, key) {
    var _this4 = this;

    if (item.mobileOnly && !this.props.renderMobile) {
      return null;
    }

    var classNames = this.classNames(item.className, this.namespace(this.classNames({
      active: this.isActive(item, false)
    })));

    var props = nav_bottom_objectSpread({
      'className': classNames,
      'target': item.target,
      'id': item.id,
      'href': item.href || '#',
      'data-eid': item.eid,
      'onClick': function onClick(e) {
        _this4.onItemClick(item, e);
      },
      'onClicked': this.closeNavTrays
    }, item.dataAttrs);

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      key: key,
      className: props.className
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, props, item.caption, item.icon && this.renderNavIcon(item.icon)));
  }
  /**
   * Create a list with all nested data structures
   * rendered appropriately.
   *
   * @param {Object} navItem the parent nav item of a collection of columns
   * @param {Boolean} multi True if the nav structure is multi-column
   * @returns {ReactElement} Columns
   * @private
   */
  ;

  _proto.renderColumns = function renderColumns(navItem, multi) {
    var _this5 = this;

    if (multi) {
      return navItem.children.map(function (child, k) {
        return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", babelHelpers["extends"]({
          key: k,
          className: _this5.namespace('list-unstyled', 'nav-column')
        }, child.dataAttrs), _this5.renderColumn(child, k));
      });
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", babelHelpers["extends"]({
      className: this.namespace('list-unstyled', 'nav-column')
    }, navItem.dataAttrs), navItem.children.map(function (child, k) {
      return _this5.renderSingleItem(child, k);
    }));
  }
  /**
   * Determines if the root navigations structure is multi- or simgle columned
   *
   * @param {Object} navItem the root node of the nav structure
   * @returns {Boolean} true if multi column
   * @private
   */
  ;

  _proto.isMultiColumn = function isMultiColumn(navItem) {
    return navItem.children && navItem.children.every(function (child) {
      return Array.isArray(child.children);
    });
  }
  /**
   * Render items that appear on the right side of the navigation
   * @param  {Object} item Object containing details of the navigation item
   * @param  {ReactElement} icon Span containing a uxicon
   * @param  {Number} i Index value
   * @returns {ReactElement} Either a button-link or a string of text
   * @private
   */
  ;

  _proto.renderNavRightItem = function renderNavRightItem(item, icon, i) {
    if (item.href) {
      var design = item.design || 'default';
      var size = 'small';
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: i,
        className: this.namespace('nav-item')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(button_default.a, babelHelpers["extends"]({
        design: design,
        size: size,
        id: item.id,
        href: item.href,
        target: item.target,
        onClick: item.onClick,
        "data-eid": item.eid
      }, item.dataAttrs), icon, item.caption));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      key: i,
      className: this.namespace('nav-item')
    }, item.caption);
  }
  /**
   * Render the navigation items
   *
   * @param {Object} item nav item
   * @param {Number} i index value
   * @returns {ReactElement} ReactElement
   * @private
   */
  ;

  _proto.renderItems = function renderItems(item, i) {
    var _this6 = this;

    // discard if it's mobile and mobileOnly
    if (item.mobileOnly && !this.props.renderMobile) {
      return null;
    }

    var isActive = this.isActive(item);
    var classNames = this.namespace(this.classNames('nav-item', {
      active: isActive
    }));
    var icon;

    if (item.icon) {
      icon = this.renderNavIcon(item.icon);
    } //
    // Render a tray-menu if the current item has children regardless of side
    //


    if (item.children && item.children.length) {
      var multiColumn = this.isMultiColumn(item);
      var columns = this.renderColumns(item, multiColumn);
      var trayTitle = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('tray-title')
      }, item.caption, icon);
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        className: classNames,
        key: i
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_menu, babelHelpers["extends"]({
        ref: function ref(r) {
          _this6.trayMenus[i] = r;
        },
        className: this.namespace(this.classNames({
          'multi-col': multiColumn
        })),
        showOpenCaret: true,
        name: trayTitle,
        "data-eid": item.eid,
        fullwidth: false,
        showClose: false
      }, item.dataAttrs), trayTitle, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('flex-columns')
      }, columns)));
    } // if no children, handle rendering for right side


    if (this.props.side === 'right') {
      return this.renderNavRightItem(item, icon, i);
    } // handle render for left side


    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      key: i,
      className: classNames
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
      className: this.namespace('nav-link', 'font-base'),
      id: item.id,
      href: item.href,
      target: item.target,
      onClick: item.onClick,
      "data-eid": item.eid
    }, item.dataAttrs), item.caption, icon));
  }
  /**
   * Render the navigation component
   *
   * @returns {ReactElement} ReactElement
   */
  ;

  _proto.render = function render() {
    var props = this.props;
    var items = props.items;

    if (!items.length) {
      return null;
    }

    if (props.renderMobile) {
      return this.renderMobile(items);
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('nav', "nav-".concat(props.side))
    }, items.map(this.renderItems));
  };

  return Navigation;
}(namespace_component_["NamespaceConsumer"]);

nav_bottom_Navigation.defaultProps = {
  side: 'left',
  renderEmptyTitle: false,
  items: []
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

nav_bottom_Navigation.propTypes = nav_bottom_objectSpread({}, namespace_component_["NamespaceShape"], {
  items: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  side: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  renderMobile: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  renderEmptyTitle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
var NamespacedNavigation = Object(namespace_component_["withNamespace"])(nav_bottom_Navigation);

var nav_bottom_NavigationBottom =
/*#__PURE__*/
function (_NamespaceConsumer2) {
  babelHelpers.inheritsLoose(NavigationBottom, _NamespaceConsumer2);

  function NavigationBottom() {
    return _NamespaceConsumer2.apply(this, arguments) || this;
  }

  var _proto2 = NavigationBottom.prototype;

  _proto2.render = function render() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("nav", {
      className: this.namespace('nav-bottom', 'clearfix')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(nav_set, props))));
  };

  return NavigationBottom;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Helper to update navigations (regular or right sided). Clones object or arrays
 * to ensure setState is done against a new object in memory.
 *
 * @param {Array|Object} nav Updated navigation, can be navigation array or object.
 * @param {Boolean} right Optionally update right side navigation, defaults to regular.
 * @param {Function} done Optional completion callback.
 * @returns {Self} fluent interface.
 * @api public
 */


nav_bottom_NavigationBottom.update = function update(nav) {
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var done = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (typeof right === 'function') {
    done = right;
    right = false;
  }

  var navs = ['navigation', 'navigationRight'];
  var prop = navs[+right];

  if (Array.isArray(nav)) {
    return this.setState(babelHelpers.defineProperty({}, prop, nav.slice()), done);
  }

  return this.setState(navs.reduce(function (memo, key) {
    if (Array.isArray(nav[key])) {
      memo[key] = nav[key].slice();
    }

    return memo;
  }, {}), done);
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */


var rightNavPropTypes = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  'blacklist': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'whitelist': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'caption': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'data-mix': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'disposition': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'eid': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'href': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'children': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  'design': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOf(['purchase', 'primary', 'default'])
});
nav_bottom_NavigationBottom.propTypes = nav_bottom_objectSpread({}, namespace_component_["NamespaceShape"], {
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  navigation: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array.isRequired,
  navigationRight: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(rightNavPropTypes)
});

/* harmony default export */ var nav_bottom = (Object(namespace_component_["withNamespace"])(nav_bottom_NavigationBottom));
// CONCATENATED MODULE: ./src/enums.js
 //
// Define the breakpoints the manifest need to listen to.
//

var enums_breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large']; //
// Golf translation ids.
//

var enums_golf = {
  'accountSettings': 'PC:AppHeader:Header:AccountSettings',
  'accountLabel': 'PC:AppHeader:Header:AccountLabel',
  'closeMenu': 'Shared:UtilityBar:Close',
  'products': 'PC:AppHeader:Header:MyProducts',
  'accountHome': 'PC:AppHeader:Header:MyAccountHome',
  'account': 'PC:AppHeader:Header:Account',
  'resources': 'PC:AppHeader:Header:Resources',
  'phoneNumbersHours': 'PC:AppHeader:Header:PhoneNumberHours',
  'shopGD': 'PC:AppHeader:Header:ShopGD',
  'renewals': 'PC:AppHeader:Header:MyRenewals',
  'pro': 'PC:AppHeader:Header:ProDashboard',
  'login': 'PC:AppHeader:Header:Login',
  'logout': 'PC:AppHeader:Header:Logout',
  'policy': 'PC:AppHeader:Footer:PrivacyPolicy',
  'shopperid': 'PC:AppHeader:Header:CustomerNumber',
  'menu': 'PC:AppHeader:Header:ActiveSubMenuDefault',
  'pinLabel': 'Shared:AccountTray:CustomerPinLabel',
  'resetPin': 'Shared:UtilityBar:AccountTray:ResetPin',
  'viewPin': 'Shared:UtilityBar:AccountTray:ViewPin',
  'vip': 'PC:AppHeader:Header:VipRepName',
  'title': 'PC:AppHeader:Header:usermenu-title',
  'internalModeTitle': 'PC:AppHeader:Header:MyAccount',
  'inApp': 'Shared:Help:InAppTitle',
  'goDaddyGuides': 'Shared:HelpByGoDaddyGuides',
  'notifications': {
    headerText: 'Shared:UtilityBar:Notifications:HeaderText',
    failedNotificationsTitle: 'Shared:UtilityBar:Notifications:FailedNotificationsTitle',
    failedNotificationsText: 'Shared:UtilityBar:Notifications:FailedNotificationsText',
    failedNotificationsLink: 'Shared:UtilityBar:Notifications:FailedNotificationsLink',
    noNotificationsTitle: 'Shared:UtilityBar:Notifications:NoNotificationsTitle',
    noNotificationsText: 'Shared:UtilityBar:Notifications:NoNotificationsText'
  },
  'username': 'Shared:UtilityBar:LoginForm:Username',
  'proRewardPoints': 'PC:AppHeader:Header:RewardPoints',
  'ssl': 'PC:AppHeader:Header:product_ssl',
  'domains': 'PC:AppHeader:Header:product_domains',
  'hosting': 'PC:AppHeader:Header:product_hosting',
  'email': 'PC:AppHeader:Header:product_email',
  'websites': 'PC:AppHeader:Header:product_websites',
  'email-office': 'PC:AppHeader:Header:product_email-office',
  'hosting-wordpress': 'PC:AppHeader:Header:product_hosting-wordpress',
  'home': 'PC:AppHeader:Header:Home',
  'manage-my-products': 'PC:AppHeader:Header:ManageMyProducts'
}; //
// Generate Traffic2 eid's to be used to track clicks. Map the generated
// strings back to the same keys the Golf translations strings have.
//

var src_enums_eids = Object.keys(enums_golf).reduce(function (acc, key) {
  acc[key] = golf_to_eid_default()(enums_golf[key], {
    prefix: 'uxp.hyd.app_header',
    postfix: 'link.click'
  });
  return acc;
}, {});

// EXTERNAL MODULE: ./node_modules/@ux/order-confirmation/src/index.js
var order_confirmation_src = __webpack_require__("./node_modules/@ux/order-confirmation/src/index.js");

// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/shapes.js

var string = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
    node = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node,
    array = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array;
var shapes_sso = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  login: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired
  }).isRequired
});
var shapes_link = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  href: string,
  title: string
});
var shapes_eids = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  click: string,
  impression: string
});
var shapes_messages = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  noNotificationsTitle: node.isRequired,
  noNotificationsText: node.isRequired,
  headerText: node.isRequired,
  failedNotificationsTitle: node.isRequired,
  failedNotificationsText: node.isRequired,
  failedNotificationsLink: node.isRequired
});
var shapes_notification = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  title: string.isRequired,
  content: string.isRequired,
  priority: string.isRequired,
  eids: shapes_eids,
  actions: array
});
var shapes = {
  sso: shapes_sso,
  link: shapes_link,
  eids: shapes_eids,
  messages: shapes_messages,
  notification: shapes_notification
};

// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/cache.js


function isValid(cache, shopperId, market) {
  return cache && cache.shopperId && cache.shopperId === shopperId && cache.market && cache.market === market && cache.timestamp && Date.now() - cache.timestamp < 1000 * 60 * 60 * 24; // 24 hours
}

var cacheSet = 'Notification_Set';
var cacheReq = 'Notification_Req';
var cacheRecv = 'Notification_Get';
var header = 'notify:';
var iframeCache = null;
var getCacheTimer = null;
var getCacheHandler = null;

function initCache(iframeCacheUrl, iframeClasses) {
  iframeCache = document.createElement('iframe');
  iframeCache.src = iframeCacheUrl;
  iframeCache.className = iframeClasses; // backwards compatibility with eldorado

  iframeCache.id = 'notificationCacheFrame';
  document.body.appendChild(iframeCache);
}

function postMessage(obj) {
  if (iframeCache && iframeCache.contentWindow) {
    iframeCache.contentWindow.postMessage(header + JSON.stringify(obj), '*');
  }
}

function deserializeMessage(msg) {
  if (babelHelpers["typeof"](msg) === 'object') {
    return msg;
  } else if (typeof msg === 'string' && msg.substr(0, header.length) === header) {
    return JSON.parse(msg.substr(header.length));
  }
}

function setCache(setObj) {
  postMessage({
    type: cacheSet,
    payload: setObj
  });
}

function getCache(successCb, errorCb) {
  var timeoutCount = 0;
  getCacheTimer = setTimeout(function cacheTimeout() {
    if (timeoutCount < 1) {
      timeoutCount++;
      postMessage({
        type: cacheReq
      });
      getCacheTimer = setTimeout(cacheTimeout, 1000);
      return;
    }

    getCacheCleanup();
    errorCb();
  }, 1000);

  getCacheHandler = function getCacheHandler(e) {
    getCacheCleanup();
    var data = deserializeMessage(e.data);

    if (data && data.type === cacheRecv) {
      return successCb(data.payload);
    }

    errorCb();
  };

  window.addEventListener('message', getCacheHandler, false);
}

function getCacheCleanup() {
  if (getCacheTimer) {
    clearTimeout(getCacheTimer);
    getCacheTimer = null;
  }

  if (getCacheHandler) {
    window.removeEventListener('message', getCacheHandler);
    getCacheHandler = null;
  }
} // eslint-disable-next-line max-params


function requestNotifications(href, privateLabelId, shopperId, market, successCb, errorCb) {
  util_["request"].get(href, {
    headers: {
      'Content-Type': 'application/json',
      'X-App-Key': 'customerexperience'
    }
  }, function notifCacheResponseHandler(error, notifications) {
    if (error || !Array.isArray(notifications)) {
      return errorCb(error || new Error("expected an array but got ".concat(notifications)));
    }

    var response = {
      notifications: notifications,
      shopperId: shopperId,
      market: market,
      timestamp: Date.now()
    };
    setCache(response);
    successCb(response);
  });
} // eslint-disable-next-line max-params


function cache_get(cache, iframeClasses, api, privateLabelId, shopperId, market, successCb, errorCb) {
  function cacheGetError() {
    requestNotifications(api.href, privateLabelId, shopperId, market, successCb, errorCb);
  }

  function cacheGetSuccess(obj) {
    if (isValid(obj, shopperId, market)) {
      successCb(obj);
      return;
    }

    cacheGetError();
  }

  getCache(cacheGetSuccess, cacheGetError); // The cache sends its notifications as soon as it loads, so do this *after* setting up the cache receive handlers in getCache

  if (!iframeCache) {
    initCache(cache, iframeClasses);
  }
}
function cache_reset() {
  if (iframeCache) {
    iframeCache.parentNode.removeChild(iframeCache);
    iframeCache = null;
  }

  getCacheCleanup();
}
// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/badge.js
function badge_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function badge_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { badge_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { badge_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var badge_NotificationBadge =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationBadge, _NamespaceConsumer);

  function NotificationBadge() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = NotificationBadge.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        showCount = _this$props.showCount,
        count = _this$props.count,
        tooltip = _this$props.tooltip,
        _this$props$messages = _this$props.messages,
        messages = _this$props$messages === void 0 ? {} : _this$props$messages;
    var bellClasses = this.classNames(this.namespace('btn', 'dropdown-toggle'), this.namespace(this.classNames({
      'notifications-mini-bell': showCount && count,
      'notifications-bell': !showCount || !count,
      'no-count': !showCount
    })));
    var messagesLabel = tooltip || messages.headerText;

    if (showCount && count > 0) {
      var badgeClasses = this.namespace('notifications-badge', 'font-primary-bold');
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
        "aria-label": messagesLabel,
        className: bellClasses,
        title: tooltip,
        type: "button"
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: badgeClasses
      }, count));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      "aria-label": messagesLabel,
      className: bellClasses,
      title: tooltip,
      type: "button"
    });
  };

  return NotificationBadge;
}(namespace_component_["NamespaceConsumer"]);

badge_NotificationBadge.propTypes = badge_objectSpread({}, namespace_component_["NamespaceShape"], {
  tooltip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  messages: shapes.messages
});
/* harmony default export */ var src_badge = (Object(namespace_component_["withNamespace"])(badge_NotificationBadge));
// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/list-empty.js
function list_empty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function list_empty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { list_empty_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { list_empty_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var list_empty_NotificationsEmpty =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationsEmpty, _NamespaceConsumer);

  function NotificationsEmpty() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = NotificationsEmpty.prototype;

  _proto.render = function render() {
    var failed = this.props.failed;

    if (failed) {
      var _this$props = this.props,
          sso = _this$props.sso,
          _this$props$messages = _this$props.messages,
          failedNotificationsTitle = _this$props$messages.failedNotificationsTitle,
          failedNotificationsText = _this$props$messages.failedNotificationsText,
          failedNotificationsLink = _this$props$messages.failedNotificationsLink;

      var _classes = this.namespace('notifications-list-empty', 'notifications-session-alert');

      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        className: _classes
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, failedNotificationsTitle), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, failedNotificationsText), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", sso.login, failedNotificationsLink));
    }

    var _this$props$messages2 = this.props.messages,
        noNotificationsTitle = _this$props$messages2.noNotificationsTitle,
        noNotificationsText = _this$props$messages2.noNotificationsText;
    var classes = this.namespace('notifications-list-empty', 'notifications-alert');
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: classes
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, noNotificationsTitle), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('no-notifications-text')
    }, noNotificationsText));
  };

  return NotificationsEmpty;
}(namespace_component_["NamespaceConsumer"]);

list_empty_NotificationsEmpty.propTypes = list_empty_objectSpread({}, namespace_component_["NamespaceShape"], {
  sso: shapes.sso.isRequired,
  messages: shapes.messages.isRequired,
  failed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var list_empty = (Object(namespace_component_["withNamespace"])(list_empty_NotificationsEmpty));
// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/list-item.js
function list_item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function list_item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { list_item_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { list_item_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var list_item_NotificationListItem =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationListItem, _NamespaceConsumer);

  function NotificationListItem() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.renderNotificationLink = _this.renderNotificationLink.bind(babelHelpers.assertThisInitialized(_this));
    _this.renderStaticNotification = _this.renderStaticNotification.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  var _proto = NotificationListItem.prototype;

  _proto.renderNotificationLink = function renderNotificationLink(notification, href, classes) {
    var content = notification.content,
        eids = notification.eids;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
      "data-eid": eids && eids.click,
      className: classes
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, content));
  };

  _proto.renderStaticNotification = function renderStaticNotification(notification, classes) {
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.classNames(classes, this.namespace('no-link'))
    }, notification.content);
  };

  _proto.render = function render() {
    var notification = this.props.notification;
    var priority = notification.priority,
        subcategory = notification.subcategory;
    var type = subcategory === 'FailedBilling' ? 'creditCardExpiration' : '';
    var priorityClassMap = {
      Medium: 'medium',
      High: 'high'
    };
    var priorityClass = priorityClassMap[priority] || '';
    var priorityLabelClassName = this.namespace('priority', priorityClass, type);
    var classes = this.namespace('notifications-list-item', 'font-base');
    var link = notification.link;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: classes
    }, link ? this.renderNotificationLink(notification, link, priorityLabelClassName) : this.renderStaticNotification(notification, priorityLabelClassName));
  };

  return NotificationListItem;
}(namespace_component_["NamespaceConsumer"]);

list_item_NotificationListItem.propTypes = list_item_objectSpread({}, namespace_component_["NamespaceShape"], {
  notification: shapes.notification.isRequired
});
/* harmony default export */ var list_item = (Object(namespace_component_["withNamespace"])(list_item_NotificationListItem));
// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/list.js
function list_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function list_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { list_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { list_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var list_NotificationList =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationList, _NamespaceConsumer);

  function NotificationList() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = NotificationList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        failed = _this$props.failed,
        notifications = _this$props.notifications,
        sso = _this$props.sso,
        messages = _this$props.messages,
        closeList = _this$props.closeList;

    function stopPropagation(e) {
      e.stopPropagation();
    }

    var classes = this.namespace('notifications-list', 'dropdown-menu');
    var closeIconClasses = this.namespace('notifications-close', 'close');
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: classes,
      onClick: stopPropagation
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      className: closeIconClasses,
      onClick: closeList
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("h4", {
      className: this.namespace('notifications-list-header')
    }, messages.headerText), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('notifications-list-items')
    }, notifications && notifications.length > 0 ? notifications.map(function (n, c) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(list_item, {
        key: c,
        notification: n
      });
    }) : external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(list_empty, {
      failed: failed,
      messages: messages,
      sso: sso
    })));
  };

  return NotificationList;
}(namespace_component_["NamespaceConsumer"]);

list_NotificationList.propTypes = list_objectSpread({}, namespace_component_["NamespaceShape"], {
  sso: shapes.sso.isRequired,
  messages: shapes.messages.isRequired,
  notifications: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(shapes.notification),
  closeList: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  failed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var list = (Object(namespace_component_["withNamespace"])(list_NotificationList));
// CONCATENATED MODULE: ./node_modules/@ux/notifications/src/index.js
function notifications_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function notifications_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { notifications_src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { notifications_src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var trfqEventDesc = 'click';
var src_Notifications =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Notifications, _NamespaceConsumer);

  function Notifications(props) {
    var _this;

    _this = _NamespaceConsumer.call(this, props) || this;
    _this.openList = _this.openList.bind(babelHelpers.assertThisInitialized(_this));
    _this.closeList = _this.closeList.bind(babelHelpers.assertThisInitialized(_this));
    _this.toggleList = _this.toggleList.bind(babelHelpers.assertThisInitialized(_this));
    _this.generateEid = _this.generateEid.bind(babelHelpers.assertThisInitialized(_this)); // A reference to the trigger function that wraps the click handler. We keep a reference
    // to it so we can unbind the event later, when the component unmounts.

    _this.clickEventTrigger = null;
    _this._isMounted = true;
    return _this;
  }

  var _proto = Notifications.prototype;

  _proto.dismiss = function dismiss() {
    if (!this._isMounted) return;
    this.setState({
      dismissed: true
    });
    util_["cookie"].set('notificationsDismissed', true, {
      domain: '.' + new util_["URL"]().domain(1)
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.off('click', this.clickEventTrigger);
    this._isMounted = false;
  };

  _proto.openList = function openList(event) {
    event.preventDefault();
    var isLoaded = this.state.isLoaded;

    if (!isLoaded || !this._isMounted) {
      return;
    }

    this.setState({
      isOpen: true
    }, function badgeOpened() {
      this.bellClickLogImpressions();
      this.dismiss();
    }.bind(this));
  };

  _proto.closeList = function closeList() {
    var isLoaded = this.state.isLoaded;

    if (!isLoaded || !this._isMounted) {
      return;
    }

    this.setState({
      isOpen: false
    });
  };

  _proto.toggleList = function toggleList(e) {
    var isOpen = this.state.isOpen;
    var openList = this.openList,
        closeList = this.closeList;
    isOpen ? closeList(e) : openList(e);
  };

  _proto.generateEid = function generateEid(suffix) {
    var manifest = this.props.manifest.toLowerCase();
    return "uxp.hyd.".concat(manifest, ".").concat(suffix);
  };

  _proto.bellClickLogImpressions = function bellClickLogImpressions() {
    var eid = this.generateEid('notifications.unseencounterbell.click');
    var _this$state = this.state,
        notifications = _this$state.notifications,
        dismissed = _this$state.dismissed;

    if (notifications && notifications.length > 0) {
      if (dismissed) {
        eid = this.generateEid('notifications.seencounterbell.click');
      }

      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eid, trfqEventDesc);
      notifications.forEach(function (n) {
        if (n.eids && n.eids.impression) {
          external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logImpression(n.eids.impression);
        }
      });
    } else {
      eid = this.generateEid('notifications.emptybell.click');
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eid, trfqEventDesc);
    }
  };

  _proto.notesLoadLogImpressions = function notesLoadLogImpressions() {
    var eid = this.generateEid('notifications.emptybell.impression');
    var _this$state2 = this.state,
        notifications = _this$state2.notifications,
        dismissed = _this$state2.dismissed;

    if (notifications && notifications.length > 0) {
      if (dismissed) {
        eid = this.generateEid('notifications.seencounterbell.impression');
      } else {
        eid = this.generateEid('notifications.unseencounterbell.impression');
      }
    }

    external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logImpression(eid);
  };

  _proto.componentDidMount = function componentDidMount() {
    var props = this.props;
    var endpoint = props.endpoint,
        privateLabelId = props.privateLabelId,
        shopperId = props.shopperId,
        market = props.market;
    var dismissed = util_["cookie"].get('notificationsDismissed') === 'true';
    this.clickEventTrigger = this.outside('click', this.closeList, this.domNode);
    cache_get(props.cache.href, this.namespace('notification-cache'), endpoint, privateLabelId, shopperId, market, function notifRequestSuccess(response) {
      if (!this._isMounted) return;
      var notifications = response.notifications;
      this.setState({
        isLoaded: true,
        isOpen: false,
        notifications: notifications,
        dismissed: dismissed
      });
      this.notesLoadLogImpressions();
    }.bind(this), function notifRequestFailed() {
      if (!this._isMounted) return;
      this.setState({
        failed: true,
        isLoaded: true,
        dismissed: dismissed
      });
    }.bind(this));
  };

  _proto.renderCaret = function renderCaret() {
    return this.props.showOpenCaret && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('caret')
    });
  };

  _proto.renderNotificationList = function renderNotificationList() {
    var closeList = this.closeList;
    var _this$props = this.props,
        sso = _this$props.sso,
        messages = _this$props.messages;
    var _this$state3 = this.state,
        failed = _this$state3.failed,
        notifications = _this$state3.notifications;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, this.renderCaret(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(list, {
      failed: failed,
      notifications: notifications,
      messages: messages,
      sso: sso,
      closeList: closeList
    }));
  };

  _proto.render = function render() {
    var _this$classNames;

    var toggleList = this.toggleList;
    var _this$props2 = this.props,
        className = _this$props2.className,
        sso = _this$props2.sso,
        messages = _this$props2.messages,
        tooltip = _this$props2.tooltip,
        showCount = _this$props2.showCount;
    var _this$state4 = this.state,
        isOpen = _this$state4.isOpen,
        notifications = _this$state4.notifications,
        isLoaded = _this$state4.isLoaded;

    var refHandler = function refHandler(domNode) {
      this.domNode = domNode;
    }.bind(this);

    var classes = this.classNames(className, this.namespace('notifications', 'dropdown'), (_this$classNames = {}, babelHelpers.defineProperty(_this$classNames, this.namespace('open'), isOpen), babelHelpers.defineProperty(_this$classNames, this.namespace('loaded'), isLoaded), babelHelpers.defineProperty(_this$classNames, this.namespace('has-notifications'), notifications && notifications.length > 0 && sso), _this$classNames));
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      ref: refHandler,
      className: classes,
      onClick: toggleList
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_badge, {
      messages: messages,
      showCount: showCount,
      count: notifications && notifications.length,
      tooltip: tooltip
    }), isOpen && this.renderNotificationList());
  };

  return Notifications;
}(namespace_component_["NamespaceConsumer"]);
src_Notifications.defaultProps = {
  showOpenCaret: false,
  showCount: true
};
src_Notifications.propTypes = notifications_src_objectSpread({}, namespace_component_["NamespaceShape"], {
  manifest: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  cache: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired
  }).isRequired,
  endpoint: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired
  }).isRequired,
  sso: shapes.sso.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: shapes.messages.isRequired,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  tooltip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  showOpenCaret: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  showCount: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var notifications_src = (Object(namespace_component_["withNamespace"])(src_Notifications));
function Container(props) {
  var namespace = props.namespace,
      rest = babelHelpers.objectWithoutProperties(props, ["namespace"]);
  return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceProvider"], {
    namespace: namespace
  }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_Notifications, rest));
}
Container.propTypes = {
  namespace: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
};
// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/shapes.js

var shapes_string = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
    shapes_node = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.node;
var src_shapes_sso = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  login: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired
  }).isRequired
});
var src_shapes_link = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  href: shapes_string,
  title: shapes_string
});
var src_shapes_eids = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  click: shapes_string,
  impression: shapes_string
});
var src_shapes_messages = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  noNotificationsTitle: shapes_node.isRequired,
  noNotificationsText: shapes_node.isRequired,
  headerText: shapes_node.isRequired,
  failedNotificationsTitle: shapes_node.isRequired,
  failedNotificationsText: shapes_node.isRequired,
  failedNotificationsLink: shapes_node.isRequired
});
var src_shapes_notification = external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
  title: shapes_string.isRequired,
  text: shapes_string.isRequired,
  severity: shapes_string.isRequired,
  eids: src_shapes_eids,
  _links: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    resolve: src_shapes_link
  }).isRequired
});
var shapes_shapes = {
  sso: src_shapes_sso,
  link: src_shapes_link,
  eids: src_shapes_eids,
  messages: src_shapes_messages,
  notification: src_shapes_notification
};

// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/cache.js


function cache_isValid(cache, shopperId, market) {
  return cache && cache.shopperId && cache.shopperId === shopperId && cache.market && cache.market === market && cache.timestamp && Date.now() - cache.timestamp < 1000 * 60 * 60 * 24; // 24 hours
}

var cache_cacheSet = 'Notification_Set';
var cache_cacheReq = 'Notification_Req';
var cache_cacheRecv = 'Notification_Get';
var cache_header = 'notify:';
var cache_iframeCache = null;
var cache_getCacheTimer = null;
var cache_getCacheHandler = null;

function cache_initCache(iframeCacheUrl, iframeClasses) {
  cache_iframeCache = document.createElement('iframe');
  cache_iframeCache.src = iframeCacheUrl;
  cache_iframeCache.className = iframeClasses; // backwards compatibility with eldorado

  cache_iframeCache.id = 'notificationCacheFrame';
  document.body.appendChild(cache_iframeCache);
}

function cache_postMessage(obj) {
  if (cache_iframeCache && cache_iframeCache.contentWindow) {
    cache_iframeCache.contentWindow.postMessage(cache_header + JSON.stringify(obj), '*');
  }
}

function cache_deserializeMessage(msg) {
  if (babelHelpers["typeof"](msg) === 'object') {
    return msg;
  } else if (typeof msg === 'string' && msg.substr(0, cache_header.length) === cache_header) {
    return JSON.parse(msg.substr(cache_header.length));
  }
}

function cache_setCache(setObj) {
  cache_postMessage({
    type: cache_cacheSet,
    payload: setObj
  });
}

function cache_getCache(successCb, errorCb) {
  var timeoutCount = 0;
  cache_getCacheTimer = setTimeout(function cacheTimeout() {
    if (timeoutCount < 1) {
      timeoutCount++;
      cache_postMessage({
        type: cache_cacheReq
      });
      cache_getCacheTimer = setTimeout(cacheTimeout, 1000);
      return;
    }

    cache_getCacheCleanup();
    errorCb();
  }, 1000);

  cache_getCacheHandler = function getCacheHandler(e) {
    cache_getCacheCleanup();
    var data = cache_deserializeMessage(e.data);

    if (data && data.type === cache_cacheRecv) {
      return successCb(data.payload);
    }

    errorCb();
  };

  window.addEventListener('message', cache_getCacheHandler, false);
}

function cache_getCacheCleanup() {
  if (cache_getCacheTimer) {
    clearTimeout(cache_getCacheTimer);
    cache_getCacheTimer = null;
  }

  if (cache_getCacheHandler) {
    window.removeEventListener('message', cache_getCacheHandler);
    cache_getCacheHandler = null;
  }
} // eslint-disable-next-line max-params


function cache_requestNotifications(href, privateLabelId, shopperId, market, successCb, errorCb) {
  util_["request"].get(href, {
    query: {
      plId: privateLabelId
    }
  }, function notifCacheResponseHandler(error, response) {
    if (error) {
      return errorCb(error);
    }

    function replaceEid(value) {
      return value.replace('mya.products.account_header', 'globalheader.notifications');
    }

    response.notifications.map(function (item) {
      if (!('eids' in item)) {
        return;
      }

      if ('impression' in item.eids) {
        item.eids.impression = replaceEid(item.eids.impression);
      }

      if ('click' in item.eids) {
        item.eids.click = replaceEid(item.eids.click);
      }
    });
    response.shopperId = shopperId;
    response.market = market;
    response.timestamp = Date.now();
    cache_setCache(response);
    successCb(response);
  });
} // eslint-disable-next-line max-params


function src_cache_get(cache, iframeClasses, api, privateLabelId, shopperId, market, successCb, errorCb) {
  function cacheGetError() {
    cache_requestNotifications(api.href, privateLabelId, shopperId, market, successCb, errorCb);
  }

  function cacheGetSuccess(obj) {
    if (cache_isValid(obj, shopperId, market)) {
      successCb(obj);
      return;
    }

    cacheGetError();
  }

  cache_getCache(cacheGetSuccess, cacheGetError); // The cache sends its notifications as soon as it loads, so do this *after* setting up the cache receive handlers in getCache

  if (!cache_iframeCache) {
    cache_initCache(cache, iframeClasses);
  }
}
function src_cache_reset() {
  if (cache_iframeCache) {
    cache_iframeCache.parentNode.removeChild(cache_iframeCache);
    cache_iframeCache = null;
  }

  cache_getCacheCleanup();
}
// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/badge.js
function src_badge_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_badge_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_badge_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_badge_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var src_badge_NotificationBadge =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationBadge, _NamespaceConsumer);

  function NotificationBadge() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = NotificationBadge.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        count = _this$props.count,
        severity = _this$props.severity,
        dismissed = _this$props.dismissed,
        tooltip = _this$props.tooltip,
        _this$props$messages = _this$props.messages,
        messages = _this$props$messages === void 0 ? {} : _this$props$messages;
    var bellClasses = this.classNames(this.namespace('btn', 'dropdown-toggle'), this.namespace(this.classNames({
      'notifications-mini-bell': count,
      'notifications-bell': !count
    })));
    var messagesLabel = tooltip || messages.headerText;

    if (count > 0) {
      var badgeClasses = this.classNames(this.namespace('notifications-badge', 'font-primary-bold'), this.namespace(this.classNames(babelHelpers.defineProperty({
        dismissed: dismissed
      }, severity, !dismissed))) // backwards compatibility with eldorado
      );
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
        "aria-label": messagesLabel,
        className: bellClasses,
        title: tooltip,
        type: "button"
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: badgeClasses
      }, count));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      "aria-label": messagesLabel,
      className: bellClasses,
      title: tooltip,
      type: "button"
    });
  };

  return NotificationBadge;
}(namespace_component_["NamespaceConsumer"]);

src_badge_NotificationBadge.propTypes = src_badge_objectSpread({}, namespace_component_["NamespaceShape"], {
  count: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  severity: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  dismissed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  tooltip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  messages: shapes_shapes.messages
});
src_badge_NotificationBadge.defaultProps = {
  count: 0,
  severity: 'none'
};
/* harmony default export */ var notifs_v1_src_badge = (Object(namespace_component_["withNamespace"])(src_badge_NotificationBadge));
// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/list-empty.js
function src_list_empty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_list_empty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_list_empty_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_list_empty_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var src_list_empty_NotificationsEmpty =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationsEmpty, _NamespaceConsumer);

  function NotificationsEmpty() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = NotificationsEmpty.prototype;

  _proto.render = function render() {
    var failed = this.props.failed;

    if (failed) {
      var _this$props = this.props,
          sso = _this$props.sso,
          _this$props$messages = _this$props.messages,
          failedNotificationsTitle = _this$props$messages.failedNotificationsTitle,
          failedNotificationsText = _this$props$messages.failedNotificationsText,
          failedNotificationsLink = _this$props$messages.failedNotificationsLink;

      var _classes = this.namespace('notifications-list-empty', 'notifications-session-alert');

      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        className: _classes
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, failedNotificationsTitle), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, failedNotificationsText), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", sso.login, failedNotificationsLink));
    }

    var _this$props$messages2 = this.props.messages,
        noNotificationsTitle = _this$props$messages2.noNotificationsTitle,
        noNotificationsText = _this$props$messages2.noNotificationsText;
    var classes = this.namespace('notifications-list-empty', 'notifications-alert');
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: classes
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("strong", null, noNotificationsTitle), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('no-notifications-text')
    }, noNotificationsText));
  };

  return NotificationsEmpty;
}(namespace_component_["NamespaceConsumer"]);

src_list_empty_NotificationsEmpty.propTypes = src_list_empty_objectSpread({}, namespace_component_["NamespaceShape"], {
  sso: shapes_shapes.sso.isRequired,
  messages: shapes_shapes.messages.isRequired,
  failed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var src_list_empty = (Object(namespace_component_["withNamespace"])(src_list_empty_NotificationsEmpty));
// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/list-item.js
function src_list_item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_list_item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_list_item_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_list_item_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var list_item_trfqEventDesc = 'click';

var src_list_item_NotificationListItem =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationListItem, _NamespaceConsumer);

  function NotificationListItem() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.onNotificationClick = _this.onNotificationClick.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  var _proto = NotificationListItem.prototype;

  _proto.onNotificationClick = function onNotificationClick(e) {
    var _this$props$notificat = this.props.notification,
        eids = _this$props$notificat.eids,
        link = _this$props$notificat._links;
    var href = link.resolve.href;

    if (eids && eids.click) {
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eids.click, list_item_trfqEventDesc, {}, e);
    }

    if (href) {
      setTimeout(function notificationNavigate() {
        window.open(href, '_blank');
      }, 100);
    }
  };

  _proto.render = function render() {
    var notification = this.props.notification;
    var href = notification._links.resolve.href;
    var priorityLabelClassName = this.namespace('priority', notification.severity, notification.type);
    var classes = this.namespace('notifications-list-item', 'font-base');
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: classes
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
      onClick: this.onNotificationClick,
      className: priorityLabelClassName
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", null, notification.text)));
  };

  return NotificationListItem;
}(namespace_component_["NamespaceConsumer"]);

src_list_item_NotificationListItem.propTypes = src_list_item_objectSpread({}, namespace_component_["NamespaceShape"], {
  notification: shapes_shapes.notification.isRequired
});
/* harmony default export */ var src_list_item = (Object(namespace_component_["withNamespace"])(src_list_item_NotificationListItem));
// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/list.js
function src_list_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_list_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_list_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_list_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var src_list_NotificationList =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(NotificationList, _NamespaceConsumer);

  function NotificationList() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = NotificationList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        failed = _this$props.failed,
        notifications = _this$props.notifications,
        sso = _this$props.sso,
        messages = _this$props.messages,
        closeList = _this$props.closeList;

    function stopPropagation(e) {
      e.stopPropagation();
    }

    var classes = this.namespace('notifications-list', 'dropdown-menu');
    var closeIconClasses = this.namespace('notifications-close', 'close');
    return (// eslint-disable-next-line  jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: classes,
        onClick: stopPropagation
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
        className: closeIconClasses,
        onClick: closeList
      }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("h4", {
        className: this.namespace('notifications-list-header')
      }, messages.headerText), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
        className: this.namespace('notifications-list-items')
      }, notifications && notifications.length > 0 ? notifications.map(function (n, c) {
        return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_list_item, {
          key: c,
          notification: n
        });
      }) : external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_list_empty, {
        failed: failed,
        messages: messages,
        sso: sso
      })))
    );
  };

  return NotificationList;
}(namespace_component_["NamespaceConsumer"]);

src_list_NotificationList.propTypes = src_list_objectSpread({}, namespace_component_["NamespaceShape"], {
  sso: shapes_shapes.sso.isRequired,
  messages: shapes_shapes.messages.isRequired,
  notifications: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(shapes_shapes.notification),
  closeList: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,
  failed: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var src_list = (Object(namespace_component_["withNamespace"])(src_list_NotificationList));
// CONCATENATED MODULE: ./node_modules/@ux/notifs-v1/src/index.js
function notifs_v1_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function notifs_v1_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { notifs_v1_src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { notifs_v1_src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var src_trfqEventDesc = 'click';
var notifs_v1_src_Notifications =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Notifications, _NamespaceConsumer);

  function Notifications(props) {
    var _this;

    _this = _NamespaceConsumer.call(this, props) || this;
    _this.openList = _this.openList.bind(babelHelpers.assertThisInitialized(_this));
    _this.closeList = _this.closeList.bind(babelHelpers.assertThisInitialized(_this));
    _this.toggleList = _this.toggleList.bind(babelHelpers.assertThisInitialized(_this));
    _this.generateEid = _this.generateEid.bind(babelHelpers.assertThisInitialized(_this)); // A reference to the trigger function that wraps the click handler. We keep a reference
    // to it so we can unbind the event later, when the component unmounts.

    _this.clickEventTrigger = null;
    _this._isMounted = true;
    return _this;
  }

  var _proto = Notifications.prototype;

  _proto.dismiss = function dismiss() {
    if (!this._isMounted) return;
    this.setState({
      dismissed: true
    });
    util_["cookie"].set('notificationsDismissed', true, {
      domain: '.' + new util_["URL"]().domain(1)
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.off('click', this.clickEventTrigger);
    this._isMounted = false;
  };

  _proto.openList = function openList(event) {
    event.preventDefault();
    var isLoaded = this.state.isLoaded;

    if (!isLoaded || !this._isMounted) {
      return;
    }

    this.setState({
      isOpen: true
    }, function badgeOpened() {
      this.bellClickLogImpressions();
      this.dismiss();
    }.bind(this));
  };

  _proto.closeList = function closeList() {
    var isLoaded = this.state.isLoaded;

    if (!isLoaded || !this._isMounted) {
      return;
    }

    this.setState({
      isOpen: false
    });
  };

  _proto.toggleList = function toggleList(e) {
    var isOpen = this.state.isOpen;
    var openList = this.openList,
        closeList = this.closeList;
    isOpen ? closeList(e) : openList(e);
  };

  _proto.generateEid = function generateEid(suffix) {
    var manifest = this.props.manifest.toLowerCase();
    return "uxp.hyd.".concat(manifest, ".").concat(suffix);
  };

  _proto.bellClickLogImpressions = function bellClickLogImpressions() {
    var eid = this.generateEid('notifications.unseencounterbell.click');
    var _this$state = this.state,
        notifications = _this$state.notifications,
        dismissed = _this$state.dismissed;

    if (notifications && notifications.length > 0) {
      if (dismissed) {
        eid = this.generateEid('notifications.seencounterbell.click');
      }

      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eid, src_trfqEventDesc);
      notifications.forEach(function (n) {
        external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logImpression(n.eids.impression);
      });
    } else {
      eid = this.generateEid('notifications.emptybell.click');
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eid, src_trfqEventDesc);
    }
  };

  _proto.notesLoadLogImpressions = function notesLoadLogImpressions() {
    var eid = this.generateEid('notifications.emptybell.impression');
    var _this$state2 = this.state,
        notifications = _this$state2.notifications,
        dismissed = _this$state2.dismissed;

    if (notifications && notifications.length > 0) {
      if (dismissed) {
        eid = this.generateEid('notifications.seencounterbell.impression');
      } else {
        eid = this.generateEid('notifications.unseencounterbell.impression');
      }
    }

    external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logImpression(eid);
  };

  _proto.componentDidMount = function componentDidMount() {
    var props = this.props;
    var api = props.api,
        privateLabelId = props.privateLabelId,
        shopperId = props.shopperId,
        market = props.market;
    var dismissed = util_["cookie"].get('notificationsDismissed') === 'true';
    this.clickEventTrigger = this.outside('click', this.closeList, this.domNode);
    src_cache_get(props.cache.href, this.namespace('notification-cache'), api, privateLabelId, shopperId, market, function notifRequestSuccess(response) {
      if (!this._isMounted) return;
      var badge = response.badge,
          notifications = response.notifications;
      this.setState({
        isLoaded: true,
        isOpen: false,
        badge: badge,
        notifications: notifications,
        dismissed: dismissed
      });
      this.notesLoadLogImpressions();
    }.bind(this), function notifRequestFailed() {
      if (!this._isMounted) return;
      this.setState({
        failed: true,
        isLoaded: true,
        dismissed: dismissed
      });
    }.bind(this));
  };

  _proto.render = function render() {
    var _this$classNames;

    var closeList = this.closeList,
        toggleList = this.toggleList;
    var _this$props = this.props,
        className = _this$props.className,
        sso = _this$props.sso,
        messages = _this$props.messages,
        tooltip = _this$props.tooltip;
    var _this$state3 = this.state,
        failed = _this$state3.failed,
        isOpen = _this$state3.isOpen,
        dismissed = _this$state3.dismissed,
        badge = _this$state3.badge,
        notifications = _this$state3.notifications;

    var refHandler = function refHandler(domNode) {
      this.domNode = domNode;
    }.bind(this);

    var classes = this.classNames(className, this.namespace('notifications', 'dropdown'), (_this$classNames = {}, babelHelpers.defineProperty(_this$classNames, this.namespace('open'), isOpen), babelHelpers.defineProperty(_this$classNames, this.namespace('has-notifications'), notifications && notifications.length > 0 && sso), _this$classNames)); // eslint-disable-next-line  jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      ref: refHandler,
      className: classes,
      onClick: toggleList
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(notifs_v1_src_badge, babelHelpers["extends"]({
      messages: messages,
      dismissed: dismissed
    }, badge, {
      tooltip: tooltip
    })), isOpen ? external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_list, {
      failed: failed,
      notifications: notifications,
      messages: messages,
      sso: sso,
      closeList: closeList
    }) : null);
  };

  return Notifications;
}(namespace_component_["NamespaceConsumer"]);
notifs_v1_src_Notifications.propTypes = notifs_v1_src_objectSpread({}, namespace_component_["NamespaceShape"], {
  manifest: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  cache: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired
  }).isRequired,
  api: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    href: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired
  }).isRequired,
  sso: shapes_shapes.sso.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: shapes_shapes.messages.isRequired,
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  tooltip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/* harmony default export */ var notifs_v1_src = (Object(namespace_component_["withNamespace"])(notifs_v1_src_Notifications));
function src_Container(props) {
  var namespace = props.namespace,
      rest = babelHelpers.objectWithoutProperties(props, ["namespace"]);
  return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceProvider"], {
    namespace: namespace
  }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(notifs_v1_src_Notifications, rest));
}
src_Container.propTypes = {
  namespace: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
};
// CONCATENATED MODULE: ./node_modules/@ux/inapp-help/src/dialog.js
/* eslint no-return-assign: 0, no-use-before-define: 0 */


var IFrame, Panel;
/**
 * Inapp help dialog component.
 *
 * @class Dialog
 * @public
 */

var dialog_Dialog =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Dialog, _NamespaceConsumer);

  function Dialog() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this; // Initial state

    _this.state.dragging = false;
    _this.state.dragX = 0;
    _this.state.dragY = 0; // Bind event handlers so they have the correct `this` context

    ['update', 'onMouseUp', 'onMouseDown', 'onMouseMove', 'onTouchStart', 'onTouchEnd', 'onTouchMove'].forEach(function (fn) {
      _this[fn] = _this[fn].bind(babelHelpers.assertThisInitialized(_this));
    });
    return _this;
  }
  /**
   * Update the position and height of the dialog when it is first mounted.
   * Set up a window resize listener so that the dialog can be updated as needed
   * on page resize.
   *
   * @private
   */


  var _proto = Dialog.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.update();
    this.on('resize', this.update);
  }
  /**
   * Update the position and height of the dialog when it is updated.
   *
   * @param {object} prevProps The previous props
   * @private
   */
  ;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this.update();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.off('resize', this.update);
  }
  /**
   * Update the position and height of the dialog as needed.
   *
   * @public
   */
  ;

  _proto.update = function update() {
    this.setPosition();
    this.setHeight();
  }
  /**
   * Position the dialog.
   * If no x or y parameters are specified, they are calculated automatically.
   *
   * @param {Number} x - x position (optional)
   * @param {Number} y - y position (optional)
   * @public
   */
  ;

  _proto.setPosition = function setPosition(x, y) {
    if (!this.dom) return;
    var _this$props = this.props,
        rightMargin = _this$props.rightMargin,
        minLeft = _this$props.minLeft,
        minTop = _this$props.minTop;

    if (typeof x !== 'number') {
      x = window.innerWidth - this.dom.offsetWidth - rightMargin;

      if (x < minLeft) {
        x = minLeft;
      }
    }

    if (typeof y !== 'number') {
      y = minTop;
    }

    this.dom.style.left = x + 'px';
    this.dom.style.top = y + 'px';
  }
  /**
   * Return the current position of the dialog.
   *
   * @returns {Object} x,y position of dialog
   * @public
   */
  ;

  _proto.getPosition = function getPosition() {
    if (!this.dom) return {};
    var x = parseInt(this.dom.style.left, 10);
    var y = parseInt(this.dom.style.top, 10);
    return {
      x: x,
      y: y
    };
  }
  /**
   * Position the dialog.
   *
   * If no height parameter is specified, it is calculated automatically based
   * on the current window size.
   *
   * @param {Number} height - height (optional)
   * @public
   */
  ;

  _proto.setHeight = function setHeight(height) {
    if (!this.dom) return;
    var _this$props2 = this.props,
        bottomMargin = _this$props2.bottomMargin,
        minHeight = _this$props2.minHeight;
    var currentHeight = this.dom.offsetHeight;
    var heightDelta = 0;

    if (typeof height !== 'number') {
      height = window.innerHeight - parseInt(this.dom.style.top, 10) - bottomMargin;
    }

    if (height < minHeight) {
      height = minHeight;
    }

    heightDelta = height - currentHeight;
    this.frame.updateHeight(heightDelta);
    this.panel.updateHeight(heightDelta);
    this.dom.style.height = currentHeight + heightDelta + 'px';
  }
  /**
   * Get the height of the dialog.
   *
   * @returns {Number} height of the dialog
   * @public
   */
  ;

  _proto.getHeight = function getHeight() {
    if (!this.dom) return 0;
    return parseInt(this.dom.style.height, 10);
  }
  /**
   * Render the dialog.
   *
   * @returns {ReactElement} the dialog box
   * @public
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        url = _this$props3.url,
        onClose = _this$props3.onClose;
    var titleBar = dialog_renderTitleBar(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('uxicon', 'uxicon-grab-vert')
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(dialog_Close, {
      onClick: onClose,
      onTouchStart: onClose,
      onMouseDown: function onMouseDown(event) {
        return event.stopPropagation();
      },
      className: this.namespace('uxicon', 'uxicon-x')
    }), this.namespace('ux-help-title-bar')); // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      role: "dialog",
      className: this.namespace('ux-help-container'),
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onTouchStart,
      ref: function ref(node) {
        return _this2.dom = node;
      }
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(Panel, {
      dragging: this.state.dragging,
      ref: function ref(node) {
        return _this2.panel = node;
      }
    }, titleBar, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(IFrame, {
      src: url,
      ref: function ref(node) {
        return _this2.frame = node;
      }
    })));
  } //
  // Drag and drop moving
  //
  ;

  _proto.startDrag = function startDrag(x, y) {
    // Add event handlers
    this.on('mouseup', this.onMouseUp);
    this.on('mousemove', this.onMouseMove);
    this.on('touchend', this.onTouchEnd);
    this.on('touchmove', this.onTouchMove); // Update state

    this.setState({
      dragging: true,
      dragX: x,
      dragY: y
    });
  };

  _proto.stopDrag = function stopDrag() {
    if (!this.state.dragging) return; // Remove event listeners

    this.off('mouseup', this.onMouseUp);
    this.off('mousemove', this.onMouseMove);
    this.off('touchend', this.onTouchEnd);
    this.off('touchmove', this.onTouchMove); // Update state

    this.setState({
      dragging: false,
      dragX: 0,
      dragY: 0
    });
  };

  _proto.move = function move(x, y) {
    this.setPosition(x, y);
  };

  _proto.keepInBounds = function keepInBounds(x, y) {
    var minTop = this.props.minTop;
    var maxX = window.innerWidth - this.dom.offsetWidth;
    var maxY = window.innerHeight - minTop;

    if (x < 0) {
      x = 0;
    } else if (x > maxX) {
      x = maxX;
    }

    if (y < 0) {
      y = 0;
    } else if (y > maxY) {
      y = maxY;
    }

    this.move(x, y);
  };

  _proto.onMouseDown = function onMouseDown(e) {
    if (this.frame && this.frame.dom) this.frame.dom.style.pointerEvents = 'none';
    var downX = e.pageX - e.currentTarget.offsetLeft;
    var downY = e.pageY - e.currentTarget.offsetTop;
    this.startDrag(downX, downY);
    return false;
  };

  _proto.onMouseUp = function onMouseUp(e) {
    if (this.frame && this.frame.dom) this.frame.dom.style.pointerEvents = 'auto';
    var upX = e.pageX - this.state.dragX;
    var upY = e.pageY - this.state.dragY;
    this.keepInBounds(upX, upY);
    this.stopDrag();
    return false;
  };

  _proto.onMouseMove = function onMouseMove(e) {
    var _this$state = this.state,
        dragging = _this$state.dragging,
        dragX = _this$state.dragX,
        dragY = _this$state.dragY;

    if (dragging) {
      this.move(e.pageX - dragX, e.pageY - dragY);
      return false;
    }
  };

  _proto.onTouchStart = function onTouchStart(e) {
    var evt = e.originalEvent || e;
    var downX = evt.touches[0].pageX - e.currentTarget.offsetLeft;
    var downY = evt.touches[0].pageY - e.currentTarget.offsetTop;
    this.startDrag(downX, downY);
    return false;
  };

  _proto.onTouchEnd = function onTouchEnd() {
    this.stopDrag();
    return false;
  };

  _proto.onTouchMove = function onTouchMove(e) {
    var evt = e.originalEvent || e;
    var _this$state2 = this.state,
        dragging = _this$state2.dragging,
        dragX = _this$state2.dragX,
        dragY = _this$state2.dragY;

    if (dragging) {
      this.move(evt.touches[0].pageX - dragX, evt.touches[0].pageY - dragY);
      return false;
    }
  };

  return Dialog;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Default properties for the component.
 *
 * @type {Object}
 * @public
 */

dialog_Dialog.defaultProps = {
  minLeft: 100,
  minTop: 50,
  rightMargin: 0,
  bottomMargin: 50,
  minHeight: 350
};
/**
 * Inapp help dialog panel component.
 *
 * @private
 */

var dialog_PanelRaw =
/*#__PURE__*/
function (_NamespaceConsumer2) {
  babelHelpers.inheritsLoose(PanelRaw, _NamespaceConsumer2);

  function PanelRaw() {
    return _NamespaceConsumer2.apply(this, arguments) || this;
  }

  var _proto2 = PanelRaw.prototype;

  _proto2.render = function render() {
    var _this3 = this;

    var _this$props4 = this.props,
        dragging = _this$props4.dragging,
        children = _this$props4.children;
    var classNames = this.namespace(this.classNames('ux-help-panel', {
      'ux-help-positioned': !dragging,
      'ux-help-dragging': dragging
    }));
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: classNames,
      ref: function ref(node) {
        return _this3.dom = node;
      }
    }, children);
  }
  /**
   * Update the height of the component based on a delta.
   *
   * @param {Number} delta - The amount of difference to change height by.
   * @private
   */
  ;

  _proto2.updateHeight = function updateHeight(delta) {
    if (!this.dom) return;
    var currentHeight = this.dom.offsetHeight;
    this.dom.style.height = currentHeight + delta + 'px';
  };

  return PanelRaw;
}(namespace_component_["NamespaceConsumer"]);

Panel = Object(namespace_component_["withNamespace"])(dialog_PanelRaw);
/**
 * Generate the title bar
 *
 * @param {Element} grabIcon - div containing the grab icon
 * @param {ReactElement} closeButton - component containing the `x` to close the inapp-help
 * @param {String} classnames - string of classnames
 *
 * @returns {Element} div containing the content of the title bar
 * @private
 */

var dialog_renderTitleBar = function renderTitleBar(grabIcon, closeButton, classnames) {
  return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
    className: classnames
  }, grabIcon, closeButton);
};
/**
 * Inapp help dialog close button component.
 *
 * @param {Object} props - properties of the close button
 *
 * @returns {Element} div containing the close button
 * @private
 */


var dialog_Close = function Close(props) {
  return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", props);
};
/**
 * Inapp help dialog iframe component.
 *
 * @private
 */


var dialog_IFrameRaw =
/*#__PURE__*/
function (_NamespaceConsumer3) {
  babelHelpers.inheritsLoose(IFrameRaw, _NamespaceConsumer3);

  function IFrameRaw() {
    return _NamespaceConsumer3.apply(this, arguments) || this;
  }

  var _proto3 = IFrameRaw.prototype;

  _proto3.render = function render() {
    var _this4 = this;

    // eslint-disable-next-line no-unused-vars
    var _this$props5 = this.props,
        namespace = _this$props5.namespace,
        props = babelHelpers.objectWithoutProperties(_this$props5, ["namespace"]); // eslint-disable-next-line jsx-a11y/iframe-has-title

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("iframe", babelHelpers["extends"]({
      className: this.namespace('ux-help-content'),
      frameBorder: "0"
    }, props, {
      ref: function ref(node) {
        return _this4.dom = node;
      }
    }));
  }
  /**
   * Update the height of the component based on a delta.
   *
   * @param {Number} delta - The amount of difference to change height by.
   * @private
   */
  ;

  _proto3.updateHeight = function updateHeight(delta) {
    if (!this.dom) return;
    var currentHeight = this.dom.offsetHeight;
    this.dom.style.height = currentHeight + delta + 'px';
  };

  return IFrameRaw;
}(namespace_component_["NamespaceConsumer"]);

IFrame = Object(namespace_component_["withNamespace"])(dialog_IFrameRaw); //
// Export the other components as well
//

dialog_Dialog.Panel = Panel;
dialog_Dialog.Close = dialog_Close;
dialog_Dialog.IFrame = IFrame;
/* harmony default export */ var src_dialog = (Object(namespace_component_["withNamespace"])(dialog_Dialog));
// CONCATENATED MODULE: ./node_modules/@ux/inapp-help/src/index.js
function inapp_help_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function inapp_help_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { inapp_help_src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { inapp_help_src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/**
 * Inapp help component.
 *
 * This renders the anchor, which then determines what will happen when it is
 * clicked. It will enter open up a dialog, or take you to the specified url.
 *
 * @class InappHelp
 * @public
 */

var src_InappHelp =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(InappHelp, _NamespaceConsumer);

  function InappHelp(props) {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.state.open = false;
    _this.state.url = props.url;
    _this.state.closePrompt = props.closePrompt;
    _this.onClick = _this.onClick.bind(babelHelpers.assertThisInitialized(_this));
    _this.rememberState = _this.rememberState.bind(babelHelpers.assertThisInitialized(_this));
    _this.receiveMessage = _this.receiveMessage.bind(babelHelpers.assertThisInitialized(_this));
    _this.dialogRef = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createRef();
    return _this;
  }
  /**
   * Setup event handlers to remember the state when the page unloads, and check
   * if the dialog should be reopened to a persisted state when it is originally
   * mounted.
   *
   * Also setup receiveMessage to listen for posted messagees to window in order
   * to support conditional closing.
   *
   * @private
   */


  var _proto = InappHelp.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.on('beforeunload', this.rememberState);
    this.on('message', this.receiveMessage); // If the dialog was open and persisted, reopen it

    if (this.shouldPersist()) {
      this.reopen();
    }
  }
  /**
   * Remove receiveMessage handler from window event listeners.
   *
   * @private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.off('message', this.receiveMessage);
    this.off('beforeunload', this.rememberState);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (typeof nextProps.url !== 'undefined' && nextProps.url !== this.state.url) {
      this.setState({
        url: nextProps.url
      });
    }
  }
  /**
   * Render the component.
   *
   * @returns {ReactElement} Help link.
   * @api private
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var label = this.props.label;
    var dialog = this.renderDialog(); //
    // Perform loose feature detection here to see if
    // `props.label` is a <FormattedMessage />
    //

    var isIntl = label.props && label.props.id && label.props.values;
    var displayLabel = !isIntl && this.renderLabel(label) || external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.cloneElement(label, {
      id: label.props.id,
      children: function children(msg) {
        return _this2.renderLabel(msg);
      }
    });
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, displayLabel, dialog);
  }
  /**
   * Render the label by wrapping it inside an anchor.
   *
   * Temporary disable the click tracking on Help as the traffic2 integration
   * is broken. If this bug is fixed, both `data-tcc-ignore`, the `ref` and
   * custom `logEvent` call in the related `onClick` can be removed. For more
   * details see: https://jira.godaddy.com/browse/GX-2697
   *
   * @param {String|Node} label Potentially unwrapped this.props.label.
   * @returns {React.Element} React Element representing an unwrapped label.
   */
  ;

  _proto.renderLabel = function renderLabel(label) {
    var _this3 = this;

    var _this$props = this.props,
        eid = _this$props.eid,
        eidPrefix = _this$props.eidPrefix,
        tooltip = _this$props.tooltip;
    var url = this.state.url;
    var classes = this.namespace('nav-link');
    var labelIsIcon = false;

    if (label.type === icon_default.a) {
      classes = this.classNames(classes, this.namespace('uxicon', 'uxicon-' + label.props.name));
      labelIsIcon = true;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: url,
      "data-tcc-ignore": true,
      onClick: this.onClick,
      ref: function ref(c) {
        _this3.link = c;
      },
      "data-eid": "".concat(eidPrefix, ".").concat(eid),
      className: classes,
      "aria-hidden": labelIsIcon,
      title: labelIsIcon ? tooltip : void 0
    }, !labelIsIcon && label);
  }
  /**
   * Render the inapp help dialog.
   *
   * @returns {ReactElement} Dialog.
   * @private
   */
  ;

  _proto.renderDialog = function renderDialog() {
    if (!this.state.open) {
      return null;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_dialog, babelHelpers["extends"]({
      ref: this.dialogRef,
      url: this.state.url,
      onClose: this.close.bind(this)
    }, this.props));
  }
  /**
   * Handle posted messages from Iframe to support conditional closing
   *
   * @param {Event} event Posted message event.
   * @private
   */
  ;

  _proto.receiveMessage = function receiveMessage(event) {
    if (!this.dialogRef || !this.dialogRef.current || this.dialogRef.current.frame.dom.contentWindow !== event.source) {
      return;
    }

    if (event.data === 'inappHelpEnableClosePrompt') {
      this.setState({
        closePrompt: true
      });
    } else if (event.data === 'inappHelpClose') {
      this.setState({
        closePrompt: false
      });
      this.closeNoPrompt();
    }
  }
  /**
   * Handle click event for help anchor.
   *
   * TODO: remove the custom traffic2 event logging if `data-tcc-ignore` is
   * removed from the JSX.
   *
   * @param {Event} event Mouse event.
   * @returns {Boolean} Return false to prevent event propagation.
   * @private
   */
  ;

  _proto.onClick = function onClick(event) {
    var eid = this.link && this.link.getAttribute('data-eid');

    if (eid) {
      external_root_ux_trfq_commonjs_react_trfq_default_commonjs2_react_trfq_default_amd_react_trfq_default.a.logEvent(eid, 'click');
    }

    if (this.shouldOpen()) {
      this.open();
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }
  /**
   * If the inapp help dialog should be opened.
   *
   * @returns {Boolean} Should the dialog open.
   * @private
   */
  ;

  _proto.shouldOpen = function shouldOpen() {
    var enabled = this.props.enabled; // not enabled for link

    if (!enabled) {
      return false;
    }

    return !this.isMobile;
  }
  /**
   * Open the inapp help dialog on the page.
   *
   * @param {String} url - url to open up to (optional)
   * @public
   */
  ;

  _proto.open = function open(url) {
    this.setState({
      open: true,
      url: url || this.state.url
    });
  }
  /**
   * Close the inapp help dialog on the page.
   *
   * If message posted to enable prompting then notifies frame to prompt for close.
   *
   * @param {Event} event The Event
   * @returns {undefined} Nothing
   * @public
   */
  ;

  _proto.close = function close(event) {
    if (this.state.closePrompt) {
      return this.notifyFrameToPromptClose(event);
    }

    this.closeNoPrompt();
  }
  /**
   * Posts message to IFrame content window to prompt for close
   *
   * @param {Event} event The Event
   * @private
   */
  ;

  _proto.notifyFrameToPromptClose = function notifyFrameToPromptClose(event) {
    event.preventDefault();
    event.stopPropagation();
    var dialog = this.dialogRef.current;

    if (dialog && dialog.frame.dom.contentWindow) {
      dialog.frame.dom.contentWindow.postMessage('inappHelpPromptClose', '*');
    }
  }
  /**
   * Closes inapp help dialog on the page without prompting.
   *
   * @private
   */
  ;

  _proto.closeNoPrompt = function closeNoPrompt() {
    this.setState({
      open: false
    });
    this.forgetState();
    this.initSurvey();
  }
  /**
   * Toggle the inapp help dialog on the page.
   *
   * @public
   */
  ;

  _proto.toggle = function toggle() {
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  }
  /**
   * Reopen the inapp help dialog based on persisted state that gets saved when
   * the page is unloaded. If no state is found then the dialog is not reopend.
   *
   * @public
   */
  ;

  _proto.reopen = function reopen() {
    var state = this.getPersistedState();

    if (!state) {
      return;
    } // Append last=true query param to the url
    // This tells the help system to navigate to where the user was last


    var url = new util_["URL"](state.url, true);
    url.query = url.query || {};
    url.query.last = true;
    url = url.toString(); // Reopen the dialog to the new url

    this.open(url); // TODO: not sure if this can be done now? The dialog has to already be
    // rendered for this to work. This needs to happen after it has rendered.
    // Does react provide us a hook for this?

    var dialog = this.dialogRef.current;

    if (dialog) {
      dialog.setPosition(state.x, state.y);
      dialog.setHeight(state.height);
    }
  }
  /**
   * Retrieve the persisted dialog state from cookie.
   * If no state was found, undefined is returned.
   *
   * @returns {Object} Persisted state.
   * @public
   */
  ;

  _proto.getPersistedState = function getPersistedState() {
    var data = util_["cookie"].get(this.props.stateStorageKey);

    if (data) {
      return util_["json"].parse(data);
    }

    return;
  }
  /**
   * Return whether the dialog should be reopend on the page. This is determined
   * by whether any persisted state exists, and if it is fresh based on the
   * timestamp.
   *
   * @returns {Boolean} Should state be persisted
   * @public
   */
  ;

  _proto.shouldPersist = function shouldPersist() {
    if (typeof window === 'undefined' || window !== window.top) {
      return false;
    }

    var state = this.getPersistedState();

    if (!state || !state.url) {
      return false;
    } // timestamp is within range


    var now = Date.now();

    if (now - state.timestamp > this.props.persistThreshold) {
      return false;
    }

    return true;
  }
  /**
   * Returns root domain of window location hostname if available, else empty string.
   *
   * @returns {string} Root domain of the window
   * @private
   */
  ;

  _proto.getRootDomain = function getRootDomain() {
    if (!window || !window.location) {
      return '';
    }

    var hostname = window.location.hostname;

    if (hostname) {
      var parts = hostname.split('.');
      var domain = parts.slice(parts.length - 2).join('.');
      return '.' + domain;
    }

    return '';
  }
  /**
   * Save the current dialog state to cookie.
   * This includes things such as the dialog position, what domain it was for,
   * and the timestamp so that it can be used to verify it is fresh.
   *
   * @public
   */
  ;

  _proto.rememberState = function rememberState() {
    if (typeof window === 'undefined' || window !== window.top) {
      return;
    }

    var dialog = this.dialogRef.current;

    if (!dialog) {
      this.forgetState();
      return;
    }

    var pos = dialog.getPosition() || {};
    var height = dialog.getHeight();
    var host = window.location.host;
    var url = this.state.url; // can't access the value of the iframe

    var now = Date.now();
    var data = {
      timestamp: now,
      host: host,
      url: url,
      x: pos.x,
      y: pos.y,
      height: height
    };
    var expDate = new Date(Date.now() + this.props.persistThreshold);
    util_["cookie"].set(this.props.stateStorageKey, util_["json"].stringify(data), {
      domain: this.getRootDomain(),
      path: '/',
      expires: expDate.toUTCString()
    });
  }
  /**
   * Remove the current dialog state from cookies.
   *
   * @public
   */
  ;

  _proto.forgetState = function forgetState() {
    util_["cookie"].set(this.props.stateStorageKey, '', {
      domain: this.getRootDomain(),
      path: '/',
      expires: new Date(0)
    });
  }
  /**
   * Reload Qualtrics via Javascript API so that intercepts can be reevaluated.
   *
   * @param {Object} QSI Qualtrics Javascript object
   * @private
   */
  ;

  _proto.reloadQualtrics = function reloadQualtrics(QSI) {
    if (typeof QSI !== 'undefined' && typeof QSI.API !== 'undefined') {
      try {
        QSI.API.unload();
        QSI.API.load();
      } catch (e) {
        /* noop */
      }
    }
  }
  /**
   * Writes survey cookie if not present and reloads qualtrics
   *
   * @public
   */
  ;

  _proto.initSurvey = function initSurvey() {
    if (typeof window === 'undefined' || window !== window.top) {
      return;
    }

    var surveyCookie = util_["cookie"].get(this.props.surveyCookieName);

    if (surveyCookie) {
      return;
    }

    var surveyCookieValue = '1';
    var expDate = new Date(Date.now() + this.props.surveyCookieExpiration);
    util_["cookie"].set(this.props.surveyCookieName, surveyCookieValue, {
      domain: this.getRootDomain(),
      path: '/',
      expires: expDate.toUTCString()
    });
    this.reloadQualtrics(window.QSI);
  };

  return InappHelp;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Default properties for the component. The labels are only provided as a
 * fallback and should be set to localized content.
 *
 * @type {Object}
 * @public
 */

src_InappHelp.defaultProps = {
  eidPrefix: 'uxp.hyd.app_header',
  eid: 'shared.help.header_link.link.click',
  label: 'Help',
  title: 'Help',
  tooltip: 'Help',
  enabled: true,
  persistThreshold: 30 * 60 * 1000,
  // 30 minutes
  stateStorageKey: 'inapp-help-state',
  closePrompt: false,
  surveyCookieName: 'surveyme',
  surveyCookieExpiration: 72 * 60 * 60 * 1000 // 3 days

};
/**
 * Required properties.
 *
 * @type {Object}
 * @public
 */

src_InappHelp.propTypes = inapp_help_src_objectSpread({}, namespace_component_["NamespaceShape"], {
  label: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element]).isRequired,
  title: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.oneOfType([external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string, external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element]).isRequired,
  tooltip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  eidPrefix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  eid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  url: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  enabled: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  persistThreshold: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  stateStorageKey: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  closePrompt: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var inapp_help_src = (Object(namespace_component_["withNamespace"])(src_InappHelp));
// EXTERNAL MODULE: external {"root":["ux","Component"],"commonjs":["@ux/component","default"],"commonjs2":["@ux/component","default"],"amd":"@ux/component"}
var component_ = __webpack_require__("@ux/component");
var component_default = /*#__PURE__*/__webpack_require__.n(component_);

// CONCATENATED MODULE: ./node_modules/@ux/cart/index.js
function cart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function cart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { cart_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { cart_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 //
// Get all predefined breakpoints for media-specific behavior. Doing a map will
// prevent us from adding more unminifable strings.
//

var cart_breakpoints = component_default.a.breakpoints.specification.map(function (point) {
  return point.name;
});
/**
 * Render the checkout link with optional text.
 *
 * @Constructor
 * @class Cart
 * @api public
 */

var cart_Cart =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Cart, _NamespaceConsumer);

  function Cart() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = Cart.prototype;

  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */
  _proto.componentDidMount = function componentDidMount() {
    this.breakpoint.apply(this, babelHelpers.toConsumableArray(cart_breakpoints));
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.breakup();
  }
  /**
   * Render the cart icon, only show the cart if the customer has items in the cart.
   * Only show the icon (no message) if mobile.
   *
   * @returns {ReactElement} Translated cart icon and optional message.
   * @api private
   */
  ;

  _proto.render = function render() {
    var _this = this;

    var props = this.props;
    var items = typeof this.state.items === 'number' ? this.state.items : props.items;
    var messageId = items ? 'Shared:UtilityBar:Cart:ItemsInCartMessage' : 'Shared:UtilityBar:Cart:EmptyCartMessage';
    var icon = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      "aria-label": props.messages[messageId],
      className: this.namespace('app-icon', 'app-icon-cart', this.classNames({
        'cart-empty': !items
      }))
    });

    if (!props.showEmpty && !items) {
      return null;
    }

    if (props.iconOnly) {
      return icon;
    }

    if (props.textOnly) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: "Shared:UtilityBar:Cart"
      }, function (stringLiteral) {
        return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
          ariaLabel: stringLiteral,
          urlArgs: props.urlArgs,
          href: props.checkout,
          "data-eid": props.eid,
          className: _this.classNames(babelHelpers.defineProperty({}, _this.namespace('cart-empty'), !items), props.className)
        }, stringLiteral);
      });
    } // Show just the icon if the cart is empty or if we're in mobile


    if (props.showEmpty && !items || this.isMobile) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
        ariaLabel: props.messages[messageId],
        urlArgs: props.urlArgs,
        href: props.checkout,
        "data-eid": props.eid,
        className: props.className
      }, icon);
    } // In non-mobile when the cart has items, show the full "Checkout Now" link


    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
      urlArgs: props.urlArgs,
      href: props.checkout,
      "data-eid": props.eid,
      className: props.className
    }, icon, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: messageId
    })));
  };

  return Cart;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Helper to update cart items, needs to be bound to proper scope that has state
 * on the number of items before the function can be used.
 *
 * @param {Number} items Updated cart count.
 * @param {Function} done Optional completion callback.
 * @api public
 */

cart_Cart.update = function update(items) {
  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  this.setState({
    items: parseInt(items, 10) || 0
  }, done);
};
/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */


cart_Cart.defaultProps = {
  eid: 'uxp.hyd.app_header.header.cart.cart_link.link.click',
  market: 'en',
  items: 0,
  showEmpty: false,
  iconOnly: false,
  textOnly: false
};
/**
 * Property definitions.
 *
 * @type {Object}
 * @api private
 */

cart_Cart.propTypes = cart_objectSpread({}, namespace_component_["NamespaceShape"], {
  /** eid to be used link click events */
  eid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,

  /** Item count representing how many items are in the cart */
  items: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,

  /** If the customer is logged in */
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,

  /** Market needed for IntlProvider  */
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,

  /** Checkout url for the cart */
  checkout: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,

  /** Messages for IntlProvider */
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,

  /** Show the empty cart icon, default false */
  showEmpty: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,

  /** Render the icon only, no link, default false */
  iconOnly: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,

  /** Show only the word `cart`, default false */
  textOnly: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var cart = (Object(namespace_component_["withNamespace"])(cart_Cart));
// CONCATENATED MODULE: ./node_modules/@ux/logo/index.js
function logo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function logo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { logo_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { logo_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





 // Regex for whitespace and non-typographical unicode characters
// eslint-disable-next-line no-control-regex

var WHITESPACE_REGEX = /[\s\u0000-\u001F\u007F-\u009F]/g;
/**
 * Add query parameters from props to the url.
 *
 * @param {String} url link.
 * @param {Object} props Properties to merge with the query parameters object.
 * @returns {String} Configured url.
 * @private
 */

function logo_updateQuery(url, props) {
  url = new util_["URL"](url, true);
  return url.set('query', logo_objectSpread({}, url.query, {}, props)).href;
}
/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} shared logo
 * @public
 */


var logo_LogoComponent =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(LogoComponent, _NamespaceConsumer);

  function LogoComponent(props) {
    var _this;

    _this = _NamespaceConsumer.call(this, props) || this; // Some Logo consumers setup breakpoints themselves and will trigger
    // corresponding re-renders of the Logo. But for those that don't, Logo
    // needs to setup breakpoints on its own. This prevents spurious re-renders
    // when consumed by an already-breakpoint-sensitive component.

    _this.shouldConfigureBreakpoints = typeof props.isMobile !== 'boolean';
    return _this;
  }
  /**
   * Check if breakpoint is mobile. (Respects `shouldConfigureBreakpoints`.)
   *
   * @returns {Boolean} Mobile or not.
   * @private
   */


  var _proto = LogoComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldConfigureBreakpoints) {
      this.breakpoint('mobile', 'phablet', 'tablet', 'desktop', 'large');
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.shouldConfigureBreakpoints) {
      this.breakup();
    }
  }
  /**
   * Return elements for rendering a reseller logo
   * @param {String} url Logo URL
   * @returns {ReactElement} Part of the shared logo
   * @api private
   */
  ;

  _proto.resellerLogo = function resellerLogo() {
    var _this$props = this.props,
        spanClass = _this$props.spanClass,
        privateLabelName = _this$props.privateLabelName;
    var url = this._logo; //
    // If no URL for a custom logo has been provided then display
    // the name of the private label.
    //

    if (!url) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        id: "registrar",
        className: this.namespace('logo-text')
      }, privateLabelName);
    } // To prevent SVGs from rendering 0x0, set an arbitrarily large enough width
    // to cover the max-width of the span. Only appropriate for SVGs because
    // other image types would stretch if their aspect ratio is narrower than
    // the span's.


    var svgHack = /\.svg$/.test(url) && {
      width: 200
    };
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.classNames('logo-img', spanClass)
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", babelHelpers["extends"]({
      id: "registrar",
      src: encodeURI(url),
      alt: privateLabelName
    }, svgHack)));
  }
  /**
   * Return elements for rendering a primary (i.e. GoDaddy) logo with the head
   * @param {String} url Logo URL
   * @returns {ReactElement} Part of the shared logo
   * @api private
   */
  ;

  _proto.primaryLogo = function primaryLogo() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: props.spanClass
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", {
      id: props.id || 'homepage',
      src: "//img1.wsimg.com/pc/img/1/trademark/nonregistered/godaddy-logo.png",
      alt: props.messages['Shared:ProductNav:CompanyName']
    }));
  }
  /**
   * Work around for `sinon@7`/lolex having issues faking timers.
   * Context
   *
   * @returns {number} number of milliseconds since epoch (same as `Date.now()`)
   */
  ;

  _proto.getDateNow = function getDateNow() {
    return Date.now();
  }
  /**
   * Return elements for rendering the temporary GoDaddy logo for culture campaigns
   *
   * @param {Object} tempLogo from props
   * @param {String} tempLogo.filename the name of the file to be retrieved from CDN
   * @param {Object} tempLogo.start the starting date of the campaign
   * @param {Object} tempLogo.end the ending date of the campaign
   * @param {Object} tempLogo.styles the styles to be applied
   * @returns {ReactElement} The temp logo
   */
  ;

  _proto.renderTempLogo = function renderTempLogo(_ref) {
    var filename = _ref.filename,
        start = _ref.start,
        end = _ref.end,
        _ref$styles = _ref.styles,
        styles = _ref$styles === void 0 ? {} : _ref$styles,
        _ref$altText = _ref.altText,
        altText = _ref$altText === void 0 ? '' : _ref$altText;
    var props = this.props;

    var convertToDateObject = function convertToDateObject(_ref2) {
      var year = _ref2.year,
          month = _ref2.month,
          day = _ref2.day,
          _ref2$hour = _ref2.hour,
          hour = _ref2$hour === void 0 ? null : _ref2$hour;
      // subtract 1 from the month since Date months are indexed from 0
      return new Date(year, month - 1, day, hour);
    };

    var startDate = convertToDateObject(start);
    var endDate = convertToDateObject(end);
    var now = this.getDateNow();

    if (startDate < now && now < endDate) {
      var cdn = "".concat(props.urls.cdn.href, "ux/sales-header/");
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        id: props.id || 'homepage',
        className: props.spanClass,
        "aria-label": "GoDaddy"
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", {
        alt: altText,
        src: "".concat(cdn).concat(filename),
        onError: function onError(e) {
          e.target.onError = null; // default logo fallback

          e.target.src = "".concat(cdn, "gd-logo.svg");
          e.target.style = null;
        },
        style: styles
      }));
    }

    return this.headlessGDLogo();
  }
  /**
   * Return elements for rendering the headless GoDaddy logo for the Brand update in application header
   * @param {String} url Logo URL
   * @returns {ReactElement} Part of the shared logo
   * @private
   */
  ;

  _proto.headlessGDLogo = function headlessGDLogo() {
    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      id: props.id || 'homepage',
      className: props.spanClass,
      "aria-label": "GoDaddy"
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("svg", {
      className: this.namespace('logo-mark'),
      viewBox: "0 0 367.7 78.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("path", {
      className: this.namespace('logo-mark-color'),
      d: "M95.3 38.6c0-4.6-3.6-8.4-8.3-8.4-4.6 0-8.3 3.8-8.3 8.4s3.6 8.3 8.3 8.3 8.3-3.7 8.3-8.3m14.4.1c0 11.9-10.1 21.4-22.6 21.4-12.6 0-22.6-9.5-22.6-21.4 0-12 10.1-21.6 22.6-21.6 12.5-.1 22.6 9.6 22.6 21.6M154.8 30c0-8-5.6-15-13.9-15h-11.5v30.3h11.5c8.3 0 13.9-7.3 13.9-15.3m15.5 0c0 17.1-12.1 28.8-29.1 28.8h-24.6c-1.2 0-2.1-.9-2.1-2V3.4c0-1.1.9-2 2.1-2h24.6c17.1.1 29.1 11.5 29.1 28.6M194.4 46.9c4.6 0 8.3-3.8 8.3-8.4s-3.6-8.4-8.3-8.4c-4.6 0-8.3 3.8-8.3 8.4 0 4.7 3.7 8.4 8.3 8.4M192.2 17c4.9 0 8.8 1.8 10.5 4.3v-1.2c0-1.1.9-1.9 1.9-1.9H215c1.1 0 1.9.8 1.9 1.9v36.8c0 1.1-.8 1.9-1.9 1.9h-10.3c-1.1 0-1.9-.8-1.9-1.9v-1.2c-1.7 2.5-5.7 4.3-10.6 4.3-10.4 0-20.4-8.3-20.4-21.6s10-21.4 20.4-21.4M241.4 46.9c4.6 0 8.3-3.8 8.3-8.4s-3.6-8.4-8.3-8.4c-4.6 0-8.3 3.8-8.3 8.4 0 4.7 3.7 8.4 8.3 8.4M238.9 17c5 0 8.9 1.9 10.7 4.1V3.4c0-1.1.9-1.9 1.9-1.9H262c1.1 0 1.9.8 1.9 1.9V57c0 1.1-.8 1.9-1.9 1.9h-10.3c-1.1 0-1.9-.8-1.9-1.9v-1.2c-2.1 2.5-5.7 4.3-10.6 4.3-10.4 0-20.4-8.3-20.4-21.6S228.7 17 238.9 17M288.4 46.9c4.6 0 8.3-3.8 8.3-8.4s-3.6-8.4-8.3-8.4c-4.6 0-8.3 3.8-8.3 8.4.1 4.7 3.7 8.4 8.3 8.4M286 17c5 0 8.9 1.9 10.7 4.1V3.4c0-1.1.9-1.9 1.9-1.9H309c1.1 0 1.9.8 1.9 1.9V57c0 1.1-.8 1.9-1.9 1.9h-10.3c-1.1 0-1.9-.8-1.9-1.9v-1.2c-2.1 2.5-5.7 4.3-10.6 4.3-10.4 0-20.4-8.3-20.4-21.6S275.7 17 286 17M345.5 64.7c-2.6 8.6-8.6 13.4-18 13.4-5.1 0-10.1-1.7-13.3-4.5-.5-.5-.8-1.1-.8-1.7 0-.5.2-1.1.7-1.7l3.9-5.9c.6-.8 1.5-.9 1.7-.9.9 0 1.3.2 2.1.8 1.2.8 2.9 1.8 4.8 1.8 1.6 0 3.7-.7 4.5-3.1l1.3-4.1H326c-1.3 0-2.1-.9-2.5-2L313 21.5c-.2-.9-.3-1.4-.3-1.7 0-.8.6-1.5 1.7-1.5h12.4c1.1 0 1.7 1 2 2l6.9 25.4h.5l5.5-25.4c.2-1 .9-2 2-2h12.6c1.2 0 1.7.7 1.7 1.5 0 .3-.1.8-.3 1.7l-12.2 43.2M49.7 50.9c-5 6.9-13.2 9.2-20.5 9.2C12.4 60.1 0 47.6 0 30.2.1 13.5 13.5.2 31 .2c13 0 23.4 5.5 28.1 16 .6 1.2 1 3.2-2.5 3.8l-9.2 1.6c-2.1.4-3.3-1-3.7-1.6-2.7-3.7-7.1-6.2-12.4-6.2-9.2 0-15.7 7-15.7 16.3 0 10.3 7.4 16.3 15.5 16.3 5.4 0 9.8-2 12.7-5.8h-8.1c-1.2 0-2.1-.9-2.1-2v-7.7c0-1.1.9-2 2.1-2h24.7c1.2 0 2.1.9 2.1 2v25.9c0 1.1-.9 2-2.1 2h-8.6c-1.2 0-2.1-.9-2.1-2v-5.9M359.8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.4c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.9 6.4-6.4 6.4z"
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("path", {
      className: this.namespace('logo-mark-color'),
      d: "M361.4 6.5c0-.4-.1-.7-.4-.8-.2-.2-.6-.4-.9-.4h-1.4v2.3h1.4c.4 0 .7-.1.9-.4.2-.2.4-.4.4-.7zm-3.1 5.9h-1.5c-.1 0-.1 0-.2-.1 0-.1-.1-.1-.1-.2V3.8c0-.1 0-.1.1-.2.1 0 .1-.1.2-.1h3.3c1.1 0 1.9.2 2.5.8s.9 1.3.9 2.1c0 .6-.1 1.1-.5 1.5-.4.5-.7.8-1.2 1.1l1.9 2.9c.1.1.1.2 0 .4 0 .1-.1.1-.2.1H362c-.1 0-.2 0-.4-.1-.1 0-.1-.1-.2-.2l-1.6-2.7h-1.2V12c0 .1 0 .1-.1.2s-.1.2-.2.2z"
    })));
  };

  _proto.render = function render() {
    var props = this.props;
    var linkProps = {
      'className': this.classNames(props.className, {
        'white-logo-bg': props.privateLabelId !== 1 && this._logo
      }),
      'urlArgs': props.urlArgs,
      'href': logo_updateQuery(props.href, props.urlArgs),
      'data-eid': props['data-eid']
    };
    var logoCaption;

    if (props.privateLabelId !== 1) {
      linkProps.rel = 'nofollow';
      logoCaption = this.resellerLogo();
    } else if (props.tempLogo) {
      logoCaption = this.renderTempLogo(props.tempLogo);
    } else if (props.includeGDHead) {
      logoCaption = this.primaryLogo();
    } else {
      logoCaption = this.headlessGDLogo();
    }

    var logo = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Fragment, null, props.market !== 'en-US' && props.showCountryNameOnLogo && props.privateLabelId === 1 && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('topnav-country')
    }, props.country), logoCaption);
    if (!props.href) return logo;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, linkProps, logo);
  };

  babelHelpers.createClass(LogoComponent, [{
    key: "_isMobile",
    get: function get() {
      return this.shouldConfigureBreakpoints ? this.isMobile : this.props.isMobile;
    }
    /**
     * Get the logo URL for the current breakpoint.
     *
     * @returns {String} Logo URL.
     * @private
     */

  }, {
    key: "_logo",
    get: function get() {
      var logos = this.props.logos;
      var url = logos && (this._isMobile ? logos.mobile : logos.desktop) || '';
      return url.replace(WHITESPACE_REGEX, '');
    }
  }]);
  return LogoComponent;
}(namespace_component_["NamespaceConsumer"]);
logo_LogoComponent.defaultProps = {
  market: 'en-US',
  country: '',
  privateLabelId: 1,
  showCountryNameOnLogo: false,
  urlArgs: {},
  includeGDHead: true
};
logo_LogoComponent.propTypes = logo_objectSpread({}, namespace_component_["NamespaceShape"], {
  'className': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'country': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'data-eid': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'href': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'logos': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'market': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  'messages': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  'privateLabelId': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number.isRequired,
  'privateLabelName': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'showCountryNameOnLogo': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'spanClass': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  'tempLogo': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'urlArgs': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'urls': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  'isMobile': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'includeGDHead': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  'id': external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
/* harmony default export */ var _ux_logo = (Object(namespace_component_["withNamespace"])(logo_LogoComponent));
// CONCATENATED MODULE: ./node_modules/@ux/popover/src/index.js
function popover_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function popover_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { popover_src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { popover_src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
* Display popover content when click on the control component
*
* @displayName PopOver (Web)
* @class PopOver
* @public
*/

var src_PopOver =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(PopOver, _NamespaceConsumer);

  function PopOver(props) {
    var _this;

    _this = _NamespaceConsumer.call(this, props) || this;
    _this.state = {
      open: props.open
    };
    _this.toggle = _this.toggle.bind(babelHelpers.assertThisInitialized(_this));
    _this.open = _this.open.bind(babelHelpers.assertThisInitialized(_this));
    _this.close = _this.close.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }
  /**
   * Open the popover by setting open to true
   *
   * @private
   */


  var _proto = PopOver.prototype;

  _proto.open = function open() {
    var _this2 = this;

    this.setState({
      open: true
    }, function () {
      return _this2.props.onToggle(true);
    });
  }
  /**
   * Close the popover by setting open to false
   *
   * @private
   */
  ;

  _proto.close = function close() {
    var _this3 = this;

    this.setState({
      open: false
    }, function () {
      return _this3.props.onToggle(false);
    });
  }
  /**
   * Toggle the popover based on current state of open
   *
   * @private
   */
  ;

  _proto.toggle = function toggle() {
    var next = this.state.open;
    next ? this.close() : this.open();
  }
  /**
   * Hide the dropdown if clicks are outside the tray itself.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.outside('click', this.close, this.contentWrapper);
    this.outside('focusin', this.close, this.contentWrapper);
  }
  /**
   * Remove the attached click event listener.
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.off('click', this.close);
    this.off('focusin', this.close);
  }
  /**
   * Check if the open prop has changed.
   * If so, update state of open.
   *
   * @param {Object} prevProps - previous instance of props
   */
  ;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.state.open !== this.props.open) {
      this.setState({
        open: this.props.open
      });
    }
  }
  /**
   * Render the control component within a button and the popover content children.
   *
   * @returns {ReactElement} PopOver element.
   * @private
   */
  ;

  _proto.render = function render() {
    var _this4 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        control = _this$props.control,
        eid = _this$props.eid;
    var open = this.state.open ? 'open' : '';
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: className,
      "data-eid": eid,
      ref: function ref(r) {
        _this4.contentWrapper = r;
      }
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('popover', open)
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      onClick: this.toggle,
      onKeyDown: this.toggle,
      tabIndex: "0",
      className: this.namespace('popover-button')
    }, control), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('content')
    }, children)));
  };

  return PopOver;
}(namespace_component_["NamespaceConsumer"]);
src_PopOver.propTypes = popover_src_objectSpread({}, namespace_component_["NamespaceShape"], {
  /** Customized class name */
  className: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,

  /** Control component for button render  */
  control: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element,

  /** Toggle handler for when popover is opened or closed */
  onToggle: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.func,

  /** eid to be used for the traffic tracking */
  eid: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,

  /** Allows consuemer to open or close the popover */
  open: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
src_PopOver.defaultProps = {
  onToggle: function onToggle() {},
  open: false
};
/* harmony default export */ var popover_src = (Object(namespace_component_["withNamespace"])(src_PopOver));
// CONCATENATED MODULE: ./src/waffle.js
function waffle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function waffle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { waffle_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { waffle_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









/**
 * Render A waffle menu to show a long list of products
 *
 * @param {Object} options Properties to spread on the item
 * @param {Function} [namespace=no-op] Function to namespace `className`
 * @returns {React.Element} A Popover Menu that uses a waffle control.
 * @api private
 */

var waffle_WaffleMenu =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(WaffleMenu, _NamespaceConsumer);

  function WaffleMenu() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = WaffleMenu.prototype;

  /**
   * Generate a link
   * @param  {Object} opts enumeration of link content
   * @param  {String} opts.message title of link
   * @param  {String} opts.id golf id
   * @param  {String} opts.href link to product
   * @param  {String} opts.eid eid to track click
   * @param  {React.Element} opts.prefix Icon to place in front of the link
   * @returns {React.element} link to product
   */
  _proto.link = function link(_ref) {
    var message = _ref.message,
        id = _ref.id,
        href = _ref.href,
        eid = _ref.eid,
        prefix = _ref.prefix,
        className = _ref.className;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(link_Link, {
      title: message,
      href: href,
      "data-eid": eid,
      className: className,
      key: "waffle-menu-".concat(id)
    }, prefix, " ", external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: id
    }));
  };

  _proto.links = function links() {
    var _this$props = this.props,
        urls = _this$props.urls,
        messages = _this$props.messages,
        isInGoCohort = _this$props.isInGoCohort;
    return {
      home: this.link({
        eid: 'uxp.hyd.waffle_menu.home.link.click',
        href: isInGoCohort ? urls.accountHome.href : urls.products.href,
        id: enums_golf.home,
        message: messages[enums_golf.home],
        className: this.namespace('waffle-home-link'),
        prefix: external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_default.a, {
          name: "home"
        })
      }),
      manage: this.link({
        eid: 'uxp.hyd.waffle_menu.manage_my_products.link.click',
        href: urls.products.href,
        id: enums_golf['manage-my-products'],
        className: this.namespace('waffle-link'),
        message: messages[enums_golf['manage-my-products']]
      }),
      products: [{
        eid: 'uxp.hyd.waffle_menu.product_domains.link.click',
        href: urls.manageDomains.href,
        id: enums_golf.domains.replace('_', '-'),
        className: this.namespace('waffle-link'),
        message: messages[enums_golf.domains]
      }, {
        eid: 'uxp.hyd.waffle_menu.product_websites.link.click',
        href: urls.manageWebsites.href,
        id: enums_golf.websites.replace('_', '-'),
        className: this.namespace('waffle-link'),
        message: messages[enums_golf.websites]
      }, {
        eid: 'uxp.hyd.waffle_menu.product_hosting_wordpress.link.click',
        href: urls.manageHosting.href,
        id: enums_golf['hosting-wordpress'].replace('_', '-'),
        className: this.namespace('waffle-link'),
        message: messages[enums_golf['hosting-wordpress']]
      }, {
        eid: 'uxp.hyd.waffle_menu.product_email_office.link.click',
        href: urls.bigthree.email.href,
        id: enums_golf['email-office'].replace('_', '-'),
        className: this.namespace('waffle-link'),
        message: messages[enums_golf['email-office']]
      }, {
        eid: 'uxp.hyd.waffle_menu.product_ssl.link.click',
        href: urls.bigthree.ssl.href,
        id: enums_golf.ssl.replace('_', '-'),
        className: this.namespace('waffle-link'),
        message: messages[enums_golf.ssl]
      }].map(this.link)
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        showWaffleMenu = _this$props2.showWaffleMenu,
        control = _this$props2.control,
        waffleLeft = _this$props2.waffleLeft;
    var showWaffleLeft = showWaffleMenu && waffleLeft;

    if (!showWaffleMenu) {
      return null;
    }

    var links = this.links();
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(popover_src, {
      control: control,
      eid: "uxp.hyd.app_header.waffle_menu.click",
      className: this.namespace('waffle-menu', this.classNames({
        'waffle-left': showWaffleLeft
      }))
    }, links.home, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('tray-menu-divider')
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('quick-links-heading', 'tray-heading')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: 'PC:AppHeader:Header:QuickLinks'
    })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('quick-links')
    }, links.products), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('tray-menu-divider')
    }), links.manage);
  };

  return WaffleMenu;
}(namespace_component_["NamespaceConsumer"]);

waffle_WaffleMenu.propTypes = waffle_objectSpread({}, namespace_component_["NamespaceShape"], {
  control: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.element,
  showWaffleMenu: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  isInGoCohort: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var waffle = (Object(namespace_component_["withNamespace"])(waffle_WaffleMenu));
// CONCATENATED MODULE: ./src/app-name.js
function app_name_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function app_name_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { app_name_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { app_name_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/**
 * Render Big Three product dropdown.
 *
 * @Constructor
 * @class BigThree
 * @api public
 */

var app_name_AppName =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(AppName, _NamespaceConsumer);

  function AppName() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = AppName.prototype;

  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */
  _proto.componentDidMount = function componentDidMount() {
    this.breakpoint.apply(this, babelHelpers.toConsumableArray(enums_breakpoints));
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.breakup();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        market = _this$props.market,
        messages = _this$props.messages,
        showWaffleMenu = _this$props.showWaffleMenu,
        waffleLeft = _this$props.waffleLeft,
        name = _this$props.name;
    var content;
    var productName = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace('product-name')
    }, name);

    if (showWaffleMenu) {
      var control = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_["Fragment"], null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_default.a, {
        name: "apps"
      }), !waffleLeft && productName);
      content = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(waffle, babelHelpers["extends"]({}, this.props, {
        control: control
      }));
    } else {
      content = productName;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: market,
      messages: messages
    }, content);
  };

  return AppName;
}(namespace_component_["NamespaceConsumer"]);

app_name_AppName.propTypes = app_name_objectSpread({}, namespace_component_["NamespaceShape"], {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  app: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  showWaffleMenu: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var app_name = (Object(namespace_component_["withNamespace"])(app_name_AppName));
// CONCATENATED MODULE: ./src/account-tray.js
function account_tray_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function account_tray_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { account_tray_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { account_tray_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/**
 * Render User details when logged in.
 *
 * @Constructor
 * @class UserDetails
 * @api public
 */

var account_tray_UserDetails =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(UserDetails, _NamespaceConsumer);

  function UserDetails() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = UserDetails.prototype;

  _proto.renderRewardPoints = function renderRewardPoints() {
    var props = this.props;

    if (typeof props.rewardPoints !== 'number') {
      return null;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      id: this.namespace('user-details-reward-points'),
      className: this.namespace('reward-points')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.proRewardPoints
    }), ": ", props.rewardPoints);
  };

  _proto.render = function render() {
    var props = this.props;

    if (!props.loggedIn) {
      return null;
    }

    var details = null;

    if (props.preset === 'internal-header') {
      details = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('account-name')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.username
      }), ": ", props.username);
    } else if (props.privateLabelType !== 3) {
      details = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('shopper-id')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.shopperid
      }), ": ", props.shopperId), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('shopper-pin')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.pinLabel
      }), " ", external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({}, props.urls.viewPin, {
        target: "_blank"
      }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.viewPin
      }))));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, details, props.proshopper && this.renderRewardPoints(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedVIP, {
      details: props.vip,
      market: props.market,
      messages: props.messages
    })));
  };

  return UserDetails;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */


account_tray_UserDetails.propTypes = account_tray_objectSpread({}, namespace_component_["NamespaceShape"], {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  vip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  username: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  proshopper: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  proRewardPoints: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number
});
/**
 * Render VIP information if required.
 *
 * @Constructor
 * @class VIP
 * @api public
 */

var account_tray_VIP =
/*#__PURE__*/
function (_NamespaceConsumer2) {
  babelHelpers.inheritsLoose(VIP, _NamespaceConsumer2);

  function VIP() {
    return _NamespaceConsumer2.apply(this, arguments) || this;
  }

  var _proto2 = VIP.prototype;

  _proto2.render = function render() {
    var props = this.props;
    var vip = props.details;

    if (babelHelpers["typeof"](vip) !== 'object') {
      return null;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('shopper-vip')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('shopper-vip-label')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.vip
    }), ":"), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('shopper-vip-details')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, vip.repname), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, vip.phone), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      href: "mailto:".concat(vip.email)
    }, vip.email))));
  };

  return VIP;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @api private
 */


account_tray_VIP.propTypes = account_tray_objectSpread({}, namespace_component_["NamespaceShape"], {
  details: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired
});
/**
 * Render user dropdown menu.
 *
 * @Constructor
 * @class User
 * @api public
 */

var account_tray_User =
/*#__PURE__*/
function (_NamespaceConsumer3) {
  babelHelpers.inheritsLoose(User, _NamespaceConsumer3);

  function User() {
    var _this;

    _this = _NamespaceConsumer3.apply(this, arguments) || this;
    _this.state = _this.state || {};
    _this.state = account_tray_objectSpread({}, _this.state, {
      open: false
    });
    return _this;
  }
  /**
  * Show link for pro dashboard only added if a user is pro
  *
  * @returns {React.Component} Component
  * @api private
  */


  var _proto3 = User.prototype;

  _proto3.renderPro = function renderPro() {
    var props = this.props;

    if (props.loggedIn && props.proshopper) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
        className: this.namespace('customer-link')
      }, props.urls.proHomeApp, {
        "data-eid": src_enums_eids.pro
      }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        tagName: "span",
        id: enums_golf.pro
      }));
    }

    return null;
  }
  /**
   * Show title on the dropdown menu, or show the user's name
   * if user has a name
   *
   * @returns {React.Component} Component
   */
  ;

  _proto3.renderDropdownHeader = function renderDropdownHeader() {
    var props = this.props;

    if (props.loggedIn && props.name) {
      return props.name;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: props.preset === 'internal-header' ? enums_golf.internalModeTitle : enums_golf.title
    });
  }
  /**
  * Show link for products, account, and renewals except
  * for internal header and pl
  *
  * @returns {React.Component} Component
  * @api private
  */
  ;

  _proto3.renderLinks = function renderLinks() {
    var props = this.props;
    if (props.preset === 'internal-header') return null;
    var links = [props.privateLabelId === 1 && props.isInGoCohort && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      className: this.namespace('customer-link'),
      key: "accountHome",
      href: url_namespaceObject.updateQuery(props.urls.accountHome.href, props.urlArgs),
      "data-eid": src_enums_eids.accountHome
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.accountHome
    })), (props.privateLabelType !== 3 || props.resellerUrls && props.resellerUrls.products) && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      className: this.namespace('customer-link'),
      key: "products",
      href: url_namespaceObject.updateQuery(props.urls.products.href, props.urlArgs),
      "data-eid": src_enums_eids.products
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.products
    })), (props.privateLabelType !== 3 || props.resellerUrls && props.resellerUrls.account) && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
      className: this.namespace('customer-link'),
      key: "account"
    }, props.urls.account, {
      "data-eid": src_enums_eids.accountSettings
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.accountSettings
    })), props.privateLabelType !== 3 && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
      className: this.namespace('customer-link'),
      key: "renewals"
    }, props.urls.renewals, {
      "data-eid": src_enums_eids.renewals
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: enums_golf.renewals
    }))].filter(Boolean);

    if (props.privateLabelId === 1) {
      links.push.apply(links, [external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: this.namespace('tray-heading'),
        key: "resourcesHeading"
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.resources
      })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
        className: this.namespace('customer-link'),
        key: "shopGD"
      }, props.urls.home, {
        "data-eid": src_enums_eids.shopGD
      }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.shopGD
      })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({
        className: this.namespace('customer-link'),
        key: "phoneNumbersHours"
      }, props.urls.contactUs, {
        "data-eid": src_enums_eids.phoneNumbersHours
      }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedHTMLMessage"], {
        id: enums_golf.phoneNumbersHours
      }))]);
    }

    return links;
  };

  _proto3.render = function render() {
    var _this2 = this;

    var props = this.props;
    var status = props.loggedIn ? 'logout' : 'login';
    var userIcon = 'app-icon';
    var ariaLabel;

    if (props.loggedIn && props.proshopper) {
      userIcon = 'pro-icon';
      ariaLabel = 'Pro';
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: props.preset === 'internal-header' ? enums_golf.internalModeTitle : enums_golf.title
    }, function (userTray) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(tray_menu, {
        ariaLabel: userTray,
        trayAlignment: "right",
        name: "",
        className: _this2.namespace('customer-menu'),
        showOpenCaret: true,
        traySpanClass: _this2.namespace('app-icon', 'app-icon-user'),
        type: "base",
        fullwidth: false,
        onToggle: function onToggle() {
          _this2.setState({
            open: !_this2.state.open
          });
        }
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: _this2.namespace('customer-info-wrap')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: _this2.namespace('customer-icon-wrap')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        "aria-label": ariaLabel,
        className: _this2.namespace(userIcon, 'app-icon-user')
      })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: _this2.namespace('customer-name')
      }, _this2.renderDropdownHeader()), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: _this2.namespace('customer-details')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedUserDetails, props))), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        key: "accountText",
        className: _this2.namespace('tray-heading')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.account
      })), _this2.renderPro(), _this2.renderLinks(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
        className: _this2.namespace('customer-link', 'login'),
        href: url_namespaceObject.updateQuery(props.urls.sso[status].href, props.sso),
        "data-eid": src_enums_eids[status]
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf[status]
      })));
    }), (props.isMobile || props.isTablet) && this.state.open && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('menu-bg')
    })));
  };

  return User;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */


account_tray_User.propTypes = account_tray_objectSpread({}, namespace_component_["NamespaceShape"], {
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  displayName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  isMobile: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  isTablet: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  proshopper: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  sso: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  version: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
var NamespacedUserDetails = Object(namespace_component_["withNamespace"])(account_tray_UserDetails);
var NamespacedVIP = Object(namespace_component_["withNamespace"])(account_tray_VIP);
var NamespacedUser = Object(namespace_component_["withNamespace"])(account_tray_User);

// CONCATENATED MODULE: ./src/nav-top.js
function nav_top_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function nav_top_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { nav_top_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { nav_top_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/jsx-pascal-case */




 // new endpoint

 // old endpoint










/**
 * Render Version.
 *
 * @class Version
 * @api public
 */

var nav_top_Version =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Version, _NamespaceConsumer);

  function Version() {
    return _NamespaceConsumer.apply(this, arguments) || this;
  }

  var _proto = Version.prototype;

  _proto.render = function render() {
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_React_commonjs_react_commonjs2_react_amd_react_["Fragment"], null, this.props.value);
  };

  return Version;
}(namespace_component_["NamespaceConsumer"]);

nav_top_Version.propTypes = nav_top_objectSpread({}, namespace_component_["NamespaceShape"], {
  value: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
});
var NamespacedVersion = Object(namespace_component_["withNamespace"])(nav_top_Version);
/**
 * Render Application Header Footer.
 *
 * @class NavigationTop
 * @api public
 */

var nav_top_NavigationTop =
/*#__PURE__*/
function (_NamespaceConsumer2) {
  babelHelpers.inheritsLoose(NavigationTop, _NamespaceConsumer2);

  function NavigationTop() {
    return _NamespaceConsumer2.apply(this, arguments) || this;
  }

  var _proto2 = NavigationTop.prototype;

  /**
   * Determine whether to render legacy notifications or the current module
   * @returns {React.element} legacy notifications component or current
   */
  _proto2.renderNotifications = function renderNotifications() {
    var props = this.props;
    var privateLabelId = props.privateLabelId,
        urls = props.urls;
    var notificationMessages = Object.keys(enums_golf.notifications).reduce(function (memo, key) {
      memo[key] = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: enums_golf.notifications[key]
      });
      return memo;
    }, {});

    if (props.notificationsVersion === 2 && props.features.notifsV2) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(notifications_src, babelHelpers["extends"]({
        manifest: props.manifest,
        sso: urls.sso,
        market: props.market,
        shopperId: props.shopperId,
        privateLabelId: privateLabelId,
        messages: notificationMessages,
        tooltip: props.messages[enums_golf.notifications.headerText],
        showCount: false,
        showOpenCaret: true
      }, urls.notifications));
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(notifs_v1_src, babelHelpers["extends"]({
      manifest: props.manifest,
      sso: urls.sso,
      market: props.market,
      shopperId: props.shopperId,
      privateLabelId: privateLabelId,
      messages: notificationMessages,
      tooltip: props.messages[enums_golf.notifications.headerText]
    }, urls.notifications));
  }
  /**
   * Render help, cart, notifications, and account tray. ORDER MATTERS.
   * @returns {[React.element]} Array of components for each global element
   */
  ;

  _proto2.renderGlobalElements = function renderGlobalElements() {
    var _this = this;

    var props = this.props;
    var hasItems = !!props.items;
    var loggedIn = props.loggedIn;
    var isInternal = props.preset === 'internal-header';
    var isPass = props.preset === 'pass-header';
    var elements = [];
    var isApiReseller = props.privateLabelType === 3;

    if (!isInternal && (!isApiReseller || props.resellerUrls && props.resellerUrls.help)) {
      var label = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(icon_default.a, {
        name: "help-header"
      });
      var linkTitle = props.messages[enums_golf.inApp];
      var enUS = props.market.toLowerCase() === 'en-us';

      if (enUS && !props.isMobile && !props.isTablet && props.privateLabelId === 1) {
        var id = enums_golf.goDaddyGuides;
        label = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
          id: id
        });
        linkTitle = props.messages[id];
      }

      elements.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: "help",
        className: this.namespace(this.classNames('nav-item', {
          'godaddy-guides': enUS
        }))
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(inapp_help_src, {
        enabled: props.features.inappHelp,
        url: props.urls.help.href,
        ref: function ref(c) {
          _this.inappHelp = c;
        },
        label: label,
        title: linkTitle,
        tooltip: linkTitle
      })));
    }

    if (hasItems && !isPass && !isApiReseller) {
      elements.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: "cart",
        className: this.namespace(props.className, props.hidden, 'nav-item')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(cart, {
        items: props.items,
        market: props.market,
        messages: props.messages,
        checkout: props.urls.checkout.href,
        className: this.namespace('nav-link', 'nav-link-cart')
      })));
    }

    if (loggedIn && !isPass && !isInternal) {
      elements.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: "notifications",
        className: this.namespace('nav-item')
      }, this.renderNotifications()));
    }

    if (!isPass) {
      elements.push(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
        key: "account-tray",
        className: this.namespace('nav-item')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedUser, props)));
    }

    return elements;
  }
  /**
   * Renders left nav elements: logo, home button, app name.
   * @returns {React.element} The div encompassing left nav elements
   */
  ;

  _proto2.renderLeftNav = function renderLeftNav() {
    var props = this.props;
    var privateLabelId = props.privateLabelId,
        isMobile = props.isMobile,
        isTablet = props.isTablet,
        orderId = props.orderId,
        waffleLeft = props.waffleLeft,
        appName = props.appName,
        app = props.app,
        showWaffleMenu = props.showWaffleMenu,
        messages = props.messages,
        version = props.version;
    var isNotDesktop = isMobile || isTablet;
    var logoClasses = this.namespace(this.classNames('logo-text', {
      'logo-gd': privateLabelId === 1
    }));
    var name = ['riviera', 'mya', 'go', 'account'].indexOf(app) >= 0 ? messages['PC:AppHeader:Header:Home'] : appName;
    var showWaffleLeft = waffleLeft && showWaffleMenu; // Needed for some GD Only css tweaks on mobile and phablet.

    var outsideLogoClasses = this.namespace(this.classNames('logo', {
      'brand-logo': privateLabelId === 1,
      'waffle-left-logo': showWaffleLeft
    }));
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('nav-left-wrap')
    }, orderId && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(order_confirmation_src["default"], {
      orderId: orderId
    }), isNotDesktop && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(nav_set, babelHelpers["extends"]({
      renderMobile: isNotDesktop,
      navigationPosition: "top"
    }, props)), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(_ux_logo, {
      className: outsideLogoClasses,
      country: props.countryName,
      href: props.urls.home.href,
      market: props.market,
      messages: props.messages,
      logos: props.logos,
      privateLabelId: privateLabelId,
      privateLabelName: props.privateLabelName,
      showCountryNameOnLogo: false,
      spanClass: logoClasses,
      urlArgs: props.urlArgs,
      isMobile: isMobile,
      includeGDHead: false,
      "data-eid": "uxp.hyd.app_header.gd_logo.link.click"
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('nav', 'nav-left', {
        'waffle-left-control': showWaffleLeft
      }))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(app_name, babelHelpers["extends"]({}, props, {
      name: name
    }))), showWaffleLeft && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: this.namespace(this.classNames('product-name', 'waffle-menu', {
        'waffle-left-product-name': showWaffleLeft
      }))
    }, name), version && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace(this.classNames('version', 'hidden-sm-down', {
        'waffle-left-version': showWaffleLeft
      }))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(NamespacedVersion, {
      value: props.version
    })));
  };

  _proto2.render = function render() {
    var _this$props = this.props,
        market = _this$props.market,
        messages = _this$props.messages,
        isMobile = _this$props.isMobile,
        isTablet = _this$props.isTablet,
        navigationTop = _this$props.navigationTop; // safari only stuff :(

    var isThisSafari = false;

    if (typeof navigator !== 'undefined') {
      isThisSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: market,
      messages: messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("nav", {
      className: this.namespace(this.classNames('nav-top', 'clearfix', {
        'safari-only': isThisSafari
      }))
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('container')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('d-flex', 'flex-row')
    }, this.renderLeftNav(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("ul", {
      className: this.namespace('nav', 'nav-right')
    }, !isMobile && !isTablet && navigationTop && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: this.namespace('nav-item')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", null, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
      className: this.namespace('custom-link'),
      href: navigationTop.href,
      id: navigationTop.id,
      target: navigationTop.target,
      onClick: navigationTop.onClick,
      "data-eid": navigationTop.eid
    }, navigationTop.caption))), !isMobile && !isTablet && navigationTop && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("li", {
      className: this.namespace('custom-links-divider')
    }), this.renderGlobalElements())))));
  };

  return NavigationTop;
}(namespace_component_["NamespaceConsumer"]);

nav_top_NavigationTop.update = function update(nav) {
  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (Array.isArray(nav) && nav.length === 1) {
    return this.setState({
      navigationTop: nav[0]
    }, done);
  }
};

nav_top_NavigationTop.updateHelpUrl = function updateHelpUrl(helpUrl) {
  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return this.setState({
    helpUrl: helpUrl
  }, done);
};
/**
 * Default properties for the top half of the navigation.
 *
 * @type {Object}
 * @api public
 */


nav_top_NavigationTop.defaultProps = {
  app: 'domainmanager',
  features: {},
  preset: 'application-header',
  loggedIn: false,
  manifest: 'applicationheader',
  market: 'en-US',
  privateLabelId: 1,
  privateLabelName: 'GoDaddy.com',
  proshopper: false,
  urlArgs: {},
  sso: {
    app: 'www',
    path: ''
  },
  urls: {
    notifications: {
      api: {
        href: 'https://mya.dev-godaddy.com/webapi/notifications'
      },
      cache: {
        href: '//img1.wsimg-com.ide/mya/notifications/cache.html'
      },
      endpoint: {
        href: 'https://notifications.api.cloud.dev-godaddy.com/v1/notifications'
      }
    },
    help: {
      href: 'https://www.godaddy.com/help'
    },
    home: {
      href: 'https://www.godaddy.com'
    },
    contactUs: {
      href: 'https://www.godaddy.com/contact-us.aspx'
    },
    checkout: {
      href: 'https://cart.godaddy.com'
    },
    renewals: {
      href: 'https://account.godaddy.com/billing?filter=expires&subFilter=90'
    },
    account: {
      href: 'https://account.godaddy.com'
    },
    products: {
      href: 'https://account.godaddy.com/products'
    },
    pro: {
      href: 'https://pro.godaddy.com/launch/managewp?landingScreen=pro-home'
    },
    proHomeApp: {
      href: 'https://pro.godaddy.com/launch/managewp?landingScreen=pro-home'
    }
  }
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

nav_top_NavigationTop.propTypes = nav_top_objectSpread({}, namespace_component_["NamespaceShape"], {
  account: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  app: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  appName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  displayName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  features: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  help: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  preset: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  isMobile: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  isTablet: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  items: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  loggedIn: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  manifest: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  name: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  navigationTop: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  orderId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  privateLabelName: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  products: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  proshopper: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  shopperId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  showWaffleMenu: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  renewals: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  sso: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  urlArgs: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  version: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  vip: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object
});

/* harmony default export */ var nav_top = (Object(namespace_component_["withNamespace"])(nav_top_NavigationTop));
// CONCATENATED MODULE: ./node_modules/@ux/application-footer/index.js
function application_footer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function application_footer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { application_footer_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { application_footer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





/**
 * Configuration for the GoLF i18n string (and associated EID)
 * of the privacy policy link in this footer component. These
 * are included here (again) so that component can stand alone
 * when reused across multiple header services.
 */

var policy = {
  golf: 'PC:AppHeader:Footer:PrivacyPolicy',
  eid: 'uxp.hyd.int.pc.app_header.footer.privacy_policy.link.click'
};
/**
 * Render Application Header Footer.
 *
 * @class Footer
 * @api public
 */

var application_footer_ApplicationFooter =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(ApplicationFooter, _NamespaceConsumer);

  function ApplicationFooter() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.htmlClassName = _this.namespace('footer-html');
    _this.setHeight = _this.setHeight.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }
  /**
   * Calculate height and add as margin to the bottom.
   *
   * @returns {Footer} fluent interface.
   * @api private
   */


  var _proto = ApplicationFooter.prototype;

  _proto.setHeight = function setHeight() {
    var height = parseInt(window.getComputedStyle(this.element).height, 10) || 0;
    this.body.style.marginBottom = "".concat(height, "px");
    return this;
  }
  /**
   * Add className to the html element to display the footer.
   *
   * @returns {Footer} fluent interface.
   * @api private
   */
  ;

  _proto.addClassName = function addClassName() {
    var html = this.body.parentNode;
    html.className = html.className.split(' ').concat(this.htmlClassName).filter(Boolean).join(' ');
    return this;
  }
  /**
   * Renders the privacy link
   *
   * @param {Object}   props Full set of props for this component
   * @returns {React.Component} a for privacy link
   */
  ;

  _proto.buildPrivacyLink = function buildPrivacyLink(props) {
    // plid=3153 is used when "we do not know" the plid in which case we remove the privacy policy link.
    if (props.privateLabelId === 3153) {
      return;
    }

    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", babelHelpers["extends"]({}, props.urls.privacy, {
      "data-eid": policy.eid
    }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: policy.golf
    }));
  }
  /**
   * Add margin to the bottom of the body on mount and resizes to create space
   * for the absolutely positioned footer.
   *
   * @api private
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.body = document.body;
    this.on('resize', this.setHeight);
    this.addClassName().setHeight();
  }
  /**
   * Remove the resize eventlistener when the component is unmounted.
   *
   * @api private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    var html = this.body.parentNode;
    html.className = html.className.replace(this.htmlClassName, '');
    this.off('resize', this.setHeight);
  };

  _proto.render = function render() {
    var _this2 = this;

    var props = this.props;
    var id = this.namespace('appheader-footer');
    var className = this.namespace('manifest', 'footer');
    var copyright = 'PC:AppHeader:Footer:Copyright';

    if (props.privateLabelId !== 1) {
      copyright += 'PL';
    } // This is a placeholder div that is used for tealium's privacy policy content injection.


    var tealiumPrivacyPlaceholder = external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      id: "gtm_privacy"
    });
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("footer", {
      id: id,
      className: className,
      ref: function ref(c) {
        _this2.element = c;
      }
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      role: "contentinfo",
      className: this.namespace('container')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedHTMLMessage"], {
      id: copyright,
      values: {
        year: props.year
      }
    }), ' '
    /* intentional whitespace, JSX parser limitation */
    , this.buildPrivacyLink(props)), tealiumPrivacyPlaceholder));
  };

  return ApplicationFooter;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Default properties for the Footer. Year is only provided as fallback value
 * and should always be replaced with server time.
 *
 * @type {Object}
 * @api public
 */


application_footer_ApplicationFooter.defaultProps = {
  urls: {
    privacy: {
      href: 'https://www.godaddy.com/agreements/showdoc.aspx?pageid=PRIVACY'
    }
  },
  year: new Date().getFullYear(),
  privateLabelId: 1
};
/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */

application_footer_ApplicationFooter.propTypes = application_footer_objectSpread({}, namespace_component_["NamespaceShape"], {
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  year: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number
});
/* harmony default export */ var application_footer = (Object(namespace_component_["withNamespace"])(application_footer_ApplicationFooter));
// CONCATENATED MODULE: ./node_modules/@ux/abstract-header/index.js




/**
 * Super class for @ux/{sales,application,utility, pass}-headers. This module
 * should not be used directly, but rather extended in order to centralize a
 * lot of the shared business logic among the header.
 */

var abstract_header_AbstractHeader =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(AbstractHeader, _NamespaceConsumer);

  function AbstractHeader(props) {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.events = header_util_events;
    _this.state = {
      cartItems: 0
    }; // Expose a method on ux.eldorado.header to updateCart for passing down
    // to UtilityBar's Cart class as props.items

    _this.updateCart = cart.update.bind(babelHelpers.assertThisInitialized(_this));
    traffic2.init({
      type: props.traffic,
      beacon: true
    });
    _this.customer = _this.createCustomer();
    return _this;
  }
  /**
   * @typedef {typeof Customer} Customer
   */

  /**
   * Returns a valid Customer instance using the props associated
   * with this instance. Derived Headers (e.g. ApplicationHeader, SalesHeader, etc.)
   * should override this method to define custom cookie behavior.
   *
   * @returns {Customer} Customer instance from @ux/header-util.
   */


  var _proto = AbstractHeader.prototype;

  _proto.createCustomer = function createCustomer() {
    return new customer_Customer(this.props);
  }
  /**
   * Returns a value indicating if this instance will display no components
   * which themselves would require authentication (and thus a GUI call).
   * @param  {Object} components This has two distinct upstream locations:
   *   - `@ux/sales-header`:  props.components.utilityBar`.
   *   - `@ux/utility-header`: props.components (read from preset.components).
   * @returns {Boolean} Returns true if no auth data is required.
   */
  ;

  _proto.isUnauthenticated = function isUnauthenticated(components) {
    components = components || {};
    return !(components.accountDelegation || components.notifications || components.accountTray || components.cart || components.contactTray); // Federated partner info requires GUI call
  };

  _proto.getWindowLocation = function getWindowLocation() {
    return window.location.href;
  }
  /**
   * Read in cookie Data for OrderConfirmation
   */
  ;

  _proto.getOrderDetails = function getOrderDetails() {
    var orderId = new util_["URL"](this.getWindowLocation(), true).query.orderId;

    if (orderId) {
      this.setState({
        orderId: orderId
      });
    }
  }
  /**
   * Returns a shallow copy of any state set by the GUI call in
   * this.getCustomerDetails() for ease-of-access.
   * @returns {Object} All state we set from our GUI call for the customer.
   */
  ;

  _proto.getCustomerState = function getCustomerState() {
    var _this$state = this.state,
        state = _this$state === void 0 ? {} : _this$state;
    return {
      displayName: state.displayName,
      federatedPartner: state.federatedPartner,
      items: state.items,
      isInGoCohort: state.isInGoCohort,
      isPro: state.isPro,
      loggedIn: state.loggedIn,
      name: state.name,
      proshopper: state.proshopper,
      rewardPoints: state.rewardPoints,
      shopperId: state.shopperId,
      username: state.username,
      vip: state.vip
    };
  }
  /**
   * Get customer details.
   *
   * @param {Function} [done] Completion callback.
   * @api private
   */
  ;

  _proto.getCustomerDetails = function getCustomerDetails(done) {
    var _this2 = this;

    // Start with data from the existing cookie
    this.customer.updateFromCookie();

    if (typeof done !== 'function') {
      done = function done() {};
    }

    if (this.state.unauthenticated) {
      // No components visible that use customer data, so we can skip the GUI call
      shopperDataLoader.configureOnly({
        url: this.props.urls.gui.href,
        privateLabelId: this.props.privateLabelId,
        shopperId: this.customer.shopperId
      });
      done();
      return;
    } // Next, try to fetch fresh data from the server


    this.customer.fetch({
      gui: this.props.urls.gui.href
    }, function (error) {
      if (error) {
        var doneWithError = function doneWithError() {
          header_util_events.emit('error', error);
          done(error);
        }; // We still have some data from the cookie, so just fall back to that.
        // We use the presence of a shopper ID as a weak proxy to login state.
        // This won't actually unlock any real actions -- just tells the header to act
        // like the user is logged in. If they are not really logged in, they'll get
        // sent to SSO when they try to do anything that requires login.


        if (_this2.customer.shopperId) {
          _this2.setState({
            displayName: _this2.customer.displayName(true),
            federatedPartner: _this2.customer.get('federatedPartner'),
            name: _this2.customer.displayName(),
            shopperId: _this2.customer.shopperId,
            loggedIn: true
          }, doneWithError);
        } else {
          doneWithError();
        }

        return;
      }

      var proUser = _this2.customer.get('proshopper');

      var proshopper = proUser && proUser.status === 1;
      var rewardPoints = proshopper ? proUser.rewardPoints : null;

      var tmsData = _this2.customer.get('tms');

      var isInGoCohort = tmsData && tmsData.some(function (split) {
        return split.Name === 'wsb_vnext';
      });

      _this2.setState({
        displayName: _this2.customer.displayName(true),
        federatedPartner: _this2.customer.get('federatedPartner'),
        items: _this2.customer.cart,
        isInGoCohort: isInGoCohort,
        isPro: proshopper,
        loggedIn: _this2.customer.loggedIn,
        name: _this2.customer.displayName(),
        proshopper: proshopper,
        rewardPoints: rewardPoints,
        shopperId: _this2.customer.shopperId,
        username: _this2.customer.get('loginName'),
        vip: _this2.customer.vip
      }, done);
    }, false);
  }
  /**
   * Query Traffic for the variant result of a given experiment and pipe the result to React state
   * @param {Object} opt Options
   * @param {String} opt.expId The experiment ID
   * @param {Object} [opt.attributes] An optional object to to pass along attributes
   * for Traffic/Split.io to calculate the variant ID. If none pass {}
   * @param {String} opt.stateFieldName The name of the React state field to store the result in
   * @param {StateValueTransformerFn} [opt.stateValueTransformer] An optional function to transform a variant ID into a state
   *   value. If omitted, the state field will contain the variant ID itself
   * @example <caption>Sets the state value to a boolean based on if the variant ID is 'B'</caption>
   * pipeExpVariantToState({'my_experiment', { 'market-id': 'en-US' }, 'myExperiment', variantId => variantId === 'B'}, done)
   * @param {Function} [done] Callback function
   *
   * @callback StateValueTransformerFn
   * @param {String} variantId The variant identifier to transform
   *
   */
  ;

  _proto.pipeExpVariantToState = function pipeExpVariantToState(_ref, done) {
    var _this3 = this;

    var expId = _ref.expId,
        _ref$attributes = _ref.attributes,
        attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
        stateFieldName = _ref.stateFieldName,
        _ref$stateValueTransf = _ref.stateValueTransformer,
        stateValueTransformer = _ref$stateValueTransf === void 0 ? function (variantId) {
      return variantId;
    } : _ref$stateValueTransf;
    // During server-rendering, we don't want to access `window`
    if (typeof window === 'undefined') return;
    var expDataLayer = window._expDataLayer = window._expDataLayer || [];

    var pipeVariantToState = function pipeVariantToState(variantId) {
      _this3.setState(babelHelpers.defineProperty({}, stateFieldName, stateValueTransformer(variantId)), done);
    };

    expDataLayer.push({
      schema: 'get_variant_for_experiment',
      version: 'v1',
      data: {
        experiment_id: expId,
        callback: pipeVariantToState,
        attributes: attributes
      }
    });
  }
  /**
   * Notify listeners the header is mounted and expose the instance.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.events.emit('mount', 'header', this);
    this.events.emit('mount:header', this);
    this.getCustomerDetails();
    this.getOrderDetails();
  }
  /**
   * Notify header was updated.
   */
  ;

  _proto.componentDidUpdate = function componentDidUpdate() {
    header_util_events.emit('update:header', this);
  }
  /**
   * Needed to prevent enzyme from complaining about
   * missing inst.render method
   * @returns {undefined}
   */
  ;

  _proto.render = function render() {
    return null;
  };

  return AbstractHeader;
}(namespace_component_["NamespaceConsumer"]);


// EXTERNAL MODULE: ./node_modules/bowser/src/bowser.js
var bowser = __webpack_require__("./node_modules/bowser/src/bowser.js");

// CONCATENATED MODULE: ./node_modules/@ux/browser-deprecation-banner/src/enums.js
var browsers = ['Safari', 'Edge', 'Firefox', 'Chrome'];
var src_enums_breakpoints = ['mobile', 'phablet'];

// CONCATENATED MODULE: ./node_modules/@ux/browser-deprecation-banner/src/index.js
function browser_deprecation_banner_src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function browser_deprecation_banner_src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { browser_deprecation_banner_src_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { browser_deprecation_banner_src_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/**
 * A Banner to be displayed if your browser is too old.
 * @type {BrowserDeprecationBanner}
 */

var src_BrowserDeprecationBanner =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(BrowserDeprecationBanner, _NamespaceConsumer);

  function BrowserDeprecationBanner() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.dismiss = _this.dismiss.bind(babelHelpers.assertThisInitialized(_this));
    var info;

    if ((typeof navigator === "undefined" ? "undefined" : babelHelpers["typeof"](navigator)) !== 'object') {
      // pretend to be something we support on server side
      // so we don't briefly flash the banner on supported Browsers
      info = {
        name: 'Chrome',
        version: '99999999999',
        mac: false
      };
    } else {
      info = bowser["detect"](navigator.userAgent);
    }

    var _info = info,
        name = _info.name,
        version = _info.version,
        mac = _info.mac;
    _this.state = {
      mac: !!mac,
      name: name,
      version: version,
      dismissed: false
    };
    return _this;
  }
  /**
   * Handle a user clicking the X to permanently dismiss this
   * banner. The "permanence" lasts as long as cookie lasts.
   */


  var _proto = BrowserDeprecationBanner.prototype;

  _proto.dismiss = function dismiss() {
    util_["cookie"].set('_dismissedBDF', 'true');
    this.setState({
      dismissed: true
    });
  }
  /**
   * set breakpoint behavior
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.breakpoint.apply(this, babelHelpers.toConsumableArray(src_enums_breakpoints));
  }
  /**
   * Whether or not we recognize this browser. If we do not recognize it,
   * we should not make a decision on whether or not to show this banner.
   * @param {String} browser that is being recognized
   * @returns {String} name of browser that is recognized, otherwise ''
   */
  ;

  _proto.recognizedBrowser = function recognizedBrowser(browser) {
    var supportMatrix = this.props.supportMatrix;
    var matched = Object.keys(supportMatrix).filter(function (b) {
      return browser.match(b);
    });
    return matched.length > 0 ? matched[0] : '';
  }
  /**
   * Whether the whitelist provided contains the current useragent
   * @returns {Boolean} true if the useragent whitelist contains the current browser
   */
  ;

  /**
   * Whether the blacklist provided contains the browser in question
   * @param {String} browserName that is being tested
   * @param {String} browserVersion of the browser to check
   * @returns {Boolean} true if the blacklist contains the browser and version specified
   */
  _proto.browserIsBlacklisted = function browserIsBlacklisted(browserName, browserVersion) {
    var blacklistedBrowsers = this.props.blacklistedBrowsers;
    return blacklistedBrowsers.some(function (_ref) {
      var browser = _ref.browser,
          version = _ref.version;
      return browser === browserName && version === browserVersion;
    });
  }
  /**
   * Whether the version is at or below the supported matrix threshold
   * @param {String} browserName that is being tested
   * @param {String} browserVersion of the browser to check
   * @returns {Boolean} true if the browser is at or below the threshold
   */
  ;

  _proto.isUnsupportedBrowser = function isUnsupportedBrowser(browserName, browserVersion) {
    var supportMatrix = this.props.supportMatrix;
    var unsupportedBrowser = false;

    if (supportMatrix && browserName) {
      var newestWithBanner = supportMatrix[browserName][0];

      if (newestWithBanner !== null) {
        unsupportedBrowser = parseFloat(browserVersion) > parseFloat(newestWithBanner);
      } else {
        unsupportedBrowser = true;
      }
    }

    return unsupportedBrowser;
  }
  /**
   * Determines if the banner should NOT be rendered
   * @returns {Boolean} Whether or not the banner should be shown for the current browser
   */
  ;

  _proto.shouldNotShowbanner = function shouldNotShowbanner() {
    if (this.userAgentIsWhitelisted) {
      return true;
    }

    var _this$state = this.state,
        name = _this$state.name,
        version = _this$state.version,
        dismissed = _this$state.dismissed;
    var _this$props = this.props,
        supportMatrix = _this$props.supportMatrix,
        disableDeprecationBanner = _this$props.disableDeprecationBanner;

    if (disableDeprecationBanner || dismissed || !supportMatrix || util_["cookie"].get && util_["cookie"].get('_dismissedBDF')) {
      return true;
    }

    var browser = this.recognizedBrowser(name);

    if (!browser || typeof version === 'undefined') {
      return true;
    }

    if (this.browserIsBlacklisted(browser, parseFloat(version))) {
      return false;
    }

    return this.isUnsupportedBrowser(browser, parseFloat(version));
  }
  /**
   * Given that the current browser is supported, render the docs
   * @returns {[ReactElement]} 3 <span> tags that contain recommendations to download
   * Firefox, Chrome, or (Safari/Edge) depending on their OS
   */
  ;

  _proto.renderBrowsers = function renderBrowsers() {
    var _this2 = this;

    var _this$state2 = this.state,
        mac = _this$state2.mac,
        name = _this$state2.name;
    var messages = this.props.messages;
    var filtered = browsers.filter(function (b) {
      return b !== (mac ? 'Edge' : 'Safari');
    }).sort(function (a) {
      return a !== name;
    });
    var get = 'Shared:BrowserDeprecationBanner:GetBrowser';
    var update = 'Shared:BrowserDeprecationBanner:UpdateBrowser';
    return filtered.map(function (browser) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: _this2.namespace('browser-info'),
        key: "name-".concat(browser)
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("a", {
        href: messages["Shared:BrowserDeprecationBanner:Download".concat(browser)]
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: _this2.namespace('browser-text')
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
        id: browser === name ? update : get,
        values: {
          browser: browser
        }
      })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
        className: _this2.namespace('browser-icon', browser.toLowerCase())
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("img", {
        alt: browser,
        src: "https://img1.wsimg.com/wrhs-assets/browser-deprecation-warning/".concat(browser, ".png")
      }))));
    });
  };

  _proto.render = function render() {
    if (this.shouldNotShowbanner()) {
      return null;
    }

    var props = this.props;
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["IntlProvider"], {
      locale: props.market,
      messages: props.messages
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("header", {
      role: "banner"
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('row', 'browser-deprecation-banner')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("button", {
      tabIndex: "0",
      onClick: this.dismiss
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("span", {
      className: "uxicon uxicon-x"
    })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: "col-xs-12 col-md-5"
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", {
      className: this.namespace('ageism')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:BrowserDeprecationBanner:HoldingUsBack"
    })), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("p", {
      className: this.namespace('update')
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(external_root_ux_intl_commonjs_react_intl_default_commonjs2_react_intl_default_amd_react_intl_["FormattedMessage"], {
      id: "Shared:BrowserDeprecationBanner:LatestVersion"
    }))), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
      className: this.namespace('col-xs-12', 'col-md-7', 'browsers-container')
    }, this.renderBrowsers()))));
  };

  babelHelpers.createClass(BrowserDeprecationBanner, [{
    key: "userAgentIsWhitelisted",
    get: function get() {
      var whitelistedUserAgents = this.props.whitelistedUserAgents;

      if ((typeof navigator === "undefined" ? "undefined" : babelHelpers["typeof"](navigator)) === 'object' && navigator.userAgent && whitelistedUserAgents) {
        return whitelistedUserAgents.some(function (ua) {
          return !!navigator.userAgent.match(ua);
        });
      }

      return false;
    }
  }]);
  return BrowserDeprecationBanner;
}(namespace_component_["NamespaceConsumer"]);
/**
 * Allowed browser deprecation values.
 *
 * @enum {Object}
 * @api public
 */


src_BrowserDeprecationBanner.propTypes = browser_deprecation_banner_src_objectSpread({}, namespace_component_["NamespaceShape"], {
  messages: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  supportMatrix: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  whitelistedUserAgents: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.array,
  disableDeprecationBanner: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  blacklistedBrowsers: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.arrayOf(external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.shape({
    browser: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
    version: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number
  }))
});
src_BrowserDeprecationBanner.defaultProps = {
  disableDeprecationBanner: false,
  blacklistedBrowsers: []
};
/* harmony default export */ var browser_deprecation_banner_src = (Object(namespace_component_["withNamespace"])(src_BrowserDeprecationBanner));
// CONCATENATED MODULE: ./src/header.js
function header_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function header_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { header_ownKeys(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { header_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var header_Header =
/*#__PURE__*/
function (_NamespaceConsumer) {
  babelHelpers.inheritsLoose(Header, _NamespaceConsumer);

  function Header() {
    var _this;

    _this = _NamespaceConsumer.apply(this, arguments) || this;
    _this.state = header_objectSpread({}, _this.state, {
      mobileMenuOpen: false
    });
    _this.toggleMobileMenu = _this.toggleMobileMenu.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }
  /**
   * Add eventListeners for breakpoints.
   *
   * @api private
   */


  var _proto = Header.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.breakpoint.apply(this, babelHelpers.toConsumableArray(enums_breakpoints));
  }
  /**
   * Remove the eventListeners of breakpoints.
   *
   * @api private
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.breakup();
  }
  /**
   * Function to set state indicating if mobile menu is open or not
   * @param  {boolean} open The open state of the mobile menu
   */
  ;

  _proto.toggleMobileMenu = function toggleMobileMenu(open) {
    this.setState({
      mobileMenuOpen: open
    });
  };

  _proto.render = function render() {
    var props = this.props;
    var splitClassName = props.split || '';
    var isDesktop = !~['mobile', 'phablet', 'tablet'].indexOf(this.state.breakpoint);
    var showWaffleMenu = false;

    if (props.preset === 'application-header' && props.privateLabelId === 1) {
      if (['help', 'community', 'system-status'].indexOf(props.app) === -1) {
        // the help app is the only app with a logged-out state for app-header
        // if the app is not help, we dont have to check for loggedin and
        // can render server side to avoid flashing
        showWaffleMenu = true;
      } else if (props.loggedIn) {
        showWaffleMenu = true;
      }
    }

    var classNames = this.namespace(this.classNames('manifest', {
      'mobile-nav-open': this.state.mobileMenuOpen,
      'pl': props.privateLabelId !== 1,
      splitClassName: splitClassName
    }));
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("header", {
      className: classNames
    }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(nav_top, babelHelpers["extends"]({}, props, {
      showWaffleMenu: showWaffleMenu,
      isMobile: this.isMobile,
      isTablet: this.state.breakpoint === 'tablet'
    })), isDesktop && external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(nav_bottom, babelHelpers["extends"]({}, props, {
      onClick: this.toggleMobileMenu
    })));
  };

  return Header;
}(namespace_component_["NamespaceConsumer"]);

header_Header.propTypes = header_objectSpread({}, namespace_component_["NamespaceShape"], {
  accountHomeButton: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  features: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  mobileSEO: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool,
  preset: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  showWaffleMenu: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.bool
});
/* harmony default export */ var src_header = (Object(namespace_component_["withNamespace"])(header_Header));
// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("./node_modules/object-assign/index.js");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return src_Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return src_Footer; });
function src_ownKeys_0(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_objectSpread_0(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_ownKeys_0(source, true).forEach(function (key) { babelHelpers.defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_ownKeys_0(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/**
 * Return a namespace if the environment variable is set, 'polyfilled' by WebPack.
 *
 * @returns {Object} Configured namespace.
 * @api private
 */

function src_namespace() {
  return {
    namespace: "" // eslint-disable-line no-process-env

  };
}
/**
 * Render and expose the Header as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Header.
 * @api public
 */


var src_Header =
/*#__PURE__*/
function (_AbstractHeader) {
  babelHelpers.inheritsLoose(Header, _AbstractHeader);

  function Header() {
    var _this;

    _this = _AbstractHeader.apply(this, arguments) || this;
    _this.state = src_objectSpread_0({}, _this.state);
    _this.updateNavigation = nav_bottom.update.bind(babelHelpers.assertThisInitialized(_this));
    _this.updateTopNavigation = nav_top.update.bind(babelHelpers.assertThisInitialized(_this));
    _this.updateHelpUrl = nav_top.updateHelpUrl.bind(babelHelpers.assertThisInitialized(_this));
    return _this;
  }
  /**
   * Returns a valid Customer instance using the props associated
   * with this instance. If `internalMode` is `true` returns an `Employee`.
   *
   * @returns {User} Customer or Employee instance from @ux/header-util.
   */


  var _proto = Header.prototype;

  _proto.createCustomer = function createCustomer() {
    var props = this.props; // Override customer if internal mode

    if (props.preset === 'internal-header') {
      return new Employee(props);
    }

    return new customer_Customer(props);
  }
  /**
   * Prefer state over props when assigning to children
   *
   * @returns {Object} Child props
   * @api private
   */
  ;

  _proto.getChildProps = function getChildProps() {
    var helpUrl = this.state.helpUrl;
    var childProps = object_assign_default()({}, this.props, this.state);
    if (helpUrl) childProps.urls.help.href = helpUrl;
    return childProps;
  };

  _proto.render = function render() {
    var _this2 = this;

    var childProps = this.getChildProps();
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceProvider"], src_namespace(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceContext"].Consumer, null, function (context) {
      return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement("div", {
        className: context.namespace(_this2.classNames({
          loaded: _this2.isBrowser
        }))
      }, external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(browser_deprecation_banner_src, childProps), childProps.preset === 'internal-header' ? null : external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src, {
        market: childProps.market,
        messages: childProps.messages,
        action: childProps.urls.sso.exitDelegation.href,
        restoreCookie: childProps.urls.sso.restoreCookie.href,
        customer: _this2.customer
      }), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(src_header, childProps));
    }));
  };

  return Header;
}(abstract_header_AbstractHeader);

src_Header.propTypes = {
  market: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string.isRequired,
  urls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object.isRequired,
  resellerUrls: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.object,
  privateLabelType: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  privateLabelId: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.number,
  preset: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string,
  traffic: external_root_PropTypes_commonjs_prop_types_commonjs2_prop_types_amd_prop_types_default.a.string
};
src_Header.defaultProps = {
  preset: 'application-header'
};
/**
 * Render and expose the Footer as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Footer.
 * @api public
 */

var src_Footer =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto2 = Footer.prototype;

  _proto2.componentDidMount = function componentDidMount() {
    header_util_events.emit('mount', 'footer', this);
    header_util_events.emit('mount:footer', this);
  };

  _proto2.render = function render() {
    return external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(namespace_component_["NamespaceProvider"], src_namespace(), external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.createElement(application_footer, this.props));
  };

  return Footer;
}(external_root_React_commonjs_react_commonjs2_react_amd_react_default.a.Component);



/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /tmp/carpenterd-worker/@ux-application-header-test-13.7.0-en-US/86e53474-3a86-49ee-98ac-458d2a98290c/86e53474-3a86-49ee-98ac-458d2a98290c/src/index.js */"./src/index.js");


/***/ }),

/***/ "@ux/button":
/*!*************************************************************************************************************************************!*\
  !*** external {"root":["ux","Button"],"commonjs":["@ux/button","default"],"commonjs2":["@ux/button","default"],"amd":"@ux/button"} ***!
  \*************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_button__;

/***/ }),

/***/ "@ux/component":
/*!*************************************************************************************************************************************************!*\
  !*** external {"root":["ux","Component"],"commonjs":["@ux/component","default"],"commonjs2":["@ux/component","default"],"amd":"@ux/component"} ***!
  \*************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_component__;

/***/ }),

/***/ "@ux/growl":
/*!*********************************************************************************************************************************!*\
  !*** external {"root":["ux","Growl"],"commonjs":["@ux/growl","default"],"commonjs2":["@ux/growl","default"],"amd":"@ux/growl"} ***!
  \*********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_growl__;

/***/ }),

/***/ "@ux/icon":
/*!*****************************************************************************************************************************!*\
  !*** external {"root":["ux","Icon"],"commonjs":["@ux/icon","default"],"commonjs2":["@ux/icon","default"],"amd":"@ux/icon"} ***!
  \*****************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_icon__;

/***/ }),

/***/ "@ux/modal":
/*!*********************************************************************************************************************************!*\
  !*** external {"root":["ux","Modal"],"commonjs":["@ux/modal","default"],"commonjs2":["@ux/modal","default"],"amd":"@ux/modal"} ***!
  \*********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_modal__;

/***/ }),

/***/ "@ux/namespace-component":
/*!****************************************************************************************************************************************************************************************!*\
  !*** external {"root":["ux","NamespaceComponent"],"commonjs":["@ux/namespace-component","default"],"commonjs2":["@ux/namespace-component","default"],"amd":"@ux/namespace-component"} ***!
  \****************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_namespace_component__;

/***/ }),

/***/ "@ux/spinner":
/*!*****************************************************************************************************************************************!*\
  !*** external {"root":["ux","Spinner"],"commonjs":["@ux/spinner","default"],"commonjs2":["@ux/spinner","default"],"amd":"@ux/spinner"} ***!
  \*****************************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_spinner__;

/***/ }),

/***/ "@ux/util":
/*!******************************************************************************************************************************!*\
  !*** external {"root":["ux","utils"],"commonjs":["@ux/util","default"],"commonjs2":["@ux/util","default"],"amd":"@ux/util"} ***!
  \******************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__ux_util__;

/***/ }),

/***/ "prop-types":
/*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"} ***!
  \*********************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"} ***!
  \**************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-dom":
/*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"} ***!
  \*****************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

/***/ }),

/***/ "react-intl":
/*!***********************************************************************************************************************************!*\
  !*** external {"root":["ux","intl"],"commonjs":["react-intl","default"],"commonjs2":["react-intl","default"],"amd":"react-intl"} ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_intl__;

/***/ }),

/***/ "react-trfq":
/*!***********************************************************************************************************************************!*\
  !*** external {"root":["ux","trfq"],"commonjs":["react-trfq","default"],"commonjs2":["react-trfq","default"],"amd":"react-trfq"} ***!
  \***********************************************************************************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_trfq__;

/***/ })

/******/ });
});